export const houseData = [
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/58c47055abc393e679740bf8d3dc01b9l-m520835009s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T22:30:05Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "dining_room",
            "forced_air",
            "basement",
            "single_story",
            "garage_1_or_more",
            "garage_2_or_more",
            "rental_property",
            "farm",
            "ranch",
            "fixer_upper"
        ],
        "permalink": "15410-Snowden-St_Detroit_MI_48227_M39982-07682",
        "status": "for_sale",
        "list_date": "2022-10-22T02:33:11Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "27E920D9F8CCC6E5312557CB14800F67"
        },
        "branding": [
            {
                "name": "CENTURY 21 Curran & Oberski",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/58c47055abc393e679740bf8d3dc01b9l-m520835009s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/58c47055abc393e679740bf8d3dc01b9l-m3431702883s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 35000,
        "matterport": false,
        "property_id": "3998207682",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "core.broker",
                "co_broke"
            ],
            "brand_name": "essentials"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1924,
            "baths_3qtr": null,
            "sold_date": "2014-12-17",
            "sold_price": 4000,
            "baths_full": 1,
            "name": null,
            "baths_half": 1,
            "lot_sqft": 3920,
            "sqft": 640,
            "baths": 2,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 2,
            "stories": 1,
            "beds": 2,
            "type": "single_family"
        },
        "listing_id": "2949156949",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48227",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.176739,
                    "lat": 42.404183
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "15410 Snowden St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=15410%20Snowden%20St%2C%20Detroit%2C%20MI%2048227&size=640x480&source=outdoor&signature=UIuhg6qz4gFdiOZ8VhgbM0FPXYM=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949156949",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                },
                {
                    "listing_id": "2472012628",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "2912678271",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "598047685",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "572858097",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/cf3f3dd83adba842111dff8efdc71270l-m3476240515s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T20:11:04Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "dining_room",
            "fireplace",
            "forced_air",
            "basement",
            "two_or_more_stories"
        ],
        "permalink": "10037-Littlefield-St_Detroit_MI_48227_M39872-88760",
        "status": "for_sale",
        "list_date": "2022-10-22T00:11:29Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "5A99C9ABFF8A42CD93A0F0918B3EAFF6"
        },
        "branding": [
            {
                "name": "Keller Williams Realty-Great Lakes",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/cf3f3dd83adba842111dff8efdc71270l-m3476240515s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/cf3f3dd83adba842111dff8efdc71270l-m1893136205s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 85000,
        "matterport": false,
        "property_id": "3987288760",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "core.broker",
                "co_broke"
            ],
            "brand_name": "essentials"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1942,
            "baths_3qtr": null,
            "sold_date": null,
            "sold_price": null,
            "baths_full": 1,
            "name": null,
            "baths_half": null,
            "lot_sqft": 5227,
            "sqft": 1089,
            "baths": 1,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": null,
            "stories": 2,
            "beds": 3,
            "type": "single_family"
        },
        "listing_id": "2949152814",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48227",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.175792,
                    "lat": 42.370334
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "10037 Littlefield St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=10037%20Littlefield%20St%2C%20Detroit%2C%20MI%2048227&size=640x480&source=outdoor&signature=rO8XvRavkXO_2EGZveyk8TB6uBM=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949152814",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                },
                {
                    "listing_id": "2948698666",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "2918205264",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "2519682887",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "615700305",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "540353977",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "540319029",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "523707313",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/18a41dc5527d70bdd7c9f676fc8afc44l-m61416215s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T19:44:04Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "central_air",
            "dining_room",
            "forced_air",
            "basement",
            "two_or_more_stories",
            "garage_1_or_more",
            "garage_2_or_more",
            "open_floor_plan",
            "floor_plan",
            "open_house",
            "new_roof"
        ],
        "permalink": "282-Lakewood-St_Detroit_MI_48215_M42205-41369",
        "status": "for_sale",
        "list_date": "2022-10-21T23:44:35Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "F4B064F6E26A6ADDCB5C649C40C3090A"
        },
        "branding": [
            {
                "name": "KW Advantage",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/18a41dc5527d70bdd7c9f676fc8afc44l-m61416215s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/18a41dc5527d70bdd7c9f676fc8afc44l-m4215858441s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-22",
        "list_price": 279900,
        "matterport": false,
        "property_id": "4220541369",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": true,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "core.broker",
                "co_broke"
            ],
            "brand_name": "essentials"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1930,
            "baths_3qtr": null,
            "sold_date": "2022-09-23",
            "sold_price": 117000,
            "baths_full": 2,
            "name": null,
            "baths_half": null,
            "lot_sqft": 5663,
            "sqft": 1737,
            "baths": 2,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 2,
            "stories": 2,
            "beds": 4,
            "type": "single_family"
        },
        "listing_id": "2949152104",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48215",
                "state": "Michigan",
                "coordinate": {
                    "lon": -82.93871,
                    "lat": 42.36232
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "282 Lakewood St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=282%20Lakewood%20St%2C%20Detroit%2C%20MI%2048215&size=640x480&source=outdoor&signature=iXyTFeDUbstKj9gNCCrtIP18nMM=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949152104",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/9a9fe215d33f8a29458fe68a2ada55acl-m1137384333s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T18:49:04Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "basement",
            "two_or_more_stories",
            "garage_1_or_more",
            "garage_2_or_more",
            "shopping"
        ],
        "permalink": "13464-Gallagher-St_Detroit_MI_48212_M44459-41716",
        "status": "for_sale",
        "list_date": "2022-10-21T22:50:50Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "901D50C39155CB172E6CF8A42925A898"
        },
        "branding": [
            {
                "name": "Amin Realty",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/9a9fe215d33f8a29458fe68a2ada55acl-m1137384333s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/9a9fe215d33f8a29458fe68a2ada55acl-m694372729s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 84900,
        "matterport": false,
        "property_id": "4445941716",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "co_broke"
            ],
            "brand_name": "basic_opt_in"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1920,
            "baths_3qtr": null,
            "sold_date": null,
            "sold_price": null,
            "baths_full": 1,
            "name": null,
            "baths_half": null,
            "lot_sqft": 3049,
            "sqft": 1779,
            "baths": 1,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 2,
            "stories": 2,
            "beds": 3,
            "type": "single_family"
        },
        "listing_id": "2949150906",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48212",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.06509,
                    "lat": 42.415283
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "13464 Gallagher St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=13464%20Gallagher%20St%2C%20Detroit%2C%20MI%2048212&size=640x480&source=outdoor&signature=0XPfKx58UENItpv0zSDSXuBA7g0=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949150906",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                },
                {
                    "listing_id": "2942744131",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/1aad9ace8082c5a31aa9b08ff0ad2609l-m1650582221s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T17:38:05Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "forced_air",
            "basement",
            "two_or_more_stories",
            "garage_1_or_more",
            "garage_2_or_more",
            "fenced_yard"
        ],
        "permalink": "16485-Rossini-Dr_Detroit_MI_48205_M40574-71383",
        "status": "for_sale",
        "list_date": "2022-10-21T21:38:43Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "5DF249C7CDA5F7A57A262EFF5B26187F"
        },
        "branding": [
            {
                "name": "EXP Realty, LLC",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/1aad9ace8082c5a31aa9b08ff0ad2609l-m1650582221s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/1aad9ace8082c5a31aa9b08ff0ad2609l-m449801330s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 59900,
        "matterport": false,
        "property_id": "4057471383",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "core.broker",
                "co_broke"
            ],
            "brand_name": "essentials"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1942,
            "baths_3qtr": null,
            "sold_date": "2013-05-23",
            "sold_price": 12025,
            "baths_full": 1,
            "name": null,
            "baths_half": null,
            "lot_sqft": 5227,
            "sqft": 916,
            "baths": 1,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 2,
            "stories": 2,
            "beds": 3,
            "type": "single_family"
        },
        "listing_id": "2949148289",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48205",
                "state": "Michigan",
                "coordinate": {
                    "lon": -82.949454,
                    "lat": 42.444183
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "16485 Rossini Dr"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=16485%20Rossini%20Dr%2C%20Detroit%2C%20MI%2048205&size=640x480&source=outdoor&signature=9YxlML0gcsaK-4aafc1yTwPd9qU=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949148289",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                },
                {
                    "listing_id": "2936942357",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "2936195029",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "592848109",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "587112425",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "571537801",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "553179385",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "547939269",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/a8c6530f6781ba1324ef3b5e309d7520l-m4278721866s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T17:24:07Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                },
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "dining_room",
            "family_room",
            "basement",
            "two_or_more_stories",
            "garage_1_or_more",
            "updated_kitchen",
            "park",
            "shopping"
        ],
        "permalink": "19178-San-Juan-Dr_Detroit_MI_48221_M38809-27389",
        "status": "for_sale",
        "list_date": "2022-10-21T21:17:29Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "15640D6A9D239AA50B3ECD275EC29E37"
        },
        "branding": [
            {
                "name": "RE/MAX Team 2000",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/a8c6530f6781ba1324ef3b5e309d7520l-m4278721866s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/a8c6530f6781ba1324ef3b5e309d7520l-m2083437514s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 144950,
        "matterport": false,
        "property_id": "3880927389",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": true,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "co_broke"
            ],
            "brand_name": "basic_opt_in"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1930,
            "baths_3qtr": null,
            "sold_date": "2011-03-23",
            "sold_price": 10130,
            "baths_full": 1,
            "name": null,
            "baths_half": 1,
            "lot_sqft": 4356,
            "sqft": 1638,
            "baths": 2,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 1,
            "stories": 2,
            "beds": 3,
            "type": "single_family"
        },
        "listing_id": "2949147668",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48221",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.14665,
                    "lat": 42.432706
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "19178 San Juan Dr"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=19178%20San%20Juan%20Dr%2C%20Detroit%2C%20MI%2048221&size=640x480&source=outdoor&signature=t9EFFldgpbV2JUnE2XmWO4dQn-E=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949147668",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                },
                {
                    "listing_id": "2944201897",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "518426865",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/2bc24538efe77aeba85e6b596286806dl-m4001923285s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T17:12:05Z",
        "source": {
            "agents": [
                {
                    "office_name": "Tyraa Nicole Properties LLC"
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "forced_air",
            "basement",
            "single_story",
            "garage_1_or_more",
            "farm",
            "ranch"
        ],
        "permalink": "18900-Alstead-St_Grosse-Pointe-Woods_MI_48236_M49746-08972",
        "status": "for_sale",
        "list_date": "2022-10-21T21:14:33Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "379E1801A627409F8DB31D5D7B53E48A"
        },
        "branding": [
            {
                "name": "Tyraa Nicole Properties Llc",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/2bc24538efe77aeba85e6b596286806dl-m4001923285s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/2bc24538efe77aeba85e6b596286806dl-m685979701s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 129900,
        "matterport": false,
        "property_id": "4974608972",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "co_broke"
            ],
            "brand_name": "basic_opt_in"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1953,
            "baths_3qtr": null,
            "sold_date": "2001-01-18",
            "sold_price": 98000,
            "baths_full": 1,
            "name": null,
            "baths_half": null,
            "lot_sqft": 4356,
            "sqft": 1039,
            "baths": 1,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 1,
            "stories": 1,
            "beds": 3,
            "type": "single_family"
        },
        "listing_id": "2949147031",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48236",
                "state": "Michigan",
                "coordinate": {
                    "lon": -82.928468,
                    "lat": 42.42281
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "18900 Alstead St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=18900%20Alstead%20St%2C%20Detroit%2C%20MI%2048236&size=640x480&source=outdoor&signature=6GqO60Cw7hz3Z9dBcCyoXmq5D_4=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949147031",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                },
                {
                    "listing_id": "2935487284",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "578757101",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/15705a68e3c735be4f52001b2c4808f8l-m3089873038s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T17:12:05Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "forced_air",
            "basement",
            "single_story",
            "garage_1_or_more",
            "garage_2_or_more",
            "rental_property",
            "fixer_upper"
        ],
        "permalink": "12837-Bramell-St_Detroit_MI_48223_M48351-67336",
        "status": "for_sale",
        "list_date": "2022-10-21T21:14:33Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "5AA1A278F028F2362708ABA71A2E9370"
        },
        "branding": [
            {
                "name": "Benjamin Management Group, Inc",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/15705a68e3c735be4f52001b2c4808f8l-m3089873038s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 99900,
        "matterport": false,
        "property_id": "4835167336",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": true,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "core.broker",
                "co_broke"
            ],
            "brand_name": "essentials"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1956,
            "baths_3qtr": null,
            "sold_date": null,
            "sold_price": null,
            "baths_full": 1,
            "name": null,
            "baths_half": null,
            "lot_sqft": 5227,
            "sqft": 1030,
            "baths": 1,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 2,
            "stories": 1,
            "beds": 3,
            "type": "single_family"
        },
        "listing_id": "2949147023",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48223",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.264183,
                    "lat": 42.381425
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "12837 Bramell St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=12837%20Bramell%20St%2C%20Detroit%2C%20MI%2048223&size=640x480&source=outdoor&signature=9V3gsoEL783IswEZn44PzSLrgBk=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949147023",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/5ff4137a0e5a1c836e63affc700682dbl-m19610044s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T16:54:05Z",
        "source": {
            "agents": [
                {
                    "office_name": "CMP Realty"
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "community_security_features",
            "fireplace",
            "forced_air",
            "basement",
            "two_or_more_stories",
            "garage_1_or_more",
            "efficient",
            "groundscare"
        ],
        "permalink": "16146-Blackstone-St_Detroit_MI_48219_M38245-08678",
        "status": "for_sale",
        "list_date": "2022-10-21T20:58:20Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "8E4C40452BD938899723D9D5DA97CB76"
        },
        "branding": [
            {
                "name": "Cmp Realty",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/5ff4137a0e5a1c836e63affc700682dbl-m19610044s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/5ff4137a0e5a1c836e63affc700682dbl-m2254059789s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 89000,
        "matterport": false,
        "property_id": "3824508678",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "co_broke"
            ],
            "brand_name": "basic_opt_in"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1940,
            "baths_3qtr": null,
            "sold_date": "1995-07-31",
            "sold_price": 34900,
            "baths_full": 1,
            "name": null,
            "baths_half": 1,
            "lot_sqft": 6098,
            "sqft": 1064,
            "baths": 2,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 1,
            "stories": 2,
            "beds": 2,
            "type": "single_family"
        },
        "listing_id": "2949146335",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48219",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.24933,
                    "lat": 42.408379
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "16146 Blackstone St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=16146%20Blackstone%20St%2C%20Detroit%2C%20MI%2048219&size=640x480&source=outdoor&signature=wN3OUQQdadXlzOnNY5BuGO4LyuI=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949146335",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                },
                {
                    "listing_id": "2948227350",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "2947311350",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "2945166597",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "2799003128",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "616641361",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "616371909",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "603402897",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "603402221",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "585373557",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "573405261",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/f5f45bff62b4ea15dd1fd50a42b58e2fl-m2212517508s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T15:40:05Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "central_air",
            "forced_air",
            "basement",
            "single_story",
            "garage_1_or_more",
            "garage_2_or_more",
            "garage_3_or_more",
            "rental_property",
            "investment_opportunity",
            "fixer_upper"
        ],
        "permalink": "9754-Broadstreet-Ave_Detroit_MI_48204_M38904-90215",
        "status": "for_sale",
        "list_date": "2022-10-21T19:41:35Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "83D9B5FE5B44CA161BC1A4BE51113EF7"
        },
        "branding": [
            {
                "name": "Real Estate Home Services & Solutio",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/f5f45bff62b4ea15dd1fd50a42b58e2fl-m2212517508s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/f5f45bff62b4ea15dd1fd50a42b58e2fl-m3501507454s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 12720,
        "matterport": false,
        "property_id": "3890490215",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": true,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "core.broker",
                "co_broke"
            ],
            "brand_name": "essentials"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1921,
            "baths_3qtr": null,
            "sold_date": "2001-12-12",
            "sold_price": 28500,
            "baths_full": 1,
            "name": null,
            "baths_half": null,
            "lot_sqft": 4356,
            "sqft": 1002,
            "baths": 1,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 3,
            "stories": 1,
            "beds": 3,
            "type": "single_family"
        },
        "listing_id": "2949142799",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48204",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.128469,
                    "lat": 42.371716
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "9754 Broadstreet Ave"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=9754%20Broadstreet%20Ave%2C%20Detroit%2C%20MI%2048204&size=640x480&source=outdoor&signature=HWC2yc2eOQ-lwkRdtLmKAACuzUA=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949142799",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/090fc4c7c1e37b8163af8eaf589f0580l-m162811897s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T15:29:04Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                },
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "central_air",
            "dishwasher",
            "forced_air",
            "basement",
            "two_or_more_stories",
            "garage_1_or_more",
            "garage_2_or_more",
            "fenced_yard",
            "shopping"
        ],
        "permalink": "5290-Haverhill-St_Detroit_MI_48224_M40323-28764",
        "status": "for_sale",
        "list_date": "2022-10-21T19:29:46Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "D7F0E04266B8F0C6CCB613B4F07C3324"
        },
        "branding": [
            {
                "name": "REAL ESTATE ONE-TROY",
                "photo": "https://ap.rdcpix.com/93658424df2484efec3af266e6e1640bo-c1207872728s.jpg",
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/090fc4c7c1e37b8163af8eaf589f0580l-m162811897s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/090fc4c7c1e37b8163af8eaf589f0580l-m2132733793s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 135000,
        "matterport": false,
        "property_id": "4032328764",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "advantage_pro"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "core.broker",
                "listing_owner_lead.broker",
                "listing_owner_brand.broker"
            ],
            "brand_name": "advantage_pro"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1928,
            "baths_3qtr": null,
            "sold_date": "2022-04-19",
            "sold_price": 50000,
            "baths_full": 1,
            "name": null,
            "baths_half": 1,
            "lot_sqft": 4792,
            "sqft": 1394,
            "baths": 2,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 2,
            "stories": 2,
            "beds": 3,
            "type": "single_family"
        },
        "listing_id": "2949142289",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48224",
                "state": "Michigan",
                "coordinate": {
                    "lon": -82.944459,
                    "lat": 42.4043
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "5290 Haverhill St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=5290%20Haverhill%20St%2C%20Detroit%2C%20MI%2048224&size=640x480&source=outdoor&signature=HNm6DPISxR5EHTRf9wbqKdTO6hY=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949142289",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/9be730173e9cb2d124c7ba6a67770caal-m3048039380s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T15:05:05Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                },
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "dining_room",
            "forced_air",
            "basement",
            "two_or_more_stories",
            "new_roof"
        ],
        "permalink": "14248-Greenlawn-St_Detroit_MI_48238_M34560-83872",
        "status": "for_sale",
        "list_date": "2022-10-21T19:05:45Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "163C058ECE7526F3F7BF3C20A60E5835"
        },
        "branding": [
            {
                "name": "Keller Williams Professionals",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/9be730173e9cb2d124c7ba6a67770caal-m3048039380s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/9be730173e9cb2d124c7ba6a67770caal-m2827838870s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 80000,
        "matterport": false,
        "property_id": "3456083872",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "core.broker",
                "co_broke"
            ],
            "brand_name": "essentials"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1928,
            "baths_3qtr": null,
            "sold_date": null,
            "sold_price": null,
            "baths_full": 1,
            "name": null,
            "baths_half": null,
            "lot_sqft": 3485,
            "sqft": 1026,
            "baths": 1,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": null,
            "stories": 2,
            "beds": 3,
            "type": "single_family"
        },
        "listing_id": "2949141091",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48238",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.149628,
                    "lat": 42.392632
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "14248 Greenlawn St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=14248%20Greenlawn%20St%2C%20Detroit%2C%20MI%2048238&size=640x480&source=outdoor&signature=F4pXcMyqQnG1Y8dDUGG_6T5ScdI=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949141091",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/8136fd7d5efe4b287264830082a00787l-m433892961s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T14:58:04Z",
        "source": {
            "agents": [
                {
                    "office_name": "KW Metro"
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "dining_room",
            "basement",
            "two_or_more_stories",
            "fenced_yard",
            "fixer_upper"
        ],
        "permalink": "2526-Lamothe-St_Detroit_MI_48206_M43234-16893",
        "status": "for_sale",
        "list_date": "2022-10-21T18:58:19Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "DF70476438921A0E84AA22586FFB495E"
        },
        "branding": [
            {
                "name": "KW Metro",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/8136fd7d5efe4b287264830082a00787l-m433892961s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/8136fd7d5efe4b287264830082a00787l-m3622498202s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 130000,
        "matterport": false,
        "property_id": "4323416893",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "core.broker",
                "co_broke"
            ],
            "brand_name": "essentials"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1913,
            "baths_3qtr": null,
            "sold_date": null,
            "sold_price": null,
            "baths_full": 1,
            "name": null,
            "baths_half": 1,
            "lot_sqft": 6970,
            "sqft": 1486,
            "baths": 2,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": null,
            "stories": 2,
            "beds": 3,
            "type": "single_family"
        },
        "listing_id": "2949139820",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48206",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.101223,
                    "lat": 42.363336
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "2526 Lamothe St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=2526%20Lamothe%20St%2C%20Detroit%2C%20MI%2048206&size=640x480&source=outdoor&signature=OGOaX2nYFAbIMMaq_AlS70MOM1M=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949139820",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                },
                {
                    "listing_id": "2949097887",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "585208677",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/1c1fd30cfe18dec870c5424d754fbfa2l-m4226190349s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T14:58:04Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "forced_air",
            "basement",
            "garage_1_or_more"
        ],
        "permalink": "3966-Casmere-St_Detroit_MI_48212_M47354-81642",
        "status": "for_sale",
        "list_date": "2022-10-21T18:58:19Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "6D6C38BD902C4B18646FA9BBD3F9FF36"
        },
        "branding": [
            {
                "name": "Keller Williams Legacy",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/1c1fd30cfe18dec870c5424d754fbfa2l-m4226190349s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 150000,
        "matterport": false,
        "property_id": "4735481642",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "core.broker",
                "co_broke"
            ],
            "brand_name": "essentials"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1922,
            "baths_3qtr": null,
            "sold_date": "2002-09-25",
            "sold_price": 60000,
            "baths_full": 2,
            "name": null,
            "baths_half": null,
            "lot_sqft": 3485,
            "sqft": 1140,
            "baths": 2,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": null,
            "stories": null,
            "beds": 6,
            "type": "multi_family"
        },
        "listing_id": "2949139822",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48212",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.051233,
                    "lat": 42.405598
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "3966 Casmere St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=3966%20Casmere%20St%2C%20Detroit%2C%20MI%2048212&size=640x480&source=outdoor&signature=i_Ji7NwiWvM0zsj4llANKjFX0aQ=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949139822",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/ec13e05310f49d6d7599c1d36a7946e1l-m3509549693s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T21:11:04Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "community_security_features",
            "dining_room",
            "forced_air",
            "basement",
            "two_or_more_stories",
            "garage_1_or_more",
            "updated_kitchen",
            "new_roof"
        ],
        "permalink": "16215-Harlow-St_Detroit_MI_48235_M46743-64090",
        "status": "for_sale",
        "list_date": "2022-10-21T18:48:51Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "51D9F815101D29285B47F7EB55440868"
        },
        "branding": [
            {
                "name": "Black Diamond Realty",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/ec13e05310f49d6d7599c1d36a7946e1l-m3509549693s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/ec13e05310f49d6d7599c1d36a7946e1l-m360494821s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-22",
        "list_price": 214900,
        "matterport": false,
        "property_id": "4674364090",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "co_broke"
            ],
            "brand_name": "basic_opt_in"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1939,
            "baths_3qtr": null,
            "sold_date": "2022-01-19",
            "sold_price": 60000,
            "baths_full": 1,
            "name": null,
            "baths_half": 1,
            "lot_sqft": 4356,
            "sqft": 1316,
            "baths": 2,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 1,
            "stories": 2,
            "beds": 3,
            "type": "single_family"
        },
        "listing_id": "2949138586",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48235",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.21571,
                    "lat": 42.410071
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "16215 Harlow St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=16215%20Harlow%20St%2C%20Detroit%2C%20MI%2048235&size=640x480&source=outdoor&signature=ORkrLy2bSVqVQgG5tO8gkZQRLIU=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949138586",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                },
                {
                    "listing_id": "563513661",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "562764229",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "557697613",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/649ceefe4ad94ff70316bf2233ca8b4el-m755528130s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T14:29:06Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "community_security_features",
            "community_tennis_court",
            "dining_room",
            "forced_air",
            "furnished",
            "recreation_facilities",
            "tennis_court",
            "basement",
            "single_story",
            "garage_1_or_more"
        ],
        "permalink": "1300-E-Lafayette-St-Apt-209_Detroit_MI_48207_M99774-11646",
        "status": "for_sale",
        "list_date": "2022-10-21T18:29:59Z",
        "open_houses": null,
        "tax_record": null,
        "branding": [
            {
                "name": "Historic Realty Detroit",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/649ceefe4ad94ff70316bf2233ca8b4el-m755528130s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/649ceefe4ad94ff70316bf2233ca8b4el-m895809087s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-22",
        "list_price": 125000,
        "matterport": true,
        "property_id": "9977411646",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": true,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "core.broker",
                "co_broke"
            ],
            "brand_name": "essentials"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1964,
            "baths_3qtr": null,
            "sold_date": null,
            "sold_price": null,
            "baths_full": 1,
            "name": null,
            "baths_half": null,
            "lot_sqft": null,
            "sqft": 783,
            "baths": 1,
            "sub_type": "condo",
            "baths_1qtr": null,
            "garage": 1,
            "stories": 1,
            "beds": 1,
            "type": "condos"
        },
        "listing_id": "2949137675",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48207",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.03419,
                    "lat": 42.336692
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "1300 E Lafayette St Apt 209"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=1300%20E%20Lafayette%20St%20Apt%20209%2C%20Detroit%2C%20MI%2048207&size=640x480&source=outdoor&signature=9eJlg-ZnpHaPrdB45YYqyeNTavQ=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949137675",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/06b0afaa4aa892d4f868489b3f03c958l-m853536844s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T14:03:05Z",
        "source": {
            "agents": [
                {
                    "office_name": "Reach Realty Group"
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "dining_room",
            "forced_air",
            "basement",
            "two_or_more_stories",
            "garage_1_or_more",
            "garage_2_or_more",
            "rental_property",
            "investment_opportunity",
            "shopping"
        ],
        "permalink": "16848-Fielding-St_Detroit_MI_48219_M42322-06832",
        "status": "for_sale",
        "list_date": "2022-10-21T18:10:17Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "14B9F4C7C164B5A34AF62D58E5640FA0"
        },
        "branding": [
            {
                "name": "Reach Realty Group, Llc",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/06b0afaa4aa892d4f868489b3f03c958l-m853536844s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/06b0afaa4aa892d4f868489b3f03c958l-m2337090147s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 100000,
        "matterport": false,
        "property_id": "4232206832",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "core.broker",
                "co_broke"
            ],
            "brand_name": "essentials"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1928,
            "baths_3qtr": null,
            "sold_date": "2018-01-26",
            "sold_price": 60000,
            "baths_full": 2,
            "name": null,
            "baths_half": 1,
            "lot_sqft": 5227,
            "sqft": 1318,
            "baths": 3,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 2,
            "stories": 2,
            "beds": 4,
            "type": "single_family"
        },
        "listing_id": "2949136613",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48219",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.242905,
                    "lat": 42.413887
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "16848 Fielding St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=16848%20Fielding%20St%2C%20Detroit%2C%20MI%2048219&size=640x480&source=outdoor&signature=0kcDbRrW_fuWqc4YnrHxswVGZew=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949136613",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                },
                {
                    "listing_id": "605437193",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "598957713",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "588097073",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/da13f16cda3c049c1b77be9907e8ccd4l-m1150568204s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T14:00:06Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "dining_room",
            "family_room",
            "fireplace",
            "furnished",
            "river_view",
            "spa_or_hot_tub",
            "view",
            "washer_dryer",
            "water_view",
            "basement",
            "two_or_more_stories",
            "garage_1_or_more",
            "garage_2_or_more"
        ],
        "permalink": "474-Fiske-Dr_Detroit_MI_48214_M44336-47624",
        "status": "for_sale",
        "list_date": "2022-10-21T17:53:52Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "4BF115DDC8D668922954EEF4E9E396D1"
        },
        "branding": [
            {
                "name": "Historic Realty Detroit",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/da13f16cda3c049c1b77be9907e8ccd4l-m1150568204s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/da13f16cda3c049c1b77be9907e8ccd4l-m940423687s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-22",
        "list_price": 399999,
        "matterport": false,
        "property_id": "4433647624",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": true,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "core.broker",
                "co_broke"
            ],
            "brand_name": "essentials"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1925,
            "baths_3qtr": null,
            "sold_date": "2004-08-13",
            "sold_price": 100000,
            "baths_full": 3,
            "name": null,
            "baths_half": 1,
            "lot_sqft": 9148,
            "sqft": 2819,
            "baths": 4,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 2,
            "stories": 3,
            "beds": 5,
            "type": "single_family"
        },
        "listing_id": "2949136008",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48214",
                "state": "Michigan",
                "coordinate": {
                    "lon": -82.984152,
                    "lat": 42.356223
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "474 Fiske Dr"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=474%20Fiske%20Dr%2C%20Detroit%2C%20MI%2048214&size=640x480&source=outdoor&signature=D3kAt4KeZJl2NUWK3z6pDvnhTc0=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949136008",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/cf0879b326a19c36b665afe0024bc399l-m1441221417s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T12:58:04Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "central_air",
            "community_security_features",
            "dining_room",
            "dishwasher",
            "family_room",
            "fireplace",
            "forced_air",
            "washer_dryer",
            "basement",
            "two_or_more_stories",
            "garage_1_or_more",
            "garage_2_or_more",
            "fenced_yard",
            "golf_course",
            "groundscare",
            "shopping"
        ],
        "permalink": "18301-Monica-St_Detroit_MI_48221_M30815-99519",
        "status": "for_sale",
        "list_date": "2022-10-21T16:58:56Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "46B17BFFE7E3A8F6B9A9DE510E0255DA"
        },
        "branding": [
            {
                "name": "National Realty Centers-Northville",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/cf0879b326a19c36b665afe0024bc399l-m1441221417s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/cf0879b326a19c36b665afe0024bc399l-m3634887761s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 179900,
        "matterport": false,
        "property_id": "3081599519",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "core.broker",
                "co_broke"
            ],
            "brand_name": "essentials"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1939,
            "baths_3qtr": null,
            "sold_date": null,
            "sold_price": null,
            "baths_full": 2,
            "name": null,
            "baths_half": 1,
            "lot_sqft": 3485,
            "sqft": 1518,
            "baths": 3,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 2,
            "stories": 2,
            "beds": 4,
            "type": "single_family"
        },
        "listing_id": "2949133562",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48221",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.144779,
                    "lat": 42.425847
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "18301 Monica St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=18301%20Monica%20St%2C%20Detroit%2C%20MI%2048221&size=640x480&source=outdoor&signature=6H9oNB71aW8VwVN-tRp3MjD93l8=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949133562",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                },
                {
                    "listing_id": "565876673",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/571e010eff8e5111658d64478b3952f4l-m77988947s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T12:53:04Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                },
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "forced_air",
            "basement",
            "updated_kitchen",
            "new_roof"
        ],
        "permalink": "6644-Mercier-St_Detroit_MI_48210_M43057-25719",
        "status": "for_sale",
        "list_date": "2022-10-21T16:53:45Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "EF61966E66AD29F526EFF7D9F545E647"
        },
        "branding": [
            {
                "name": "Munoz Realty Inc",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/571e010eff8e5111658d64478b3952f4l-m77988947s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/571e010eff8e5111658d64478b3952f4l-m3783760522s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 100000,
        "matterport": false,
        "property_id": "4305725719",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "co_broke"
            ],
            "brand_name": "basic_opt_in"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1917,
            "baths_3qtr": null,
            "sold_date": "2017-05-10",
            "sold_price": 55000,
            "baths_full": 2,
            "name": null,
            "baths_half": null,
            "lot_sqft": 2614,
            "sqft": 1748,
            "baths": 2,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": null,
            "stories": null,
            "beds": 4,
            "type": "multi_family"
        },
        "listing_id": "2949133347",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48210",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.12306,
                    "lat": 42.326638
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "6644 Mercier St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=6644%20Mercier%20St%2C%20Detroit%2C%20MI%2048210&size=640x480&source=outdoor&signature=Mx6X_sEuhCd59FRbh95vGsrTS_A=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949133347",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                },
                {
                    "listing_id": "589281573",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/bfa734dc8e6e62dd7a6b8bbac11d0dc7l-m3361096188s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T12:58:04Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "dining_room",
            "fireplace",
            "forced_air",
            "laundry_room",
            "basement",
            "two_or_more_stories",
            "garage_1_or_more"
        ],
        "permalink": "18474-Roselawn-St_Detroit_MI_48221_M45605-83647",
        "status": "for_sale",
        "list_date": "2022-10-21T16:51:25Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "9988D0B603F43A492163ABE65C22CBF1"
        },
        "branding": [
            {
                "name": "Peerless Properties Llc",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/bfa734dc8e6e62dd7a6b8bbac11d0dc7l-m3361096188s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/bfa734dc8e6e62dd7a6b8bbac11d0dc7l-m3116122733s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 190000,
        "matterport": false,
        "property_id": "4560583647",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "core.broker",
                "co_broke"
            ],
            "brand_name": "essentials"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1936,
            "baths_3qtr": null,
            "sold_date": null,
            "sold_price": null,
            "baths_full": 1,
            "name": null,
            "baths_half": 1,
            "lot_sqft": 4792,
            "sqft": 1875,
            "baths": 2,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 1,
            "stories": 2,
            "beds": 3,
            "type": "single_family"
        },
        "listing_id": "2949133262",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48221",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.152577,
                    "lat": 42.427178
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "18474 Roselawn St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=18474%20Roselawn%20St%2C%20Detroit%2C%20MI%2048221&size=640x480&source=outdoor&signature=SGOarpTf-RC0eRT434rEbF9y96E=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949133262",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/7c8870da256c4cc6188b415ab0addb44l-m522695278s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T12:41:06Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                },
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "forced_air",
            "basement",
            "garage_1_or_more",
            "rental_property",
            "investment_opportunity"
        ],
        "permalink": "14221-Jane-St_Detroit_MI_48205_M41889-47005",
        "status": "for_sale",
        "list_date": "2022-10-21T16:41:42Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "E2C77E11DA48FBAEAE6577266779D579"
        },
        "branding": [
            {
                "name": "Munoz Realty Inc",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/7c8870da256c4cc6188b415ab0addb44l-m522695278s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/7c8870da256c4cc6188b415ab0addb44l-m4154737197s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 130000,
        "matterport": false,
        "property_id": "4188947005",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "co_broke"
            ],
            "brand_name": "basic_opt_in"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1927,
            "baths_3qtr": null,
            "sold_date": "2021-02-10",
            "sold_price": 115000,
            "baths_full": 2,
            "name": null,
            "baths_half": null,
            "lot_sqft": 6098,
            "sqft": 1045,
            "baths": 2,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": null,
            "stories": null,
            "beds": 4,
            "type": "multi_family"
        },
        "listing_id": "2949132863",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48205",
                "state": "Michigan",
                "coordinate": {
                    "lon": -82.976846,
                    "lat": 42.419595
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "14221 Jane St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=14221%20Jane%20St%2C%20Detroit%2C%20MI%2048205&size=640x480&source=outdoor&signature=sUUo5ghu40fAfqqEkUaAlpUX8AY=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949132863",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                },
                {
                    "listing_id": "518586757",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "502083929",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/848d43b845cabf49f64d252212c73577l-m396709095s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T13:47:37Z",
        "source": {
            "agents": [
                {
                    "office_name": "Nika & Co"
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "dining_room",
            "forced_air",
            "basement",
            "two_or_more_stories",
            "modern_kitchen",
            "large_kitchen",
            "front_porch",
            "new_roof"
        ],
        "permalink": "3753-Fischer-St_Detroit_MI_48214_M30106-59685",
        "status": "for_sale",
        "list_date": "2022-10-21T16:38:37Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "93E536AF39E6A66E438E913FACC33DA4"
        },
        "branding": [
            {
                "name": "Nika & Co",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/848d43b845cabf49f64d252212c73577l-m396709095s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/848d43b845cabf49f64d252212c73577l-m2862710157s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 199000,
        "matterport": false,
        "property_id": "3010659685",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "co_broke"
            ],
            "brand_name": "basic_opt_in"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1914,
            "baths_3qtr": null,
            "sold_date": null,
            "sold_price": null,
            "baths_full": 1,
            "name": null,
            "baths_half": 1,
            "lot_sqft": 3049,
            "sqft": 1471,
            "baths": 2,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": null,
            "stories": 2,
            "beds": 4,
            "type": "single_family"
        },
        "listing_id": "2949132719",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48214",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.000085,
                    "lat": 42.370322
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "3753 Fischer St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=3753%20Fischer%20St%2C%20Detroit%2C%20MI%2048214&size=640x480&source=outdoor&signature=uysrcfOmIqfnGfR_wbdTQvA3TMI=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949132719",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                },
                {
                    "listing_id": "2947499444",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "2944282156",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/ed60e0afe6d3fcdceebe6d88446e9917l-m3522715457s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T12:26:05Z",
        "source": {
            "agents": [
                {
                    "office_name": "Munoz Realty Inc"
                },
                {
                    "office_name": "Munoz Realty Inc"
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "dining_room",
            "basement",
            "two_or_more_stories",
            "garage_1_or_more",
            "garage_2_or_more",
            "updated_kitchen"
        ],
        "permalink": "8280-Carlin-St_Detroit_MI_48228_M37058-90480",
        "status": "for_sale",
        "list_date": "2022-10-21T16:27:34Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "C65846BFB58665D65ABF0E455476EABA"
        },
        "branding": [
            {
                "name": "Munoz Realty Inc",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/ed60e0afe6d3fcdceebe6d88446e9917l-m3522715457s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/ed60e0afe6d3fcdceebe6d88446e9917l-m3584758964s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-22",
        "list_price": 85000,
        "matterport": false,
        "property_id": "3705890480",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": true,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "co_broke"
            ],
            "brand_name": "basic_opt_in"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1929,
            "baths_3qtr": null,
            "sold_date": "2019-07-01",
            "sold_price": 79900,
            "baths_full": 2,
            "name": null,
            "baths_half": null,
            "lot_sqft": 4356,
            "sqft": 1461,
            "baths": 2,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 2,
            "stories": 2,
            "beds": 4,
            "type": "single_family"
        },
        "listing_id": "2949132192",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48228",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.178188,
                    "lat": 42.354853
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "8280 Carlin St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=8280%20Carlin%20St%2C%20Detroit%2C%20MI%2048228&size=640x480&source=outdoor&signature=NG2xxmjejO5MppW1zb0O6y-j30Y=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949132192",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                },
                {
                    "listing_id": "599271285",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "515107401",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/578437da1c6f003f2ac342481de478afl-m4260575603s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T12:05:05Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                },
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "forced_air",
            "basement",
            "single_story",
            "garage_1_or_more",
            "rental_property"
        ],
        "permalink": "18071-Saint-Marys-St_Detroit_MI_48235_M30250-13371",
        "status": "for_sale",
        "list_date": "2022-10-21T16:05:37Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "02F3ED9D89AB5BFF82357F627C6D44B1"
        },
        "branding": [
            {
                "name": "Munoz Realty Inc",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/578437da1c6f003f2ac342481de478afl-m4260575603s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/578437da1c6f003f2ac342481de478afl-m2847013289s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-22",
        "list_price": 80000,
        "matterport": false,
        "property_id": "3025013371",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": true,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "co_broke"
            ],
            "brand_name": "basic_opt_in"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1941,
            "baths_3qtr": null,
            "sold_date": "2019-07-01",
            "sold_price": 70000,
            "baths_full": 1,
            "name": null,
            "baths_half": null,
            "lot_sqft": 4792,
            "sqft": 878,
            "baths": 1,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 1,
            "stories": 1,
            "beds": 2,
            "type": "single_family"
        },
        "listing_id": "2949131262",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48235",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.207407,
                    "lat": 42.422174
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "18071 Saint Marys St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=18071%20Saint%20Marys%20St%2C%20Detroit%2C%20MI%2048235&size=640x480&source=outdoor&signature=gMCDCtSMlgLD8AkvTPUE8wEYNtk=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949131262",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                },
                {
                    "listing_id": "596025301",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "532931697",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "532932881",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/26bfb059c915026ac9687045c972df3dl-m3356554565s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T11:44:04Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                },
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "forced_air",
            "basement",
            "two_or_more_stories",
            "updated_kitchen"
        ],
        "permalink": "13551-Appleton-St_Detroit_MI_48223_M38102-61715",
        "status": "for_sale",
        "list_date": "2022-10-21T15:44:44Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "2C1FA12716505700AF2EA8FB1E2A8792"
        },
        "branding": [
            {
                "name": "Munoz Realty Inc",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/26bfb059c915026ac9687045c972df3dl-m3356554565s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/26bfb059c915026ac9687045c972df3dl-m2775065284s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 70000,
        "matterport": false,
        "property_id": "3810261715",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "co_broke"
            ],
            "brand_name": "basic_opt_in"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1944,
            "baths_3qtr": null,
            "sold_date": "2006-06-30",
            "sold_price": 83000,
            "baths_full": 1,
            "name": null,
            "baths_half": null,
            "lot_sqft": 5227,
            "sqft": 757,
            "baths": 1,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": null,
            "stories": 2,
            "beds": 2,
            "type": "single_family"
        },
        "listing_id": "2949130271",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48223",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.272595,
                    "lat": 42.384218
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "13551 Appleton St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=13551%20Appleton%20St%2C%20Detroit%2C%20MI%2048223&size=640x480&source=outdoor&signature=8myGt-HTusOYHR_W2aSd7v2j7EQ=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949130271",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                },
                {
                    "listing_id": "2796087114",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "605521753",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "578015665",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "505388897",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "505399645",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/e35372ddee9e93b16cfc5f9eb943a2d2l-m3365387167s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T11:44:04Z",
        "source": {
            "agents": [
                {
                    "office_name": "Community Choice Realty Inc"
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "forced_air",
            "basement",
            "two_or_more_stories",
            "investment_opportunity",
            "fixer_upper"
        ],
        "permalink": "18846-Riopelle-St_Detroit_MI_48203_M48919-80382",
        "status": "for_sale",
        "list_date": "2022-10-21T15:39:02Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "A8A5A1FE8AA8F3B4615D63A2E5DBF40D"
        },
        "branding": [
            {
                "name": "Community Choice Realty Inc",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/e35372ddee9e93b16cfc5f9eb943a2d2l-m3365387167s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/e35372ddee9e93b16cfc5f9eb943a2d2l-m1263250462s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 59900,
        "matterport": false,
        "property_id": "4891980382",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "core.broker",
                "co_broke"
            ],
            "brand_name": "essentials"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1940,
            "baths_3qtr": null,
            "sold_date": "2009-03-31",
            "sold_price": 2095,
            "baths_full": 1,
            "name": null,
            "baths_half": null,
            "lot_sqft": 4356,
            "sqft": 1002,
            "baths": 1,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": null,
            "stories": 2,
            "beds": 3,
            "type": "single_family"
        },
        "listing_id": "2949130010",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48203",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.0861,
                    "lat": 42.43107
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "18846 Riopelle St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=18846%20Riopelle%20St%2C%20Detroit%2C%20MI%2048203&size=640x480&source=outdoor&signature=s_GCBYi3lipI6SWsmfFW8Wdhgpg=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949130010",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                },
                {
                    "listing_id": "501045617",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "501663033",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/c1d01ca941bc544679fb59fd6945af69l-m1648664585s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T11:36:06Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "dining_room",
            "basement",
            "two_or_more_stories",
            "garage_1_or_more",
            "garage_2_or_more",
            "investment_opportunity"
        ],
        "permalink": "16227-Washburn-St_Detroit_MI_48221_M35756-45307",
        "status": "for_sale",
        "list_date": "2022-10-21T15:39:02Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "5EFA2D7F2A15CA994C1D1A736CBFDD7D"
        },
        "branding": [
            {
                "name": "C Miles Realty Llc",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/c1d01ca941bc544679fb59fd6945af69l-m1648664585s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/c1d01ca941bc544679fb59fd6945af69l-m3372761713s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 79900,
        "matterport": false,
        "property_id": "3575645307",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "co_broke"
            ],
            "brand_name": "basic_opt_in"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1928,
            "baths_3qtr": null,
            "sold_date": "1992-11-04",
            "sold_price": 33000,
            "baths_full": 1,
            "name": null,
            "baths_half": 1,
            "lot_sqft": 3485,
            "sqft": 1569,
            "baths": 2,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 2,
            "stories": 2,
            "beds": 3,
            "type": "single_family"
        },
        "listing_id": "2949130088",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48221",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.161453,
                    "lat": 42.411536
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "16227 Washburn St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=16227%20Washburn%20St%2C%20Detroit%2C%20MI%2048221&size=640x480&source=outdoor&signature=38YR2kJTAkVCeyAD_ZonE-A4vsQ=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949130088",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                },
                {
                    "listing_id": "568565377",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/3117c56fdf0a3877f301cc95c3d34469l-m2689754446s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T11:22:04Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "central_air",
            "dining_room",
            "fireplace",
            "forced_air",
            "basement",
            "single_story",
            "garage_1_or_more",
            "master_bedroom",
            "new_roof"
        ],
        "permalink": "16565-Sussex-St_Detroit_MI_48235_M46741-71463",
        "status": "for_sale",
        "list_date": "2022-10-21T15:23:30Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "06B3DD42A91612A33BF81181E48CD9E2"
        },
        "branding": [
            {
                "name": "Rivers Realty, Inc",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/3117c56fdf0a3877f301cc95c3d34469l-m2689754446s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/3117c56fdf0a3877f301cc95c3d34469l-m2954871263s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-22",
        "list_price": 165000,
        "matterport": false,
        "property_id": "4674171463",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": true,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "co_broke"
            ],
            "brand_name": "basic_opt_in"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1941,
            "baths_3qtr": null,
            "sold_date": null,
            "sold_price": null,
            "baths_full": 2,
            "name": null,
            "baths_half": 1,
            "lot_sqft": 5663,
            "sqft": 1358,
            "baths": 3,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 1,
            "stories": 1,
            "beds": 3,
            "type": "single_family"
        },
        "listing_id": "2949129353",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48235",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.195764,
                    "lat": 42.412208
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "16565 Sussex St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=16565%20Sussex%20St%2C%20Detroit%2C%20MI%2048235&size=640x480&source=outdoor&signature=ZlLjqujh4JF5kwGc7cqe6SwMzSg=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949129353",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/01f3ded1f9ad34f3b1e0ba12e0b60bc8l-m1014942696s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T10:25:05Z",
        "source": {
            "agents": [
                {
                    "office_name": "Elite Realty"
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "dining_room",
            "fireplace",
            "forced_air",
            "furnished",
            "basement",
            "two_or_more_stories",
            "garage_1_or_more",
            "garage_2_or_more",
            "fenced_yard",
            "front_porch"
        ],
        "permalink": "22122-Roxford-St_Detroit_MI_48219_M45509-84778",
        "status": "for_sale",
        "list_date": "2022-10-21T14:26:31Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "822315E85530E397B36A0D9468643CE9"
        },
        "branding": [
            {
                "name": "Elite Realty",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/01f3ded1f9ad34f3b1e0ba12e0b60bc8l-m1014942696s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/01f3ded1f9ad34f3b1e0ba12e0b60bc8l-m1104959402s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 120000,
        "matterport": false,
        "property_id": "4550984778",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "core.broker",
                "co_broke"
            ],
            "brand_name": "essentials"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1926,
            "baths_3qtr": null,
            "sold_date": "2013-11-25",
            "sold_price": 21053,
            "baths_full": 1,
            "name": null,
            "baths_half": 1,
            "lot_sqft": 5227,
            "sqft": 1289,
            "baths": 2,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 2,
            "stories": 2,
            "beds": 3,
            "type": "single_family"
        },
        "listing_id": "2949126101",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48219",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.260526,
                    "lat": 42.424792
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "22122 Roxford St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=22122%20Roxford%20St%2C%20Detroit%2C%20MI%2048219&size=640x480&source=outdoor&signature=O421ZrDaxjzzp_i6c_wGFAjrvNM=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949126101",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                },
                {
                    "listing_id": "558088597",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/25cf3fd5d0c0c4b6528dfa4b6bd69983l-m2438859269s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T14:36:04Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "central_air",
            "washer_dryer",
            "basement",
            "two_or_more_stories",
            "garage_1_or_more",
            "garage_2_or_more",
            "ensuite"
        ],
        "permalink": "14174-Rossini-Dr_Detroit_MI_48205_M93924-46105",
        "status": "for_sale",
        "list_date": "2022-10-21T14:17:54Z",
        "open_houses": null,
        "tax_record": null,
        "branding": [
            {
                "name": "Oracle Realty",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/25cf3fd5d0c0c4b6528dfa4b6bd69983l-m2438859269s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/25cf3fd5d0c0c4b6528dfa4b6bd69983l-m3122675787s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 115000,
        "matterport": false,
        "property_id": "9392446105",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "co_broke"
            ],
            "brand_name": "basic_opt_in"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1929,
            "baths_3qtr": null,
            "sold_date": null,
            "sold_price": null,
            "baths_full": 2,
            "name": null,
            "baths_half": null,
            "lot_sqft": 5227,
            "sqft": 1529,
            "baths": 2,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 2,
            "stories": 2,
            "beds": 4,
            "type": "single_family"
        },
        "listing_id": "2949125852",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48205",
                "state": "Michigan",
                "coordinate": {
                    "lon": -82.976545,
                    "lat": 42.443029
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "14174 Rossini Dr"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=14174%20Rossini%20Dr%2C%20Detroit%2C%20MI%2048205&size=640x480&source=outdoor&signature=16nzYuQ4V88Cg0oDBr57mchN94A=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949125852",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                },
                {
                    "listing_id": "2946928107",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/1fc2c4f031d03443b026d06bbb08728bl-m998846505s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T10:04:04Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "forced_air",
            "basement",
            "two_or_more_stories",
            "garage_1_or_more",
            "rental_property",
            "investment_opportunity"
        ],
        "permalink": "15384-Kentucky-St_Detroit_MI_48238_M32568-87140",
        "status": "for_sale",
        "list_date": "2022-10-21T14:05:46Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "2714731FD2B144E7639F2C4A00FC12D6"
        },
        "branding": [
            {
                "name": "Keller Williams Paint Creek",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/1fc2c4f031d03443b026d06bbb08728bl-m998846505s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 54000,
        "matterport": false,
        "property_id": "3256887140",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.broker",
                "co_broke"
            ],
            "brand_name": "essentials"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1926,
            "baths_3qtr": null,
            "sold_date": "1998-07-29",
            "sold_price": 10101,
            "baths_full": 1,
            "name": null,
            "baths_half": 1,
            "lot_sqft": 5663,
            "sqft": 1643,
            "baths": 2,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 1,
            "stories": 2,
            "beds": 3,
            "type": "single_family"
        },
        "listing_id": "2949125388",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48238",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.158377,
                    "lat": 42.403974
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "15384 Kentucky St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=15384%20Kentucky%20St%2C%20Detroit%2C%20MI%2048238&size=640x480&source=outdoor&signature=H_T-0PSjHkTCydDQAdZBEBN5S9s=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949125388",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                },
                {
                    "listing_id": "566654441",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "2936874085",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "2932921450",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "571044857",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/0cb43806e01d44a8e54c6d61e6c8fd3el-m2361277104s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T11:44:04Z",
        "source": {
            "agents": [
                {
                    "office_name": "Oak and Stone Real Estate"
                },
                {
                    "office_name": "Oak and Stone Real Estate"
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "forced_air",
            "basement",
            "two_or_more_stories",
            "updated_kitchen",
            "rental_property"
        ],
        "permalink": "18843-Saint-Aubin-St_Detroit_MI_48234_M31674-47655",
        "status": "for_sale",
        "list_date": "2022-10-21T13:59:28Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "BAA7691A04616854750FE41AFF059C12"
        },
        "branding": [
            {
                "name": "Oak and Stone Realtors",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/0cb43806e01d44a8e54c6d61e6c8fd3el-m2361277104s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/0cb43806e01d44a8e54c6d61e6c8fd3el-m3197803485s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 100000,
        "matterport": false,
        "property_id": "3167447655",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "co_broke"
            ],
            "brand_name": "basic_opt_in"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1941,
            "baths_3qtr": null,
            "sold_date": "2022-07-28",
            "sold_price": 31300,
            "baths_full": 1,
            "name": null,
            "baths_half": null,
            "lot_sqft": 5227,
            "sqft": 850,
            "baths": 1,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": null,
            "stories": 2,
            "beds": 3,
            "type": "single_family"
        },
        "listing_id": "2949125316",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48234",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.08194,
                    "lat": 42.431136
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "18843 Saint Aubin St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=18843%20Saint%20Aubin%20St%2C%20Detroit%2C%20MI%2048234&size=640x480&source=outdoor&signature=oKjARhvbY2-JAL5tMk5lCHenLTo=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949125316",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                },
                {
                    "listing_id": "2944696566",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/cabcd496132a0e982c75e684e1a5af3el-m1102643784s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T09:59:04Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "dining_room",
            "fireplace",
            "basement",
            "two_or_more_stories",
            "garage_1_or_more",
            "floor_plan",
            "new_roof",
            "fixer_upper"
        ],
        "permalink": "16592-Stansbury-St_Detroit_MI_48235_M35914-10207",
        "status": "for_sale",
        "list_date": "2022-10-21T13:58:47Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "3FF303C79BCDFA554851D31AB18094E3"
        },
        "branding": [
            {
                "name": "RE/MAX LEADING EDGE",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/cabcd496132a0e982c75e684e1a5af3el-m1102643784s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/cabcd496132a0e982c75e684e1a5af3el-m3577652621s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-26",
        "list_price": 65000,
        "matterport": false,
        "property_id": "3591410207",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": true,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "core.broker",
                "co_broke"
            ],
            "brand_name": "essentials"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1939,
            "baths_3qtr": null,
            "sold_date": "1996-05-06",
            "sold_price": 41500,
            "baths_full": 1,
            "name": null,
            "baths_half": null,
            "lot_sqft": 3920,
            "sqft": 1100,
            "baths": 1,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 1,
            "stories": 2,
            "beds": 3,
            "type": "single_family"
        },
        "listing_id": "2949125159",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48235",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.182478,
                    "lat": 42.413021
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "16592 Stansbury St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=16592%20Stansbury%20St%2C%20Detroit%2C%20MI%2048235&size=640x480&source=outdoor&signature=EjnhGuVKsGGLLayq0H7WNLf47y0=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949125159",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                },
                {
                    "listing_id": "2916314150",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/1690fea57f6a47f1f55692df5544eb60l-m1203864670s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T09:33:06Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                },
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": null,
        "permalink": "10750-Whittier-St_Detroit_MI_48224_M94515-18928",
        "status": "for_sale",
        "list_date": "2022-10-21T13:35:46Z",
        "open_houses": null,
        "tax_record": null,
        "branding": [
            {
                "name": "Keller Williams Somerset",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/1690fea57f6a47f1f55692df5544eb60l-m1203864670s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/1690fea57f6a47f1f55692df5544eb60l-m2942491234s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 14000,
        "matterport": false,
        "property_id": "9451518928",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "core.broker"
            ],
            "brand_name": "essentials"
        },
        "virtual_tours": null,
        "description": {
            "year_built": null,
            "baths_3qtr": null,
            "sold_date": null,
            "sold_price": null,
            "baths_full": null,
            "name": null,
            "baths_half": null,
            "lot_sqft": 4356,
            "sqft": null,
            "baths": 0,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": null,
            "stories": null,
            "beds": null,
            "type": "land"
        },
        "listing_id": "2949123274",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48224",
                "state": "Michigan",
                "coordinate": {
                    "lon": -82.953531,
                    "lat": 42.41744
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "10750 Whittier St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=10750%20Whittier%20St%2C%20Detroit%2C%20MI%2048224&size=640x480&source=outdoor&signature=Pyr6Nir9hVFuVvucgVzqV1lhbBY=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949123274",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/e1f6fdeadaf12fd5bcb428c55fdd1093l-m181911839s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T09:13:05Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                },
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "forced_air",
            "basement",
            "single_story",
            "garage_1_or_more",
            "garage_2_or_more"
        ],
        "permalink": "19220-Northrop-St_Detroit_MI_48219_M41999-97685",
        "status": "for_sale",
        "list_date": "2022-10-21T13:14:30Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "75E0CB03CEBD92900CE2DD9338ED42A8"
        },
        "branding": [
            {
                "name": "Keller Williams Somerset",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/e1f6fdeadaf12fd5bcb428c55fdd1093l-m181911839s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/e1f6fdeadaf12fd5bcb428c55fdd1093l-m3056852095s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 117000,
        "matterport": false,
        "property_id": "4199997685",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "core.broker",
                "co_broke"
            ],
            "brand_name": "essentials"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1951,
            "baths_3qtr": null,
            "sold_date": "2015-08-25",
            "sold_price": 20000,
            "baths_full": 1,
            "name": null,
            "baths_half": null,
            "lot_sqft": 5663,
            "sqft": 981,
            "baths": 1,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 2,
            "stories": 1,
            "beds": 3,
            "type": "single_family"
        },
        "listing_id": "2949122767",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48219",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.261689,
                    "lat": 42.430918
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "19220 Northrop St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=19220%20Northrop%20St%2C%20Detroit%2C%20MI%2048219&size=640x480&source=outdoor&signature=ewfa3_wj6h8QBbCcHNcxu8PoYSA=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949122767",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                },
                {
                    "listing_id": "517430229",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/40314d115710c1ae14857f830df27d20l-m4182818114s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T09:08:05Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "forced_air",
            "basement",
            "single_story",
            "garage_1_or_more",
            "garage_2_or_more",
            "farm",
            "ranch"
        ],
        "permalink": "19775-Blackstone-St_Detroit_MI_48219_M35410-32248",
        "status": "for_sale",
        "list_date": "2022-10-21T13:08:32Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "6BB2CEB2BB8CB92E37E704E371725C5A"
        },
        "branding": [
            {
                "name": "Match Realty LLC",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/40314d115710c1ae14857f830df27d20l-m4182818114s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/40314d115710c1ae14857f830df27d20l-m2388654486s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 75000,
        "matterport": false,
        "property_id": "3541032248",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "co_broke"
            ],
            "brand_name": "basic_opt_in"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1951,
            "baths_3qtr": null,
            "sold_date": "2019-01-17",
            "sold_price": 47000,
            "baths_full": 1,
            "name": null,
            "baths_half": 1,
            "lot_sqft": 5227,
            "sqft": 921,
            "baths": 2,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 2,
            "stories": 1,
            "beds": 3,
            "type": "single_family"
        },
        "listing_id": "2949122234",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48219",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.251633,
                    "lat": 42.435819
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "19775 Blackstone St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=19775%20Blackstone%20St%2C%20Detroit%2C%20MI%2048219&size=640x480&source=outdoor&signature=Rrx8NlhRK_CDjpxRuYVwL-6yq38=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949122234",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                },
                {
                    "listing_id": "569529349",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "607050989",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "571094573",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "566029589",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/8fcf4f5ad4b0ebe0e373404292657cafl-m580203678s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T15:56:20Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                }
            ],
            "id": "SEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "central_air",
            "community_outdoor_space",
            "fireplace",
            "forced_air",
            "hardwood_floors",
            "washer_dryer",
            "basement",
            "two_or_more_stories",
            "garage_1_or_more",
            "updated_kitchen",
            "big_lot"
        ],
        "permalink": "9941-E-Outer-Dr_Detroit_MI_48224_M40372-44719",
        "status": "for_sale",
        "list_date": "2022-10-21T12:03:57Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "C84D56D5F0A480A7A63733FFBFED5358"
        },
        "branding": [
            {
                "name": "Re/Max First",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/8fcf4f5ad4b0ebe0e373404292657cafl-m580203678s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/8fcf4f5ad4b0ebe0e373404292657cafl-m1337460495s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": null,
        "list_price": 149900,
        "matterport": false,
        "property_id": "4037244719",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "core.broker",
                "co_broke"
            ],
            "brand_name": "essentials"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1936,
            "baths_3qtr": null,
            "sold_date": null,
            "sold_price": null,
            "baths_full": 1,
            "name": null,
            "baths_half": 1,
            "lot_sqft": 6970,
            "sqft": 1435,
            "baths": 2,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 1,
            "stories": 2,
            "beds": 3,
            "type": "single_family"
        },
        "listing_id": "2949118549",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48224",
                "state": "Michigan",
                "coordinate": {
                    "lon": -82.962665,
                    "lat": 42.414278
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "9941 E Outer Dr"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=9941%20E%20Outer%20Dr%2C%20Detroit%2C%20MI%2048224&size=640x480&source=outdoor&signature=VTrS9HJ164npgnbkIK40jBnxeC8=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949118549",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/f0fd0d59569cb39d96de42f4441c3976l-m887256477s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T00:09:06Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "forced_air",
            "basement",
            "single_story",
            "garage_1_or_more",
            "big_yard",
            "farm",
            "ranch",
            "shopping"
        ],
        "permalink": "9916-Chatham_Detroit_MI_48239_M35269-57613",
        "status": "for_sale",
        "list_date": "2022-10-21T04:11:33Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "567691BF10A282E4A563636F208516A7"
        },
        "branding": [
            {
                "name": "Berkshire Hathaway HomeServices The Loft Warehouse",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/f0fd0d59569cb39d96de42f4441c3976l-m887256477s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/f0fd0d59569cb39d96de42f4441c3976l-m2821544275s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-21",
        "list_price": 70000,
        "matterport": false,
        "property_id": "3526957613",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "core.broker",
                "co_broke"
            ],
            "brand_name": "essentials"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1950,
            "baths_3qtr": null,
            "sold_date": "2002-08-02",
            "sold_price": 91500,
            "baths_full": 1,
            "name": null,
            "baths_half": null,
            "lot_sqft": 4356,
            "sqft": 732,
            "baths": 1,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 1,
            "stories": 1,
            "beds": 2,
            "type": "single_family"
        },
        "listing_id": "2949113045",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48239",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.261699,
                    "lat": 42.367126
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "9916 Chatham"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=9916%20Chatham%2C%20Detroit%2C%20MI%2048239&size=640x480&source=outdoor&signature=_1L11s174zHZCQkFq-xA5OSF5p0=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949113045",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                },
                {
                    "listing_id": "2944160644",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "570279629",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "544173373",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "530071221",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/73e48eb1ee7b7e2fccbc43e8aec76d3cl-m508760042s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T10:11:06Z",
        "source": {
            "agents": [
                {
                    "office_name": "Home Negotiators LLC"
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "dining_room",
            "forced_air",
            "basement",
            "two_or_more_stories",
            "garage_1_or_more"
        ],
        "permalink": "20235-Forrer-St_Detroit_MI_48235_M47766-79402",
        "status": "for_sale",
        "list_date": "2022-10-21T03:48:37Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "05E374EC01DCF85559EE61C23C163FCF"
        },
        "branding": [
            {
                "name": "Home Negotiators Llc",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/73e48eb1ee7b7e2fccbc43e8aec76d3cl-m508760042s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/73e48eb1ee7b7e2fccbc43e8aec76d3cl-m758473643s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-20",
        "list_price": 55000,
        "matterport": false,
        "property_id": "4776679402",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "co_broke"
            ],
            "brand_name": "basic_opt_in"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1946,
            "baths_3qtr": null,
            "sold_date": "2001-11-13",
            "sold_price": 50000,
            "baths_full": 1,
            "name": null,
            "baths_half": null,
            "lot_sqft": 6098,
            "sqft": 895,
            "baths": 1,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 1,
            "stories": 2,
            "beds": 3,
            "type": "single_family"
        },
        "listing_id": "2949112797",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48235",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.203574,
                    "lat": 42.441734
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "20235 Forrer St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=20235%20Forrer%20St%2C%20Detroit%2C%20MI%2048235&size=640x480&source=outdoor&signature=wiK9WQqbFpokEU58KcTXUB45q4Y=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949112797",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                },
                {
                    "listing_id": "577278637",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                },
                {
                    "listing_id": "577279785",
                    "listing_key": null,
                    "status": "off_market",
                    "primary": null
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/053188e8d0720a2a64b91de9f483d6a3l-m1529878419s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-20T22:59:05Z",
        "source": {
            "agents": [
                {
                    "office_name": null
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "forced_air",
            "basement",
            "two_or_more_stories",
            "garage_1_or_more"
        ],
        "permalink": "15081-Cruse-St_Detroit_MI_48227_M39581-80910",
        "status": "for_sale",
        "list_date": "2022-10-21T03:00:12Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "DA85D1CB3F612984C8319827F1AB9750"
        },
        "branding": [
            {
                "name": "Michael Group Realty Llc",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/053188e8d0720a2a64b91de9f483d6a3l-m1529878419s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/053188e8d0720a2a64b91de9f483d6a3l-m692696073s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-20",
        "list_price": 60000,
        "matterport": false,
        "property_id": "3958180910",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": null,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "core.broker",
                "co_broke"
            ],
            "brand_name": "essentials"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1951,
            "baths_3qtr": null,
            "sold_date": "2003-09-02",
            "sold_price": 88000,
            "baths_full": 1,
            "name": null,
            "baths_half": 1,
            "lot_sqft": 5663,
            "sqft": 1159,
            "baths": 2,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 1,
            "stories": 2,
            "beds": 3,
            "type": "single_family"
        },
        "listing_id": "2949112079",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48227",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.1837,
                    "lat": 42.400942
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "15081 Cruse St"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=15081%20Cruse%20St%2C%20Detroit%2C%20MI%2048227&size=640x480&source=outdoor&signature=CM8saG52mX3RMHMgPxga4NSAB0k=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949112079",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                }
            ]
        }
    },
    {
        "primary_photo": {
            "href": "https://ap.rdcpix.com/909a1a007d3c23b533810dcc55d5c334l-m2225279657s-w1024_h768.jpg"
        },
        "last_update_date": "2022-10-21T10:38:04Z",
        "source": {
            "agents": [
                {
                    "office_name": "RE/MAX Classic"
                }
            ],
            "id": "DEMI",
            "plan_id": null,
            "spec_id": null,
            "type": "mls"
        },
        "tags": [
            "central_air",
            "dishwasher",
            "forced_air",
            "laundry_room",
            "washer_dryer",
            "basement",
            "two_or_more_stories",
            "garage_1_or_more",
            "garage_2_or_more",
            "master_bedroom",
            "new_roof",
            "clubhouse",
            "trails",
            "shopping"
        ],
        "permalink": "7434-Lamphere_Detroit_MI_48239_M35146-10694",
        "status": "for_sale",
        "list_date": "2022-10-21T02:50:58Z",
        "open_houses": null,
        "tax_record": {
            "public_record_id": "9CC49B192D03DD55E6C6A8EA6BAA1D04"
        },
        "branding": [
            {
                "name": "RE/MAX Classic",
                "photo": null,
                "type": "Office"
            }
        ],
        "photos": [
            {
                "href": "https://ap.rdcpix.com/909a1a007d3c23b533810dcc55d5c334l-m2225279657s-w1024_h768.jpg"
            },
            {
                "href": "https://ap.rdcpix.com/909a1a007d3c23b533810dcc55d5c334l-m2132705782s-w1024_h768.jpg"
            }
        ],
        "coming_soon_date": "2022-10-22",
        "list_price": 109900,
        "matterport": false,
        "property_id": "3514610694",
        "flags": {
            "is_new_construction": null,
            "is_subdivision": null,
            "is_plan": null,
            "is_price_reduced": null,
            "is_pending": null,
            "is_foreclosure": null,
            "is_new_listing": true,
            "is_coming_soon": true,
            "is_contingent": null
        },
        "lead_attributes": {
            "show_contact_an_agent": true,
            "opcity_lead_attributes": {
                "flip_the_market_enabled": false,
                "cashback_enabled": false
            },
            "lead_type": "co_broke"
        },
        "community": null,
        "products": {
            "products": [
                "core.agent",
                "core.broker",
                "co_broke"
            ],
            "brand_name": "essentials"
        },
        "virtual_tours": null,
        "description": {
            "year_built": 1942,
            "baths_3qtr": null,
            "sold_date": null,
            "sold_price": null,
            "baths_full": 1,
            "name": null,
            "baths_half": null,
            "lot_sqft": 5227,
            "sqft": 880,
            "baths": 1,
            "sub_type": null,
            "baths_1qtr": null,
            "garage": 2,
            "stories": 2,
            "beds": 3,
            "type": "single_family"
        },
        "listing_id": "2949112017",
        "price_reduced_amount": null,
        "location": {
            "address": {
                "postal_code": "48239",
                "state": "Michigan",
                "coordinate": {
                    "lon": -83.258488,
                    "lat": 42.344703
                },
                "city": "Detroit",
                "state_code": "MI",
                "line": "7434 Lamphere"
            },
            "street_view_url": "https://maps.googleapis.com/maps/api/streetview?channel=rdc-streetview&client=gme-movesalesinc&location=7434%20Lamphere%2C%20Detroit%2C%20MI%2048239&size=640x480&source=outdoor&signature=bCm2ijx146JqlkrNsHlB_2huINo=",
            "county": {
                "fips_code": "26163",
                "name": "Wayne"
            }
        },
        "other_listings": {
            "rdc": [
                {
                    "listing_id": "2949112017",
                    "listing_key": null,
                    "status": "for_sale",
                    "primary": true
                }
            ]
        }
    }
]

export const defaultUserLocation = {
    city: "Los Angeles",
    state: "CA"
}



export const usCities = [
    "Aguadilla",
    "Atlantic City",
    "Navarre",
    "Mission Viejo",
    "Murrieta",
    "Poughkeepsie",
    "Round Lake Beach",
    "Myrtle Beach",
    "Concord",
    "Hickory",
    "Deltona",
    "Hagerstown",
    "Hemet",
    "Danbury",
    "Medford",
    "Lancaster",
    "Indio",
    "Lancaster",
    "Fayetteville",
    "Victorville",
    "Bonita Springs",
    "Kennewick",
    "Winter Haven",
    "Aguadilla",
    "Atlantic City",
    "Navarre",
    "Mission Viejo",
    "Murrieta",
    "Poughkeepsie",
    "Round Lake Beach",
    "Myrtle Beach",
    "Concord",
    "Hickory",
    "Deltona",
    "Hagerstown",
    "Hemet",
    "Danbury",
    "Medford",
    "Lancaster",
    "Indio",
    "Lancaster",
    "Fayetteville",
    "Victorville",
    "Bonita Springs",
    "Kennewick",
    "Winter Haven",
    "Gulfport",
    "Palm Coast",
    "Antioch",
    "Bel Air South",
    "Fontana",
    "College Station",
    "Norwich",
    "Salinas",
    "Olympia",
    "Gastonia",
    "Lorain",
    "Nampa",
    "Ontario",
    "Ogden",
    "Elk Grove",
    "Provo",
    "Oxnard",
    "Pensacola",
    "Kissimmee",
    "Reading",
    "Avondale",
    "McKinney",
    "Nashua",
    "Appleton",
    "Killeen",
    "Bremerton",
    "Spartanburg",
    "Thousand Oaks",
    "Moreno Valley",
    "Fargo",
    "Santa Barbara",
    "Tempe",
    "Rancho Cucamonga",
    "York",
    "Visalia",
    "Vallejo",
    "Oceanside",
    "Vero Beach South",
    "Ocala",
    "McAllen",
    "Sarasota",
    "Concord",
    "Allentown",
    "Greenville",
    "Palm Bay",
    "Ann Arbor",
    "Fort Collins",
    "Eugene",
    "Asheville",
    "The Woodlands",
    "Lafayette",
    "Wilmington",
    "Laredo",
    "Fremont",
    "Garland",
    "Kalamazoo",
    "Green Bay",
    "Huntington Beach",
    "Aurora",
    "Grand Prairie",
    "Garden Grove",
    "Cape Coral",
    "Hartford",
    "Bridgeport",
    "Murfreesboro",
    "New Haven",
    "Harrisburg",
    "Clarksville",
    "Modesto",
    "Santa Ana",
    "Flint",
    "Frisco",
    "Lansing",
    "Santa Rosa",
    "Plano",
    "Davenport",
    "Trenton",
    "Chula Vista",
    "Santa Clarita",
    "Salem",
    "Chandler",
    "Chesapeake",
    "Irving",
    "Hialeah",
    "Evansville",
    "Brownsville",
    "Portland",
    "Cedar Rapids",
    "Huntington",
    "Waterbury",
    "Peoria",
    "Grand Rapids",
    "Scranton",
    "Anaheim",
    "Denton",
    "Jersey City",
    "Gilbert",
    "High Point",
    "North Port",
    "Spring Valley",
    "Pembroke Pines",
    "Rockford",
    "Sunrise Manor",
    "Riverside",
    "Yonkers",
    "Durham",
    "Providence",
    "Worcester",
    "Roanoke",
    "Henderson",
    "Newport News",
    "Peoria",
    "North Las Vegas",
    "South Bend",
    "Newark",
    "Port St. Lucie",
    "Lakeland",
    "Paradise",
    "Vancouver",
    "Waco",
    "Sioux Falls",
    "Augusta",
    "Springfield",
    "Youngstown",
    "Bakersfield",
    "Winston-Salem",
    "Irvine",
    "Scottsdale",
    "Canton",
    "Charleston",
    "Columbus",
    "San Bernardino",
    "Erie",
    "Columbia",
    "Albany",
    "Stockton",
    "Boise",
    "Fayetteville",
    "Glendale",
    "Savannah",
    "Shreveport",
    "Virginia Beach",
    "Springfield",
    "Amarillo",
    "Arlington",
    "Fort Lauderdale",
    "Des Moines",
    "Staten Island",
    "Reno",
    "Spokane",
    "Syracuse",
    "Tallahassee",
    "Glendale",
    "Aurora",
    "Arlington",
    "Little Rock",
    "Mesa",
    "Honolulu",
    "Greensboro",
    "Long Beach",
    "Toledo",
    "Madison",
    "Huntsville",
    "St. Paul",
    "Richmond",
    "St. Petersburg",
    "Norfolk",
    "Tacoma",
    "Albuquerque",
    "Knoxville",
    "Jackson",
    "Lubbock",
    "Fort Wayne",
    "Enterprise",
    "Overland Park",
    "Lexington",
    "Salt Lake City",
    "Chattanooga",
    "Gainesville",
    "Dayton",
    "Oakland",
    "Baton Rouge",
    "Buffalo",
    "Montgomery",
    "San Juan",
    "Fresno",
    "Orlando",
    "Rochester",
    "El Paso",
    "St. Louis",
    "Miami",
    "New Orleans",
    "Lincoln",
    "Mobile",
    "Tampa",
    "Minneapolis",
    "Las Vegas",
    "Corpus Christi",
    "Cleveland",
    "Anchorage",
    "Sacramento",
    "Wichita",
    "Colorado Springs",
    "Louisville",
    "Tucson",
    "Birmingham",
    "Bronx",
    "Milwaukee",
    "Pittsburgh",
    "San Francisco",
    "Portland",
    "Baltimore",
    "Cincinnati",
    "Atlanta",
    "Tulsa",
    "Omaha",
    "Memphis",
    "Detroit",
    "San Jose",
    "Seattle",
    "Boston",
    "Charlotte",
    "Nashville",
    "Brooklyn",
    "Jacksonville",
    "Denver",
    "Indianapolis",
    "Akron",
    "Manhattan",
    "Raleigh",
    "Philadelphia",
    "San Diego",
    "Columbus",
    "Kansas City",
    "Oklahoma City",
    "Washington",
    "Dallas",
    "Houston",
    "Phoenix",
    "San Antonio",
    "Chicago",
    "Queens",
    "Los Angeles",
    "New York",
    "Arecibo",
    "Seaside",
    "South Lyon",
    "Fredericksburg",
    "Leominster",
    "Pottstown",
    "Kailua",
    "Norwalk",
    "San Germán",
    "Gilroy",
    "Holland",
    "El Centro",
    "Lafayette",
    "Portsmouth",
    "Hanford",
    "Port Huron",
    "Dover",
    "Chino Hills",
    "Kankakee",
    "South Gate",
    "Cicero",
    "Yauco",
    "Newark",
    "Marysville",
    "Cedar Park",
    "Olathe",
    "Elizabethtown",
    "Pharr",
    "Bellflower",
    "Houma",
    "Yuma",
    "Greeley",
    "Burlington",
    "Harlingen",
    "Simi Valley",
    "Meridian",
    "Salisbury",
    "Daly City",
    "Yuba City",
    "Coeur d'Alene",
    "St. George",
    "Costa Mesa",
    "Vacaville",
    "Eau Claire",
    "Allen",
    "Utica",
    "La Crosse",
    "Mandeville",
    "Turlock",
    "Jurupa Valley",
    "Fort Worth",
    "Austin",
    "Brockton",
    "Hesperia",
    "Roswell",
    "Slidell",
    "Blacksburg",
    "Mayagüez",
    "Livermore",
    "Mount Pleasant",
    "Dalton",
    "Westminster",
    "Germantown",
    "Citrus Heights",
    "Hawthorne",
    "Homosassa Springs",
    "Chino",
    "Napa",
    "Lake Forest",
    "New Braunfels",
    "Mission",
    "Alhambra",
    "Alton",
    "Williamsburg",
    "Atascocita",
    "Buena Park",
    "Loveland",
    "Joplin",
    "Westland",
    "Madera",
    "Pleasanton",
    "Lebanon",
    "Tustin",
    "San Ramon",
    "Springdale",
    "Pine Hills",
    "Texarkana",
    "Folsom",
    "Alameda",
    "Flower Mound",
    "Davis",
    "Perris",
    "Upland",
    "Layton",
    "Watsonville",
    "Wausau",
    "Port Arthur",
    "Mauldin",
    "Frederick",
    "Pomona",
    "Champaign",
    "Leesburg",
    "Camarillo",
    "Elkhart",
    "Panama City",
    "Warner Robins",
    "Merced",
    "Fairfield",
    "Gainesville",
    "Carrollton",
    "Roseville",
    "Bellingham",
    "Santa Maria",
    "Bloomington",
    "Redding",
    "East Los Angeles",
    "The Villages",
    "Dover",
    "Greenville",
    "Round Rock",
    "Manteca",
    "Sugar Land",
    "St. Cloud",
    "Saginaw",
    "Burlington",
    "Richardson",
    "Hillsboro",
    "Highlands Ranch",
    "San Buenaventura",
    "West Jordan",
    "Bend",
    "Broken Arrow",
    "Downey",
    "Sparks",
    "El Cajon",
    "Temple",
    "West Covina",
    "San Tan Valley",
    "El Monte",
    "Federal Way",
    "Rialto",
    "Elgin",
    "Temecula",
    "Clovis",
    "Idaho Falls",
    "Longmont",
    "Rio Rancho",
    "Vista",
    "Bowling Green",
    "San Marcos",
    "Tracy",
    "Compton",
    "Prescott Valley",
    "Riverview",
    "Arden-Arcade",
    "Vineland",
    "Middletown",
    "Edinburg",
    "Livonia",
    "Quincy",
    "Alafaya",
    "Santa Fe",
    "Kirkland",
    "San Leandro",
    "Town 'n' Country",
    "Florence",
    "Rapid City",
    "State College",
    "Waukegan",
    "Johns Creek",
    "O'Fallon",
    "Jackson",
    "Lawrence",
    "Hattiesburg",
    "Deerfield Beach",
    "Anderson",
    "Mountain View",
    "Somerville",
    "Auburn",
    "Zephyrhills",
    "Franklin",
    "Lakewood",
    "New Rochelle",
    "Rock Hill",
    "St. Augustine",
    "Parma",
    "Boynton Beach",
    "Kendall",
    "Logan",
    "Auburn",
    "Cheyenne",
    "Corona",
    "Lafayette",
    "Muskegon",
    "Sunnyvale",
    "Santa Cruz",
    "Palmdale",
    "Naperville",
    "Escondido",
    "Spring Hill",
    "New Bedford",
    "Baytown",
    "Mesquite",
    "Odessa",
    "Binghamton",
    "Miramar",
    "Fullerton",
    "West Valley City",
    "Santa Clara",
    "Coral Springs",
    "Yakima",
    "Pearland",
    "Kent",
    "Sterling Heights",
    "Chico",
    "Johnson City",
    "Gresham",
    "Billings",
    "Sandy Springs",
    "Lowell",
    "Pompano Beach",
    "Longview",
    "Kingsport",
    "San Mateo",
    "Columbia",
    "Charlottesville",
    "Ponce",
    "Iowa City",
    "Lawton",
    "Lynn",
    "Sandy",
    "Miami Beach",
    "Fishers",
    "Bismarck",
    "Orem",
    "Waterloo",
    "Elizabeth",
    "Menifee",
    "Kenosha",
    "Carlsbad",
    "Edmond",
    "Dearborn",
    "Albany",
    "Decatur",
    "Anderson",
    "Conroe",
    "Farmington Hills",
    "Plymouth",
    "Flagstaff",
    "Warwick",
    "Silver Spring",
    "Hoover",
    "Goodyear",
    "Redwood City",
    "Troy",
    "Cary",
    "Clifton",
    "Anniston",
    "Manchester",
    "Valdosta",
    "Bellevue",
    "Sumter",
    "Hayward",
    "Torrance",
    "Tyler",
    "Midland",
    "Pueblo",
    "Orange",
    "Metairie",
    "Columbia",
    "Racine",
    "Carolina",
    "Warren",
    "Lynchburg",
    "Texas City",
    "Las Cruces",
    "Cambridge",
    "Lewisville",
    "Burbank",
    "Brandon",
    "Monroe",
    "Miami Gardens",
    "Waldorf",
    "Everett",
    "Inglewood",
    "League City",
    "Florence",
    "Renton",
    "Lawrence",
    "Lee's Summit",
    "Carmel",
    "Terre Haute",
    "Morgantown",
    "Santa Monica",
    "Missoula",
    "Carson",
    "Muncie",
    "Springfield",
    "Bryan",
    "Whittier",
    "Brooklyn Park",
    "Hammond",
    "Melbourne",
    "Grand Junction",
    "Surprise",
    "Lake Charles",
    "Stamford",
    "Alexandria",
    "Fort Smith",
    "Bayamón",
    "Lehigh Acres",
    "Boulder",
    "Rochester",
    "Richmond",
    "Bloomington",
    "Arvada",
    "Davie",
    "Portsmouth",
    "St. Joseph",
    "Fort Myers",
    "Newport Beach",
    "West Palm Beach",
    "Beaverton",
    "Thornton",
    "Boca Raton",
    "Jacksonville",
    "Tuscaloosa",
    "Centennial",
    "Cranston",
    "South Fulton",
    "Westminster",
    "North Charleston",
    "Joliet",
    "Sunrise",
    "Lakewood",
    "Abilene",
    "Pasadena",
    "San Angelo",
    "Bloomington",
    "Suffolk",
    "Plantation",
    "Fall River",
    "Charleston",
    "Clearwater",
    "Pasadena",
    "Wichita Falls",
    "Berkeley",
    "Springfield",
    "Largo",
    "Independence",
    "Paterson",
    "Hollywood",
    "Beaumont",
    "Norman",
    "Sioux City",
    "Duluth",
    "Macon",
    "Athens",
    "Kansas City",
    "Newton",
    "Topeka",
    "Hampton",
    "Baldwin Park",
    "Milpitas",
    "Wheeling",
    "Dale City",
    "Winchester",
    "Pasco",
    "Wenatchee",
    "Pittsburg",
    "Passaic",
    "Juana Díaz",
    "Mansfield",
    "Union City",
    "Florida",
    "South San Francisco",
    "Porterville",
    "DeKalb",
    "Bristol",
    "Hanover",
    "Longview",
    "Lynwood",
    "Redmond",
    "Lehi",
    "Norwalk",
    "El Paso de Robles",
    "Glens Falls",
    "Michigan City",
    "Spokane Valley",
    "Weirton",
    "Bayonne",
    "Guayama",
    "Laguna Niguel",
    "Tulare",
    "Pflugerville",
    "Brentwood",
    "Twin Rivers",
    "Dublin",
    "Brentwood",
    "Huntington Park",
    "Taylor",
    "Montebello",
    "Malden",
    "Huntersville",
    "Moore",
    "Pico Rivera",
    "Cupertino",
    "Leander",
    "Bristol",
    "Medford",
    "Fountain Valley",
    "Hendersonville",
    "Normal",
    "Perth Amboy",
    "Berwyn",
    "Yucaipa",
    "Paramount",
    "Oak Lawn",
    "Revere",
    "Colton",
    "New Brunswick",
    "Hacienda Heights",
    "Apple Valley",
    "Delano",
    "Rosemead",
    "Spring",
    "West Haven",
    "La Habra",
    "Peabody",
    "Hoboken",
    "Smyrna",
    "Elyria",
    "Placentia",
    "DeSoto",
    "Mount Prospect",
    "West New York",
    "Country Club",
    "Lakewood",
    "Methuen Town",
    "Twin Falls",
    "Aliso Viejo",
    "Poway",
    "Cerritos",
    "Draper",
    "Cedar Hill",
    "Cypress",
    "Antelope",
    "Lincoln",
    "Beaumont",
    "Newark",
    "Ocoee",
    "Roseville",
    "Jeffersonville",
    "Burleson",
    "Arlington Heights",
    "Battle Creek",
    "Fajardo",
    "Hilton Head Island",
    "Bolingbrook",
    "South Jordan",
    "Union City",
    "Apple Valley",
    "Lake Jackson",
    "Altoona",
    "Caguas",
    "Ellicott City",
    "Owensboro",
    "Framingham",
    "Cleveland",
    "Woodbury",
    "Maple Grove",
    "San Marcos",
    "Pawtucket",
    "Jackson",
    "North Richland Hills",
    "Sheboygan",
    "Eldersburg",
    "Lodi",
    "St. Charles",
    "West Bend",
    "Decatur",
    "Yorba Linda",
    "Bay City",
    "Parkersburg",
    "Palatine",
    "Rogers",
    "Saratoga Springs",
    "Lakeville",
    "Sherman",
    "Rome",
    "Tamarac",
    "Kenner",
    "Redondo Beach",
    "West Des Moines",
    "Petaluma",
    "Florence-Graham",
    "Rowlett",
    "Eastvale",
    "Albany",
    "East Orange",
    "Jupiter",
    "Ankeny",
    "San Clemente",
    "Noblesville",
    "Coon Rapids",
    "The Hammocks",
    "Monterey Park",
    "St. Peters",
    "Burnsville",
    "Lakewood",
    "Orland Park",
    "Sebring",
    "Taylorsville",
    "National City",
    "Tinley Park",
    "Caldwell",
    "Woodland",
    "Meriden",
    "Sanford",
    "La Mesa",
    "Richland",
    "Santee",
    "South Whittier",
    "San Rafael",
    "Margate",
    "Greenwood",
    "Gardena",
    "Des Plaines",
    "Royal Oak",
    "Commerce City",
    "Council Bluffs",
    "Dundalk",
    "Arcadia",
    "Dearborn Heights",
    "Diamond Bar",
    "Kendale Lakes",
    "Grapevine",
    "Parker",
    "Tigard",
    "Blue Springs",
    "Brookhaven",
    "Cathedral City",
    "Aspen Hill",
    "Leesburg",
    "Queen Creek",
    "Wheaton",
    "West Sacramento",
    "Palm Desert",
    "Milford city ",
    "Grand Island",
    "Florissant",
    "Summerville",
    "Bentonville",
    "Wheaton",
    "Lacey",
    "Maricopa",
    "Collierville",
    "Rowland Heights",
    "Glendora",
    "Madison",
    "Mishawaka",
    "Little Elm",
    "West Lafayette",
    "Azusa",
    "Portage",
    "Downers Grove",
    "Wilson",
    "St. Louis Park",
    "Troy",
    "Bedford",
    "Columbus",
    "Bozeman",
    "Alexandria",
    "Harrisonburg",
    "Rocklin",
    "Tuckahoe",
    "Florin",
    "Rancho Santa Margarita",
    "Roswell",
    "Hammond",
    "San Jacinto",
    "Bethlehem",
    "Glenview",
    "Buckeye",
    "Dublin",
    "Mount Vernon",
    "Georgetown",
    "La Mirada",
    "San Luis Obispo",
    "Carmichael",
    "Rancho Cordova",
    "Pocatello",
    "Rochester Hills",
    "Evanston",
    "Centreville",
    "Conway",
    "Janesville",
    "New Britain",
    "Waukesha",
    "Bossier City",
    "Casas Adobes",
    "Eagan",
    "Eden Prairie",
    "Encinitas",
    "Elmira",
    "Glen Burnie",
    "Castle Rock",
    "Rockville",
    "Port Orange",
    "Victoria",
    "Skokie",
    "Fairbanks",
    "Sammamish",
    "Homestead",
    "Poinciana",
    "Lake Elsinore",
    "Wellington",
    "Mount Vernon",
    "Delray Beach",
    "Haverhill",
    "Blaine",
    "Dubuque",
    "Corvallis",
    "Springfield",
    "Grand Forks",
    "Lima",
    "Carbondale",
    "Casper",
    "Castro Valley",
    "South Hill",
    "Rocky Mount",
    "Southaven",
    "West Allis",
    "Reston",
    "St. Clair Shores",
    "Waltham",
    "Novato",
    "Palm Harbor",
    "Casa Grande",
    "Bradenton",
    "Manhattan",
    "Shoreline",
    "Tamiami",
    "Hamilton",
    "Pontiac",
    "Highland",
    "Smyrna",
    "Taunton",
    "Kokomo",
    "Lake Havasu City",
    "Apex",
    "Midwest City",
    "Aloha",
    "Coconut Creek",
    "Carson City",
    "Stonecrest",
    "Chicopee",
    "Euless",
    "Great Falls",
    "St. Cloud",
    "Severn",
    "Oak Park",
    "Apopka",
    "Levittown",
    "Catalina Foothills",
    "Missouri City",
    "Covina",
    "Minot",
    "East Lansing",
    "Kannapolis",
    "Camden",
    "Enid",
    "Hoffman Estates",
    "Chesterfield",
    "Oshkosh",
    "Jonesboro",
    "Plainfield",
    "East Providence",
    "Southfield",
    "Dunwoody",
    "Schaumburg",
    "Dothan",
    "Ames",
    "Port Charlotte",
    "Bellevue",
    "Walnut Creek",
    "Broomfield",
    "Gaithersburg",
    "North Highlands",
    "Chapel Hill",
    "Redlands",
    "Wyoming",
    "Lauderhill",
    "Weston",
    "Wesley Chapel",
    "Millcreek",
    "Daytona Beach",
    "Schenectady",
    "Wylie",
    "Westchester",
    "Galveston",
    "Doral",
    "Levittown",
    "Pinellas Park",
    "North Miami",
    "Wilmington",
    "Fountainebleau",
    "Bartlett",
    "Palm Beach Gardens",
    "Minnetonka",
    "Palm Springs",
    "White Plains",
    "Edina",
    "Novi",
    "North Little Rock",
    "Cuyahoga Falls",
    "Kentwood",
    "Murray",
    "Stillwater",
    "McLean",
    "Bowie",
    "Wauwatosa",
    "Lawrence",
    "Burien",
    "University",
    "Kettering",
    "Marietta",
    "Niagara Falls",
    "Coral Gables",
    "Mansfield",
    "Lenexa",
    "North Bethesda",
    "Palo Alto",
    "Guaynabo",
    "Beavercreek",
    "Marana",
    "Towson",
    "Shawnee",
    "Bethesda",
    "Gary",
    "Mentor",
    "Salina",
    "Elmhurst",
    "North Lauderdale",
    "Everett",
    "Winter Garden",
    "Lake Ridge",
    "San Bruno",
    "Sicklerville",
    "Morgan Hill",
    "Herriman",
    "Coachella",
    "Whitney",
    "Hilo",
    "Hackensack",
    "Attleboro",
    "Wake Forest",
    "Lombard",
    "Salem",
    "Freeport",
    "Bountiful",
    "Channelview",
    "Goose Creek",
    "Campbell",
    "Brentwood",
    "Mankato",
    "Lompoc",
    "Ceres",
    "Woodbridge",
    "Pittsfield",
    "Buffalo Grove",
    "La Quinta",
    "Lancaster",
    "Woburn",
    "Huber Heights",
    "Shakopee",
    "Rancho Palos Verdes",
    "Linden",
    "Cedar Falls",
    "Moline",
    "Delaware",
    "Alpharetta",
    "Fitchburg",
    "Findlay",
    "Rohnert Park",
    "Woonsocket",
    "Bell Gardens",
    "Hicksville",
    "West Babylon",
    "Manassas",
    "Marlborough",
    "Streamwood",
    "Westfield",
    "Roy",
    "Keizer",
    "Mission Bend",
    "Holyoke",
    "South Valley",
    "Los Banos",
    "Hollister",
    "Pacifica",
    "Marion",
    "Hallandale Beach",
    "Fairfield",
    "Spanish Fork",
    "Kearny",
    "Friendswood",
    "Romeoville",
    "Chelsea",
    "Calexico",
    "Royal Palm Beach",
    "Wentzville",
    "Grove City",
    "Clovis",
    "Gallatin",
    "Montclair",
    "Essex",
    "Meadow Woods",
    "Wheeling",
    "Carol Stream",
    "Oakley",
    "Columbia",
    "Coppell",
    "Reynoldsburg",
    "Addison",
    "Clinton",
    "Rock Island",
    "Park Ridge",
    "San Juan",
    "Carpentersville",
    "La Presa",
    "Fort Lee",
    "Waipahu",
    "Beloit",
    "Winter Springs",
    "Cottage Grove",
    "Pleasant Grove",
    "Hilliard",
    "Oregon City",
    "Clermont",
    "Owasso",
    "Evans",
    "Olive Branch",
    "Dunedin",
    "West Fargo",
    "East Meadow",
    "Kearns",
    "Hanover Park",
    "Martinez",
    "Lincoln Park",
    "Egypt Lake-Leto",
    "Moorpark",
    "Monrovia",
    "Menomonee Falls",
    "New Albany",
    "Oak Creek",
    "Richfield",
    "Elmont",
    "Calumet City",
    "Lewiston",
    "Oakville",
    "Bettendorf",
    "Roseville",
    "El Mirage",
    "La Vergne",
    "Oswego",
    "Buenaventura Lakes",
    "Watertown Town",
    "Shelton",
    "Menlo Park",
    "Del Rio",
    "Gahanna",
    "Wildomar",
    "San Juan Capistrano",
    "Tooele",
    "Post Falls",
    "La Porte",
    "Franklin",
    "Richmond",
    "Peachtree City",
    "Mount Juliet",
    "Temple City",
    "Claremont",
    "Bell",
    "Marion",
    "Norristown",
    "Chester",
    "Huntington Station",
    "San Dimas",
    "Fruit Cove",
    "Kaneohe",
    "Sun Prairie",
    "Montgomery Village",
    "Foster City",
    "Stow",
    "Torrington",
    "North Ridgeville",
    "Pleasant Hill",
    "Pullman",
    "Woodridge",
    "Springville",
    "Owings Mills",
    "Hinesville",
    "Long Beach",
    "Northbrook",
    "Georgetown",
    "Glendale Heights",
    "McMinnville",
    "Midvale",
    "Prairieville",
    "Lake Stevens",
    "Mason",
    "Brunswick",
    "Socorro",
    "Adelanto",
    "New City",
    "Oildale",
    "Richmond",
    "Princeton",
    "Bartlett",
    "Andover",
    "Lewiston",
    "Baldwin",
    "Bothell",
    "Copperas Cove",
    "Middletown",
    "El Dorado Hills",
    "Matthews",
    "Manitowoc",
    "Pueblo West",
    "East Honolulu",
    "Florence",
    "Pearl City",
    "Keller",
    "Potomac",
    "Walla Walla",
    "Titusville",
    "Farmington",
    "Fair Lawn",
    "Pekin",
    "Altamonte Springs",
    "Ashburn",
    "Rockwall",
    "Danville",
    "Concord",
    "Strongsville",
    "Altadena",
    "The Colony",
    "Ormond Beach",
    "Brea",
    "Urbandale",
    "Riverton",
    "Kyle",
    "North Miami Beach",
    "Fond du Lac",
    "Edmonds",
    "Urbana",
    "Farmers Branch",
    "Odenton",
    "Apache Junction",
    "Midland",
    "Beverly",
    "Trujillo Alto",
    "Spring Hill",
    "Annandale",
    "Greenacres",
    "North Fort Myers",
    "Westerville",
    "Annapolis",
    "Valrico",
    "Lancaster",
    "Security-Widefield",
    "Lynnwood",
    "Quincy",
    "Oviedo",
    "Bullhead City",
    "Issaquah",
    "Jefferson City",
    "San Gabriel",
    "Hutchinson",
    "New Berlin",
    "Lake Oswego",
    "Cape Girardeau",
    "Hobbs",
    "Mableton",
    "Orangevale",
    "Brookfield",
    "Duncanville",
    "Westfield",
    "Manhattan Beach",
    "Culver City",
    "Hot Springs",
    "Hurst",
    "Catonsville",
    "Danville",
    "Brighton",
    "Newnan",
    "Crystal Lake",
    "Sun City",
    "Stanton",
    "Mooresville",
    "Weslaco",
    "Milton",
    "La Puente",
    "Kendall West",
    "Portage",
    "Mechanicsville",
    "Commack",
    "Holly Springs",
    "Waxahachie",
    "South Miami Heights",
    "Foothill Farms",
    "Leavenworth",
    "Carrollwood",
    "Eagle Mountain",
    "Bartlesville",
    "Valley Stream",
    "Inver Grove Heights",
    "Muskogee",
    "East Point",
    "Grants Pass",
    "Rosenberg",
    "Aventura",
    "Merrillville",
    "Westmont",
    "Redan",
    "Monroe",
    "Riviera Beach",
    "Prattville",
    "Benton",
    "Cottonwood Heights",
    "Goshen",
    "Lebanon",
    "Richmond West",
    "Phenix City",
    "Kennesaw",
    "University City",
    "Martinez",
    "Cedar City",
    "Fairborn",
    "Plainfield",
    "Chillum",
    "Oakland Park",
    "Sayreville",
    "Germantown",
    "Indian Trail",
    "Coram",
    "Peachtree Corners",
    "Parkland",
    "Spanaway",
    "Dana Point",
    "The Acreage",
    "Warren",
    "Maplewood",
    "Wilkes-Barre",
    "Severna Park",
    "Cutler Bay",
    "Vineyard",
    "Englewood",
    "Sierra Vista",
    "Springfield",
    "Horizon West",
    "St. Charles",
    "Linton Hall",
    "Central Islip",
    "Plant City",
    "Deer Park",
    "Valparaiso",
    "Plainfield",
    "Pine Bluff",
    "Haltom City",
    "Burke",
    "Moorhead",
    "Schertz",
    "University Place",
    "Alabaster",
    "French Valley",
    "Tupelo",
    "Parkland",
    "Meridian",
    "Oakton",
    "Winchester",
    "Dakota Ridge",
    "Randallstown",
    "Greenfield",
    "Tucker",
    "West Hollywood",
    "DeLand",
    "Upper Arlington",
    "Merritt Island",
    "Biloxi",
    "Beverly Hills",
    "Douglasville",
    "Northglenn",
    "Puyallup",
    "Estero",
    "Belleville",
    "Vestavia Hills",
    "San Luis",
    "Salisbury",
    "Kearney",
    "Euclid",
    "Ken Caryl",
    "Fair Oaks",
    "Littleton",
    "Oro Valley",
    "Leawood",
    "Land O' Lakes",
    "Cleveland Heights",
    "Lauderdale Lakes",
    "Lufkin",
    "Prescott",
    "Huntsville",
    "Gadsden",
    "Pikesville",
    "Cooper City",
    "Garfield",
    "Uniondale",
    "North Olmsted",
    "Liberty",
    "Covington",
    "Eastpointe",
    "American Fork",
    "Cookeville",
    "Franklin Square",
    "South Riding",
    "Southlake",
    "Laguna Hills",
    "Graham",
    "Lawndale",
    "Woodlawn",
    "Kaysville",
    "Olney",
    "Fort Pierce",
    "Nacogdoches",
    "Elk Grove Village",
    "Golden Glades",
    "Helena",
    "Butte",
    "Savage",
    "Westlake",
    "La Verne",
    "Marrero",
    "Redmond",
    "Alamogordo",
    "Goldsboro",
    "Midlothian",
    "Goleta",
    "Wheat Ridge",
    "Bay Shore",
    "Fallbrook",
    "Bangor",
    "Clearfield",
    "Wildwood",
    "Mundelein",
    "Orcutt",
    "Centereach",
    "Long Branch",
    "Algonquin",
    "Gurnee",
    "Sterling",
    "Golden Gate",
    "Atascadero",
    "Fleming Island",
    "Saratoga Springs",
    "West Falls Church",
    "Santa Paula",
    "Gloucester",
    "Atwater",
    "Madison Heights",
    "Nicholasville",
    "Milford Mill",
    "Rahway",
    "Oceanside",
    "Syracuse",
    "San Carlos",
    "Walnut",
    "Naugatuck",
    "San Pablo",
    "Carney",
    "Cornelius",
    "Lawrenceville",
    "Hopkinsville",
    "Banning",
    "Fountain",
    "Burlingame",
    "Texarkana",
    "Fair Oaks",
    "Saratoga",
    "Westfield",
    "North Royalton",
    "Kahului",
    "North Tonawanda",
    "Parkville",
    "Middle River",
    "Crown Point",
    "Highland Park",
    "Chicago Heights",
    "East Palo Alto",
    "Seguin",
    "O'Fallon",
    "Suisun City",
    "Fortuna Foothills",
    "Oak Park",
    "Eagle Pass",
    "Jamestown",
    "Carlsbad",
    "Laplace",
    "Niles",
    "Port Chester",
    "Lake in the Hills",
    "Huntley",
    "Tualatin",
    "Bethany",
    "Ridgecrest",
    "Lansing",
    "East Chicago",
    "Aberdeen",
    "Drexel Hill",
    "Wasco",
    "Fuquay-Varina",
    "Immokalee",
    "Enterprise",
    "Middletown",
    "Benicia",
    "Oak Ridge",
    "Yukon",
    "Windsor",
    "Newark",
    "Burbank",
    "South Laurel",
    "Oak Forest",
    "Southgate",
    "Shirley",
    "Williamsport",
    "Casselberry",
    "Temescal Valley",
    "Frankfort",
    "Washington",
    "Englewood",
    "Melrose",
    "Glen Ellyn",
    "Mililani Town",
    "Henderson",
    "Millville",
    "Independence",
    "Eagle",
    "Paragould",
    "Summerlin South",
    "Converse",
    "Pahrump",
    "Kirkwood",
    "Morrisville",
    "Maywood",
    "New London",
    "Ramsey",
    "Glen Cove",
    "Norco",
    "Bixby",
    "Allen Park",
    "Magna",
    "Mason City",
    "Belmont",
    "McHenry",
    "Lindenhurst",
    "Colleyville",
    "Paramus",
    "Horn Lake",
    "Florence",
    "Hutto",
    "Mint Hill",
    "Chaska",
    "Bergenfield",
    "Garden City",
    "Maple Valley",
    "New Lenox",
    "Pearl",
    "Wooster",
    "Sanger",
    "West Linn",
    "Vernon Hills",
    "Leisure City",
    "Dodge City",
    "Lemon Grove",
    "Imperial Beach",
    "Garden City",
    "Wilmette",
    "Thomasville",
    "Erie",
    "Cabot",
    "Shoreview",
    "West Chicago",
    "West Islip",
    "Marshalltown",
    "Xenia",
    "Ewa Gentry",
    "Orchards",
    "Fremont",
    "Plainview",
    "Galt",
    "Barberton",
    "Medina",
    "Deer Park",
    "Sun City West",
    "Troy",
    "Terrytown",
    "Clinton",
    "Woodstock",
    "Woodburn",
    "Bay Point",
    "Muskego",
    "Haines City",
    "Lemoore",
    "Prosper",
    "Owatonna",
    "Cliffside Park",
    "Brawley",
    "West Whittier-Los Nietos",
    "Cave Spring",
    "South Pasadena",
    "Reedley",
    "Lafayette",
    "Palm City",
    "Mercer Island",
    "Ruskin",
    "Soledad",
    "Fountain Hills",
    "Lockport",
    "Starkville",
    "Salem",
    "Sachse",
    "Madison",
    "Ridgewood",
    "Tarpon Springs",
    "Kingsville",
    "Cloverleaf",
    "Neenah",
    "Oakdale",
    "Williston",
    "Melrose Park",
    "Kiryas Joel",
    "South Portland",
    "Hanahan",
    "Zanesville",
    "Laurel",
    "Watertown",
    "Socastee",
    "Austin",
    "El Cerrito",
    "Holbrook",
    "Timberwood Park",
    "De Pere",
    "Juneau",
    "Des Moines",
    "Greer",
    "Ladera Ranch",
    "Aiken",
    "Grandview",
    "Weatherford",
    "Harker Heights",
    "Wyandotte",
    "Shawnee",
    "Los Gatos",
    "West Little River",
    "Silver Springs Shores",
    "Dania Beach",
    "Spring Valley",
    "College Park",
    "Athens",
    "Belvidere",
    "Massillon",
    "Laramie",
    "Champlin",
    "Bethel Park",
    "Ferry Pass",
    "Woodstock",
    "Gillette",
    "Cleburne",
    "Sahuarita",
    "Cibolo",
    "LaGrange",
    "Petersburg",
    "Brooklyn Center",
    "Kingman",
    "Ithaca",
    "Danville",
    "Los Altos",
    "Spring Valley",
    "Garner",
    "Drexel Heights",
    "Ballwin",
    "Galesburg",
    "San Lorenzo",
    "Winter Park",
    "Opelika",
    "Bowling Green",
    "New Bern",
    "North Chicago",
    "Morristown",
    "East Niles",
    "Chamblee",
    "Sanford",
    "Maryland Heights",
    "Winona",
    "Twentynine Palms",
    "Big Spring",
    "Temple Terrace",
    "Stockbridge",
    "Austintown",
    "Kent",
    "New Iberia",
    "Gladstone",
    "Canton",
    "Shaker Heights",
    "Russellville",
    "New Smyrna Beach",
    "Easton",
    "Eureka",
    "Short Pump",
    "Franklin",
    "Garfield Heights",
    "Prior Lake",
    "Schererville",
    "White Bear Lake",
    "Eastern Goleta Valley",
    "Citrus Park",
    "Greenville",
    "Crofton",
    "Statesville",
    "Rexburg",
    "Bella Vista",
    "Oxford",
    "Forest Hills",
    "Ilchester",
    "Jacksonville",
    "Alvin",
    "Duluth",
    "Greenville",
    "Fridley",
    "Granite City",
    "Athens",
    "Mehlville",
    "Raytown",
    "Monroeville",
    "Rockledge",
    "Marion",
    "Bayonet Point",
    "Superior",
    "Brownsburg",
    "Daphne",
    "Batavia",
    "Sun City Center",
    "Coral Terrace",
    "McDonough",
    "Walker",
    "Balch Springs",
    "Columbine",
    "Miami Lakes",
    "Sebastian",
    "Stevens Point",
    "Granger",
    "Suitland",
    "Holladay",
    "Edgewood",
    "Tysons",
    "Paducah",
    "Rochester",
    "Lochearn",
    "Bel Air North",
    "Holt",
    "Homewood",
    "Rome",
    "Sherwood",
    "Asheboro",
    "Moscow",
    "Auburn",
    "Hercules",
    "University Park",
    "Bloomingdale",
    "Lakeside",
    "Statesboro",
    "Palm Springs",
    "South Salt Lake",
    "Mount Pleasant",
    "Maryville",
    "Lake Magdalene",
    "Edwardsville",
    "West Odessa",
    "North Tustin",
    "Princeton",
    "East Lake",
    "Bessemer",
    "Pasadena",
    "Burton",
    "Desert Hot Springs",
    "Monterey",
    "Central",
    "Chanhassen",
    "Green",
    "East Lake-Orient Park",
    "Perry Hall",
    "Marysville",
    "Caledonia",
    "Emporia",
    "Decatur",
    "Pooler",
    "Northampton",
    "Jeffersontown",
    "Ives Estates",
    "Fairland",
    "Hastings",
    "Denison",
    "Kernersville",
    "Forest Grove",
    "Reisterstown",
    "Lakewood Ranch",
    "Ardmore",
    "Zionsville",
    "Westmont",
    "Rosemount",
    "Fitchburg",
    "Plum",
    "Keystone",
    "Riverside",
    "Elk River",
    "Mount Pleasant",
    "Palm River-Clair Mel",
    "Oakleaf Plantation",
    "Sandusky",
    "Burlington",
    "East St. Louis",
    "Carrollton",
    "Clarksburg",
    "Canyon Lake",
    "Hazleton",
    "Mill Creek East",
    "Hazelwood",
    "Bainbridge Island",
    "Staunton",
    "Hobart",
    "Harrison",
    "SeaTac",
    "Northport",
    "North Laurel",
    "Rockville Centre",
    "Key West",
    "Ottumwa",
    "Homer Glen",
    "Collinsville",
    "Elmwood Park",
    "Arnold",
    "Farmington",
    "Dinuba",
    "Harvey",
    "Pelham",
    "Wilsonville",
    "Chantilly",
    "Freeport",
    "San Fernando",
    "Norfolk",
    "Avon Lake",
    "Okemos",
    "Derby",
    "Watauga",
    "Camas",
    "Inkster",
    "Somerset",
    "Calabasas",
    "North Platte",
    "Selma",
    "West Springfield",
    "Fort Dodge",
    "Allendale",
    "Kalispell",
    "Peekskill",
    "Candler-McAfee",
    "Dix Hills",
    "Wadsworth",
    "Auburn Hills",
    "Faribault",
    "Sugar Hill",
    "Ridgeland",
    "Port St. John",
    "Wekiwa Springs",
    "Fort Washington",
    "Brandon",
    "South Plainfield",
    "San Benito",
    "Lodi",
    "Forney",
    "Waverly",
    "Westchase",
    "Muscatine",
    "Zion",
    "Morton Grove",
    "Newberg",
    "Auburn",
    "Jacksonville Beach",
    "Rock Springs",
    "Willoughby",
    "Greenbelt",
    "Belton",
    "Taylors",
    "Hastings",
    "Herndon",
    "Rolling Meadows",
    "Columbus",
    "Moses Lake",
    "Eastmont",
    "Webster Groves",
    "Maywood",
    "The Crossings",
    "Oak Harbor",
    "Fresno",
    "Carteret",
    "Barstow",
    "Anthem",
    "Farmington",
    "Oxford",
    "Kerrville",
    "Van Buren",
    "Windsor",
    "Dickinson",
    "Bluffton",
    "Solon",
    "Kenmore",
    "Fort Hood",
    "Keene",
    "Carolina Forest",
    "Medford",
    "West Melbourne",
    "Kingston",
    "Lisle",
    "Millbrae",
    "Farragut",
    "Searcy",
    "Laguna Beach",
    "Blue Island",
    "Fish Hawk",
    "South Elgin",
    "Avon",
    "Kihei",
    "Roselle",
    "Machesney Park",
    "Allison Park",
    "Hayesville",
    "King of Prussia",
    "Middletown",
    "Lexington",
    "Valinda",
    "Bloomingdale",
    "Hopewell",
    "Christiansburg",
    "Greenfield",
    "New Brighton",
    "Mustang",
    "Mandan",
    "Munster",
    "Patterson",
    "Marina",
    "Hudson",
    "South Lake Tahoe",
    "Waynesboro",
    "Vega Baja",
    "Watertown",
    "East Peoria",
    "Junction City",
    "Shelbyville",
    "Gardner",
    "Garden City",
    "Highland",
    "Jasmine Estates",
    "Pace",
    "Lennox",
    "Darien",
    "Dolton",
    "Lincolnia",
    "Corcoran",
    "Belton",
    "Sunny Isles Beach",
    "East Patchogue",
    "Woodlawn",
    "Clinton",
    "Johnston",
    "Maple Heights",
    "Chester",
    "Nixa",
    "South Milwaukee",
    "Summit",
    "Arvin",
    "Bonney Lake",
    "Gallup",
    "Villa Park",
    "Mountlake Terrace",
    "Florida Ridge",
    "North Bellmore",
    "Brambleton",
    "Perrysburg",
    "Shenandoah",
    "South El Monte",
    "Covington",
    "South Holland",
    "Massapequa",
    "Pickerington",
    "Battle Ground",
    "Alliance",
    "Hazel Dell",
    "Arnold",
    "Kapolei",
    "Lorton",
    "Geneva",
    "Harvey",
    "La Porte",
    "Bellview",
    "Chillicothe",
    "Piqua",
    "Ramona",
    "Ashland",
    "Duarte",
    "Selden",
    "Birmingham",
    "Coralville",
    "Sedalia",
    "Hays",
    "Roselle",
    "Chambersburg",
    "Lebanon",
    "Mukilteo",
    "Milwaukie",
    "Raymore",
    "East Ridge",
    "Yucca Valley",
    "Mead Valley",
    "Dickinson",
    "DeBary",
    "Mountain House",
    "Bloomington",
    "Cudahy",
    "Oakdale",
    "Mokena",
    "North Salt Lake",
    "Park Forest",
    "Murphy",
    "Sidney",
    "Palisades Park",
    "Ellensburg",
    "Universal City",
    "Adrian",
    "Secaucus",
    "Ashland",
    "Suwanee",
    "Libertyville",
    "Wright",
    "Paris",
    "Palmetto Bay",
    "Oak Ridge",
    "Marquette",
    "Crestview",
    "Warrensburg",
    "Agoura Hills",
    "Forest Lake",
    "Lockport",
    "Conway",
    "Bayshore Gardens",
    "Mequon",
    "Riverbank",
    "Brookings",
    "Newport",
    "Saginaw",
    "Elko",
    "Norton Shores",
    "Clinton",
    "Grayslake",
    "Willowbrook",
    "Gardner",
    "Palm Valley",
    "Hillsborough",
    "Bailey's Crossroads",
    "Northfield",
    "West Memphis",
    "Ponca City",
    "Hialeah Gardens",
    "Lathrop",
    "Rosemont",
    "North Lynnwood",
    "Watertown",
    "Cockeysville",
    "Romulus",
    "Four Square Mile",
    "Clarksville",
    "Clayton",
    "Acworth",
    "Port Hueneme",
    "West Puente Valley",
    "Ruston",
    "Union Hill-Novelty Hill",
    "Duncan",
    "Jenks",
    "North Augusta",
    "Trussville",
    "Fort Walton Beach",
    "North Potomac",
    "Lino Lakes",
    "Fairfax",
    "Marshall",
    "Radcliff",
    "Griffin",
    "Roseburg",
    "Elkridge",
    "Vicksburg",
    "Benbrook",
    "Chalmette",
    "Corsicana",
    "West Carson",
    "Loves Park",
    "Cottage Lake",
    "Simpsonville",
    "Albertville",
    "Centerville",
    "Landover",
    "Tumwater",
    "Linda",
    "Monsey",
    "Greenwood",
    "Granite Bay",
    "Prairie Village",
    "Rose Hill",
    "Waukee",
    "Corinth",
    "Del City",
    "East San Gabriel",
    "Leland",
    "Hamtramck",
    "Fairhope",
    "Seal Beach",
    "Brent",
    "Cataño",
    "Winter Gardens",
    "Biddeford",
    "Bear",
    "Klamath Falls",
    "South Euclid",
    "St. Andrews",
    "Ballenger Creek",
    "Oxford",
    "Sapulpa",
    "Sanford",
    "Sun Valley",
    "Montclair",
    "Kuna",
    "East Moline",
    "Clemmons",
    "Rancho San Diego",
    "Ypsilanti",
    "Ferguson",
    "Sweetwater",
    "Clifton",
    "Cartersville",
    "Carrboro",
    "Eustis",
    "Holiday",
    "Easley",
    "Ensley",
    "Liberty Triangle",
    "Stephenville",
    "Merrick",
    "New Hope",
    "Green Valley",
    "Pleasant Prairie",
    "Lakeside",
    "Parsippany",
    "Bryant",
    "Trotwood",
    "Cherry Hill",
    "Apollo Beach",
    "Ashland",
    "Silver Firs",
    "South Bradenton",
    "Coronado",
    "Copiague",
    "Edgewater",
    "Northdale",
    "Evans",
    "La Cañada Flintridge",
    "Nogales",
    "Pittsburg",
    "Dixon",
    "Albany",
    "Happy Valley",
    "North Plainfield",
    "Camp Springs",
    "Bayou Cane",
    "West Pensacola",
    "Payson",
    "Lutz",
    "Columbia Heights",
    "Prunedale",
    "Crystal",
    "Glassboro",
    "South St. Paul",
    "Pascagoula",
    "Rocky River",
    "Pleasantville",
    "Frederickson",
    "Portsmouth",
    "Lomita",
    "Naples",
    "Plainview",
    "Rolla",
    "American Canyon",
    "Crest Hill",
    "East Hemet",
    "Venice",
    "Loma Linda",
    "McNair",
    "West Rancho Dominguez",
    "Golden Valley",
    "Rosamond",
    "Ozark",
    "Union City",
    "Miamisburg",
    "Ashland",
    "Martha Lake",
    "Lumberton",
    "Papillion",
    "Katy",
    "Charleston",
    "Ferndale",
    "Silverdale",
    "Columbus",
    "Lynn Haven",
    "Prichard",
    "Golden",
    "Fernley",
    "Lealman",
    "Mill Creek",
    "Tullahoma",
    "Arlington",
    "Oregon",
    "Ennis",
    "Fort Mill",
    "North Ogden",
    "Snellville",
    "Bartow",
    "Shafter",
    "Badger",
    "Horizon City",
    "Makakilo",
    "Midway",
    "Belle Glade",
    "Cumberland",
    "Willmar",
    "Louisville",
    "Mineola",
    "Hunters Creek",
    "Parma Heights",
    "Seymour",
    "Mililani Mauka",
    "Sherwood",
    "Bethany",
    "West Hempstead",
    "Old Jamestown",
    "Lynbrook",
    "Stillwater",
    "Fairwood",
    "Murray",
    "Norwood",
    "Five Corners",
    "Pinole",
    "Alamo",
    "Angleton",
    "Blythe",
    "Lake Zurich",
    "Boone",
    "Five Forks",
    "West St. Paul",
    "Painesville",
    "Brigham City",
    "Frankfort",
    "Jacksonville",
    "Sylvania",
    "Central Falls",
    "Saco",
    "Ronkonkoma",
    "Rosedale",
    "South San Jose Hills",
    "Farmington",
    "Highland",
    "Madisonville",
    "Affton",
    "Phelan",
    "Monroe",
    "Sherrelwood",
    "Liberal",
    "Morristown",
    "Arbutus",
    "Westbrook",
    "Seabrook",
    "Hawthorne",
    "Altoona",
    "Hermosa Beach",
    "Deerfield",
    "Ansonia",
    "Marion Oaks",
    "Berea",
    "North Bay Shore",
    "Carlisle",
    "Wallingford Center",
    "Ottawa",
    "Bourbonnais",
    "Valle Vista",
    "Alsip",
    "Syosset",
    "Bellaire",
    "Twinsburg",
    "Pinecrest",
    "Point Pleasant",
    "Alice",
    "Altamont",
    "Broadview Heights",
    "Nanuet",
    "Evergreen Park",
    "Shelbyville",
    "Onalaska",
    "Whitehall",
    "Bellwood",
    "McKeesport",
    "Newton",
    "North Liberty",
    "Orinda",
    "Lake Forest",
    "Stevenson Ranch",
    "New Castle",
    "Culpeper",
    "Rancho Mirage",
    "Durant",
    "Mayfield Heights",
    "Forest Park",
    "Cedar Mill",
    "Brookfield",
    "Holtsville",
    "Lake Shore",
    "Homewood",
    "Imperial",
    "Thomasville",
    "Creve Coeur",
    "Central Point",
    "Cortland",
    "Brook Park",
    "Winchester",
    "Fairmont",
    "Hurricane",
    "Harrison",
    "Springboro",
    "Cudahy",
    "Gibsonton",
    "Round Lake",
    "Newburyport",
    "Ashtabula",
    "Burlington",
    "Pecan Grove",
    "Rutherford",
    "Bethpage",
    "Hybla Valley",
    "Sheridan",
    "Niles",
    "Arcata",
    "Preakness",
    "McAlester",
    "Eastlake",
    "Menasha",
    "Bensenville",
    "St. Marys",
    "Castaic",
    "Nipomo",
    "El Dorado",
    "Bon Air",
    "Melville",
    "North Massapequa",
    "Spanish Lake",
    "Greenfield",
    "North Babylon",
    "Marion",
    "Godfrey",
    "Trenton",
    "White Settlement",
    "Amsterdam",
    "Jenison",
    "Sycamore",
    "Macomb",
    "Arroyo Grande",
    "Dumont",
    "Alton",
    "Canby",
    "Lackawanna",
    "Elmwood Park",
    "Safety Harbor",
    "Maitland",
    "Kingstowne",
    "Maumelle",
    "Tallmadge",
    "Lithia Springs",
    "Lake Butler",
    "Bay City",
    "Bryn Mawr-Skyway",
    "San Carlos Park",
    "Ocean Springs",
    "Wantagh",
    "Colonia",
    "Takoma Park",
    "Albert Lea",
    "Franklin Park",
    "Kirksville",
    "Marshfield",
    "Sudley",
    "Dover",
    "Burke Centre",
    "Santa Fe Springs",
    "Ferndale",
    "Lenoir",
    "Sartell",
    "Cary",
    "Zachary",
    "North Aurora",
    "Elizabeth City",
    "Maryland City",
    "Logansport",
    "Manassas Park",
    "Humacao",
    "Chowchilla",
    "Paradise",
    "Bostonia",
    "Ada",
    "Brownsville",
    "Centralia",
    "Anoka",
    "Wailuku",
    "Kingsland",
    "Hermiston",
    "New Philadelphia",
    "South Houston",
    "Parole",
    "Oswego",
    "Iselin",
    "Hinsdale",
    "Nederland",
    "Mattoon",
    "Colonial Heights",
    "Lindenwold",
    "Mount Pleasant",
    "Kinston",
    "Huntington",
    "Taylor",
    "Winder",
    "Avenel",
    "Tiffin",
    "Hannibal",
    "Siloam Springs",
    "Lebanon",
    "Clive",
    "Massapequa Park",
    "Palos Hills",
    "Estelle",
    "Lemont",
    "Perry",
    "Brenham",
    "Cocoa",
    "Vincennes",
    "Flowing Wells",
    "Pampa",
    "Port Angeles",
    "Hauppauge",
    "Augusta",
    "Middleton",
    "Montgomery",
    "Westminster",
    "Oroville",
    "Foley",
    "Englewood",
    "Salmon Creek",
    "Mesquite",
    "Franconia",
    "Lexington",
    "Shelby",
    "Sulphur",
    "Country Walk",
    "North Valley Stream",
    "Yorkville",
    "Calhoun",
    "Camano",
    "Matteson",
    "Haslett",
    "East Cleveland",
    "Germantown",
    "South Burlington",
    "Fox Crossing",
    "Lake Mary",
    "Bradfordville",
    "Coalinga",
    "North Amityville",
    "Tavares",
    "Forest Park",
    "Howard",
    "La Vista",
    "Meadowbrook",
    "Havelock",
    "Plattsburgh",
    "Springfield",
    "Langley Park",
    "East Northport",
    "La Crescenta-Montrose",
    "Willimantic",
    "Cimarron Hills",
    "Sand Springs",
    "Shorewood",
    "Anacortes",
    "Monroe",
    "Wade Hampton",
    "World Golf Village",
    "Franklin Farm",
    "Montrose",
    "Claremore",
    "Rosedale",
    "Rio Rico",
    "New Castle",
    "Durango",
    "West Mifflin",
    "Punta Gorda",
    "Scarsdale",
    "Brushy Creek",
    "Lake Ronkonkoma",
    "East Massapequa",
    "Orange",
    "Concord",
    "Cameron Park",
    "Steubenville",
    "Idylwood",
    "Gautier",
    "White Oak",
    "Marco Island",
    "Gretna",
    "Manchester",
    "Hyattsville",
    "Wisconsin Rapids",
    "Hopkins",
    "Oxon Hill",
    "Palestine",
    "North Canton",
    "Fayetteville",
    "St. Matthews",
    "Brownwood",
    "Selma",
    "West Columbia",
    "Beltsville",
    "Altus",
    "Midlothian",
    "Laurel",
    "Avon",
    "Portland",
    "Eloy",
    "Laurel",
    "Radford",
    "Clemson",
    "St. Michael",
    "Sunland Park",
    "South Ogden",
    "Ashwaubenon",
    "Poplar Bluff",
    "Vero Beach",
    "Oak Grove",
    "Pinewood",
    "Ocean Acres",
    "Woodmere",
    "Otsego",
    "Schofield Barracks",
    "Buckhall",
    "Terrell",
    "Murrysville",
    "Damascus",
    "Redland",
    "North Druid Hills",
    "Bothell West",
    "Seminole",
    "Stafford",
    "Merrifield",
    "Palmview",
    "Centerville",
    "Woodcrest",
    "Norcross",
    "Cinco Ranch",
    "Cutlerville",
    "Tinton Falls",
    "Casa de Oro-Mount Helix",
    "Myrtle Grove",
    "Glenvar Heights",
    "Wayne",
    "Mountain Brook",
    "Norwalk",
    "Troy",
    "West Chester",
    "Erlanger",
    "Oconomowoc",
    "Lansdale",
    "Bristol",
    "Milledgeville",
    "Martinsburg",
    "El Reno",
    "Natchitoches",
    "Tillmans Corner",
    "Tukwila",
    "Tifton",
    "Calverton",
    "Sevierville",
    "Phoenixville",
    "Upper Grand Lagoon",
    "Boerne",
    "Johnstown",
    "St. John",
    "Knik-Fairview",
    "Danville",
    "Baldwin",
    "Knightdale",
    "Farmingville",
    "Defiance",
    "Seagoville",
    "Clayton",
    "Bull Run",
    "Vienna",
    "Pendleton",
    "Dallas",
    "McKinleyville",
    "Lemay",
    "Waterville",
    "Highland Village",
    "Easton",
    "Troutdale",
    "Artesia",
    "Hazel Park",
    "Sikeston",
    "Streetsboro",
    "Steiner Ranch",
    "Mount Vernon",
    "El Segundo",
    "Washington",
    "Hillcrest Heights",
    "Ham Lake",
    "Palmetto Estates",
    "Sunnyside",
    "Menomonie",
    "Morganton",
    "Camp Pendleton South",
    "Opelousas",
    "Aberdeen",
    "Madison",
    "Buda",
    "Mercedes",
    "Buffalo",
    "Country Club Hills",
    "Laconia",
    "Truckee",
    "Beckley",
    "Hibbing",
    "Boulder City",
    "Lake St. Louis",
    "Aurora",
    "Port Washington",
    "Shelbyville",
    "Roosevelt",
    "Pinehurst",
    "Ripon",
    "Floral Park",
    "Parkway",
    "Fort Thomas",
    "Mount Clemens",
    "Los Osos",
    "Fairview Heights",
    "Chickasha",
    "Harrisburg",
    "Griffith",
    "New Milford",
    "Cañon City",
    "Waxhaw",
    "Live Oak",
    "Westchester",
    "Opa-locka",
    "Cherryland",
    "Glassmanor",
    "Washougal",
    "Lebanon",
    "Wahiawa",
    "Donna",
    "Adelphi",
    "Heber",
    "Laguna Woods",
    "Kaukauna",
    "Walnut Park",
    "Kings Park",
    "Dyer",
    "Cohoes",
    "Rio Linda",
    "Crawfordsville",
    "Crowley",
    "Prospect Heights",
    "Sulphur Springs",
    "Brunswick",
    "Murraysville",
    "Fairview Park",
    "Uvalde",
    "South Venice",
    "Somerton",
    "Fremont",
    "Center Point",
    "Tahlequah",
    "Fort Mohave",
    "Beaver Dam",
    "Dyersburg",
    "Ukiah",
    "Albemarle",
    "Helena",
    "Grandville",
    "Sayville",
    "Bellmore",
    "Discovery Bay",
    "South River",
    "Villa Rica",
    "Warrington",
    "North Arlington",
    "Morton",
    "Isla Vista",
    "River Falls",
    "Lady Lake",
    "La Palma",
    "Shively",
    "Mastic Beach",
    "Pataskala",
    "Mitchell",
    "West University Place",
    "Longwood",
    "Fillmore",
    "Hermitage",
    "Niceville",
    "Elkton",
    "The Dalles",
    "Aberdeen",
    "Mebane",
    "Stallings",
    "Payson",
    "Dentsville",
    "Grosse Pointe Woods",
    "Hot Springs Village",
    "Jasper",
    "Bridgeview",
    "La Grange",
    "Ocean Pointe",
    "Dublin",
    "Wilmington Island",
    "Coto de Caza",
    "Berkley",
    "Glenmont",
    "Hueytown",
    "Depew",
    "Kenmore",
    "Hartford",
    "Chubbuck",
    "Clearlake",
    "Candelaria",
    "Weston",
    "Asbury Park",
    "Seaford",
    "Eden",
    "Bemidji",
    "Olivehurst",
    "Goodlettsville",
    "Ramsey",
    "Hugo",
    "Bellair-Meadowbrook Terrace",
    "Talladega",
    "St. Simons",
    "Laurinburg",
    "Bellevue",
    "Wilkinsburg",
    "Great Bend",
    "Middleburg Heights",
    "Fullerton",
    "Powder Springs",
    "Newport",
    "Ladson",
    "New Cassel",
    "Brooklyn Park",
    "Front Royal",
    "Bay Village",
    "Newton",
    "Welby",
    "Clarksdale",
    "Seymour",
    "Hayden",
    "Dickson",
    "Jackson",
    "West Haven",
    "Stone Ridge",
    "Rutland",
    "Pacific Grove",
    "Alpine",
    "Los Lunas",
    "Worthington",
    "East Rancho Dominguez",
    "Westbury",
    "Long Beach",
    "West Park",
    "Kerman",
    "Henderson",
    "Susanville",
    "Dixon",
    "Lemon Hill",
    "Frankfort",
    "Groves",
    "Three Lakes",
    "Sun Lakes",
    "Eggertsville",
    "Sunset",
    "Jacksonville",
    "South Farmingdale",
    "Bluffdale",
    "Sterling",
    "Grovetown",
    "Gloversville",
    "Natchez",
    "Kilgore",
    "Whitewater",
    "Mount Vernon",
    "Hewitt",
    "Carthage",
    "Mount Washington",
    "Lynden",
    "Oldsmar",
    "Lebanon",
    "Tonawanda",
    "Bradley Gardens",
    "Hobe Sound",
    "Callaway",
    "Hereford",
    "Hampton Bays",
    "Fort Leonard Wood",
    "Jennings",
    "Ferndale",
    "Tenafly",
    "Spring Creek",
    "Destin",
    "Yankton",
    "Fraser",
    "Livingston",
    "Scottsbluff",
    "Roanoke Rapids",
    "Moraga",
    "Corinth",
    "Morris",
    "Live Oak",
    "Sterling",
    "Fort Hunt",
    "Beeville",
    "New Port Richey",
    "Antioch",
    "Johnson City",
    "Rio Grande City",
    "Greensburg",
    "Coos Bay",
    "Robbinsdale",
    "New River",
    "Metuchen",
    "Norridge",
    "Sharonville",
    "Johnstown",
    "La Marque",
    "Ammon",
    "Four Corners",
    "East Milton",
    "Red Wing",
    "Southchase",
    "West Lealman",
    "Summerfield",
    "Falls Church",
    "Vincent",
    "Colesville",
    "Nocatee",
    "Pearl River",
    "Storrs",
    "East Highland Park",
    "Fort Carson",
    "Seven Oaks",
    "Alexander City",
    "Glasgow",
    "Hartselle",
    "Mill Valley",
    "Lindenhurst",
    "Cayey",
    "Hickory Hills",
    "Paradise Valley",
    "Gainesville",
    "Owosso",
    "Ozark",
    "Wolf Trap",
    "Phillipsburg",
    "Gainesville",
    "Calera",
    "Red Hill",
    "Mountain Home",
    "Douglas",
    "Midlothian",
    "Saraland",
    "Batavia",
    "East Riverdale",
    "Fort Campbell North",
    "Ojus",
    "Grain Valley",
    "Northview",
    "Indianola",
    "Millbrook",
    "Stanford",
    "Sierra Vista Southeast",
    "Buford",
    "Rossville",
    "Hope Mills",
    "Fairburn",
    "Traverse City",
    "Warsaw",
    "New Haven",
    "Centerton",
    "Lakeway",
    "Cloverly",
    "Addison",
    "Humble",
    "Parlier",
    "Canyon",
    "Glasgow",
    "Clarksburg",
    "Riverdale",
    "Mineral Wells",
    "Elk Plain",
    "Greenwood Village",
    "North Decatur",
    "Americus",
    "Tanque Verde",
    "Bradley",
    "Groveland",
    "Salida",
    "Azalea Park",
    "Overland",
    "Beech Grove",
    "Graham",
    "Spanish Springs",
    "Colonial Park",
    "North New Hyde Park",
    "Salem Lakes",
    "Greenlawn",
    "Greendale",
    "Greeneville",
    "Gantt",
    "Stuart",
    "Olympia Heights",
    "Cullman",
    "Hawaiian Gardens",
    "California",
    "Thonotosassa",
    "White Oak",
    "Scottsboro",
    "Thibodaux",
    "Belvedere Park",
    "North Auburn",
    "Fate",
    "Vandalia",
    "Piney Green",
    "Anna",
    "Dayton",
    "Jamestown",
    "Lamont",
    "Hollins",
    "Anderson Creek",
    "Southern Pines",
    "Gonzalez",
    "Mastic",
    "Weigelstown",
    "White Center",
    "Flower Hill",
    "Republic",
    "Glen Allen",
    "Lake Stickney",
    "Hershey",
    "Mount Dora",
    "Port Orchard",
    "West Richland",
    "Groveton",
    "Conyers",
    "Highland Springs",
    "Princeton Meadows",
    "Kemp Mill",
    "Chippewa Falls",
    "Muscle Shoals",
    "Hopatcong",
    "Williamstown",
    "Washington Court House",
    "North Myrtle Beach",
    "Luling",
    "Franklin Park",
    "Berea",
    "Aldine",
    "Great Falls",
    "College Park",
    "Villas",
    "North Fair Oaks",
    "Lake Wales",
    "Berea",
    "Lockhart",
    "Fairview",
    "Mount Holly",
    "Broadlands",
    "Youngsville",
    "West Freehold",
    "Miami Springs",
    "Swansea",
    "Auburn",
    "East Wenatchee",
    "Sun Village",
    "Forrest City",
    "Kings Park West",
    "Washington",
    "Red Bluff",
    "Springdale",
    "Willowick",
    "Dumas",
    "Bloomsburg",
    "Hidalgo",
    "Havre de Grace",
    "Greenwood",
    "Oneonta",
    "Deming",
    "Chicago Ridge",
    "Jericho",
    "Circleville",
    "Oak Park",
    "Alamo",
    "Andrews",
    "Chesterton",
    "Vail",
    "Hazel Crest",
    "Forest Park",
    "Sauk Rapids",
    "Athens",
    "King City",
    "Pierre",
    "Royse City",
    "Marshall",
    "Wauconda",
    "Auburndale",
    "Andover",
    "Ridge",
    "Loveland",
    "Roselle Park",
    "California City",
    "Wood Dale",
    "Lockhart",
    "Shepherdsville",
    "Reidsville",
    "Maumee",
    "Grimes",
    "Olean",
    "Covington",
    "Cahokia",
    "North Mankato",
    "Hudson",
    "Palmetto",
    "Blytheville",
    "River Ridge",
    "Monticello",
    "St. Helens",
    "Short Hills",
    "Lincoln",
    "Middlesex",
    "Seabrook",
    "Hammonton",
    "Highland Park",
    "Brookside",
    "Atlantic Beach",
    "Royal Kunia",
    "Pottsville",
    "Ephrata",
    "McMinnville",
    "Waimalu",
    "Lakeland North",
    "Harper Woods",
    "Snoqualmie",
    "Jensen Beach",
    "Artondale",
    "Alexandria",
    "Bay St. Louis",
    "Bexley",
    "Beacon",
    "Iona",
    "D'Iberville",
    "Moberly",
    "Palmer Ranch",
    "Fruita",
    "Levelland",
    "Chaparral",
    "Ewa Beach",
    "Moorestown-Lenola",
    "Marietta",
    "Hutchinson",
    "Waunakee",
    "Brandermill",
    "Canton",
    "Wixom",
    "St. James",
    "Huntington",
    "Hernando",
    "Sault Ste. Marie",
    "Brecksville",
    "Gladeview",
    "Lake Forest Park",
    "Grover Beach",
    "Carpinteria",
    "Mount Vernon",
    "Huron",
    "Bellefontaine",
    "Moss Point",
    "Shorewood",
    "Powell",
    "Dardenne Prairie",
    "Palos Verdes Estates",
    "Washington",
    "New Providence",
    "La Grande",
    "Kettering",
    "Bedford",
    "Richmond Hill",
    "Yulee",
    "Auburn",
    "Brainerd",
    "Lyndhurst",
    "Claremont",
    "North Adams",
    "Sharon",
    "Woodinville",
    "Trenton",
    "Baker",
    "Annapolis Neck",
    "La Grange Park",
    "Stoughton",
    "McPherson",
    "Los Alamos",
    "Western Springs",
    "Irondale",
    "Glenn Heights",
    "Willow Grove",
    "Lahaina",
    "Portland",
    "Marshall",
    "El Dorado",
    "Mounds View",
    "North Palm Beach",
    "Oakland",
    "Lumberton",
    "University Heights",
    "Butler",
    "El Sobrante",
    "Key Biscayne",
    "San Marino",
    "Plover",
    "South Daytona",
    "Rantoul",
    "Fort Lewis",
    "Verona",
    "New Kingman-Butler",
    "McFarland",
    "Newton",
    "Azle",
    "Edgewater",
    "Red Oak",
    "Jupiter Farms",
    "Lexington Park",
    "Connersville",
    "Worthington",
    "Ocean Pines",
    "Fostoria",
    "Coatesville",
    "New Carrollton",
    "Rogers",
    "Warrenville",
    "Miami",
    "Rochester",
    "Dorado",
    "Harrison",
    "Las Vegas",
    "Steamboat Springs",
    "Superior",
    "Powell",
    "Sarasota Springs",
    "Bardstown",
    "Chatham",
    "Waianae",
    "New Ulm",
    "Davidson",
    "Ridgefield Park",
    "Fergus Falls",
    "Cedar Lake",
    "Grass Valley",
    "Jacksonville",
    "Joppatowne",
    "Lindsay",
    "Kingston",
    "Cornelius",
    "Dover",
    "Cypress Lake",
    "Lilburn",
    "Geneva",
    "McComb",
    "East Islip",
    "Clarkston",
    "Crowley",
    "Greenville",
    "Smithfield",
    "Wickliffe",
    "Endicott",
    "Verde Village",
    "Lakeside",
    "Harrison",
    "Manorville",
    "Meadville",
    "St. Ann",
    "Trinity",
    "Echelon",
    "Fulton",
    "Port Neches",
    "Martinsville",
    "Salisbury",
    "Lakeland Village",
    "Fernandina Beach",
    "Lake Wylie",
    "North St. Paul",
    "Markham",
    "Troy",
    "Patchogue",
    "New Baltimore",
    "Gardendale",
    "Bayou Blue",
    "Artesia",
    "Halawa",
    "Centralia",
    "Fort Payne",
    "Woodhaven",
    "Allouez",
    "Hockessin",
    "Maili",
    "Viera West",
    "Whitefish Bay",
    "Boone",
    "Mountain Home",
    "Conneaut",
    "Winnetka",
    "Streator",
    "San Anselmo",
    "Pineville",
    "Miller Place",
    "Fruitville",
    "Sugarland Run",
    "Georgetown",
    "Wells Branch",
    "Pell City",
    "New Kensington",
    "Moultrie",
    "St. Marys",
    "Lincolnwood",
    "Fords",
    "Goldenrod",
    "Choctaw",
    "Palos Heights",
    "Half Moon Bay",
    "Cheney",
    "Tamalpais-Homestead Valley",
    "Lakewood Park",
    "Loganville",
    "Riverdale",
    "Borger",
    "Vinings",
    "Lakeland",
    "Fort Atkinson",
    "Justice",
    "Middleburg",
    "Glen Carbon",
    "Newington Forest",
    "Marysville",
    "Grand Terrace",
    "Marion",
    "Wilmington",
    "Lewisville",
    "Derby",
    "Kewanee",
    "Bedford",
    "Washington",
    "Grenada",
    "Bridgetown",
    "Dallas",
    "Lake Arbor",
    "Federal Heights",
    "Holly Springs",
    "Vadnais Heights",
    "Forest City",
    "Soddy-Daisy",
    "Celina",
    "Oatfield",
    "Warrensville Heights",
    "Richton Park",
    "Channahon",
    "Shiloh",
    "Henderson",
    "Indiana",
    "Lebanon",
    "Lone Tree",
    "Elizabethton",
    "Chelsea",
    "Santa Fe",
    "Firestone",
    "Glenpool",
    "Teays Valley",
    "Bothell East",
    "Conway",
    "Ardmore",
    "Mountain Park",
    "Englewood",
    "Monroe",
    "West Carrollton",
    "Avenal",
    "Monroe",
    "Jefferson Valley-Yorktown",
    "Herrin",
    "Timberlake",
    "Bensville",
    "Lakeland South",
    "Wilton Manors",
    "Elfers",
    "Dunmore",
    "Panama City Beach",
    "Gulf Shores",
    "Gulfport",
    "Orangeburg",
    "Clayton",
    "Westmont",
    "Black Forest",
    "Riviera Beach",
    "Bonita",
    "Big Bear City",
    "Glenn Dale",
    "Coolidge",
    "Beaufort",
    "Forest Hill",
    "North Valley",
    "Hendersonville",
    "Lansdowne",
    "Monfort Heights",
    "Port Royal",
    "Rocky Point",
    "College",
    "Gatesville",
    "Gaffney",
    "Newington",
    "Montgomeryville",
    "Cayce",
    "Fort Bliss",
    "Blue Ash",
    "Larkspur",
    "Lake Norman of Catawba",
    "Commerce",
    "West Monroe",
    "Leeds",
    "Tehachapi",
    "Moody",
    "East Renton Highlands",
    "Avocado Heights",
    "Urbana",
    "Athens",
    "Richmond",
    "New Franklin",
    "Green Valley",
    "Waycross",
    "Franklin Park",
    "Suamico",
    "Mercerville",
    "Nesconset",
    "Beach Park",
    "Latham",
    "Solana Beach",
    "Jasper",
    "Rendon",
    "Glendale",
    "Fort Drum",
    "South Charleston",
    "Finneytown",
    "Fairfax Station",
    "Irmo",
    "South Sioux City",
    "Ottawa",
    "Effingham",
    "Canóvanas",
    "Naranja",
    "Waconia",
    "Beatrice",
    "Río Grande",
    "West Plains",
    "Belmont",
    "Cambridge",
    "Santaquin",
    "Malibu",
    "Carnot-Moon",
    "Holly Hill",
    "White House",
    "Woodward",
    "Northlake",
    "Minneola",
    "Amherst",
    "Cottonwood",
    "Poquoson",
    "Valencia West",
    "Broussard",
    "Mays Chapel",
    "Baraboo",
    "Fortuna",
    "Freeport",
    "Manatí",
    "Lake Tapps",
    "Orange City",
    "Clawson",
    "Coldwater",
    "Kingsburg",
    "East Grand Rapids",
    "Lantana",
    "Garden City",
    "Cloquet",
    "Gold Canyon",
    "Martinsville",
    "Macedonia",
    "Green River",
    "Elon",
    "Sedro-Woolley",
    "Cascades",
    "Riverview",
    "Festus",
    "Escanaba",
    "Enumclaw",
    "Myrtle Grove",
    "Stony Brook",
    "Weatherford",
    "Webb City",
    "Canton",
    "Minden",
    "Healdsburg",
    "Somersworth",
    "Shady Hills",
    "Claiborne",
    "Franklin",
    "Somerville",
    "Laurel",
    "North Merrick",
    "Delhi",
    "Eufaula",
    "Dunkirk",
    "Lewisburg",
    "Madison",
    "Norton",
    "Lake Station",
    "Middle Valley",
    "St. Peter",
    "Alum Rock",
    "Dranesville",
    "Platteville",
    "Red Bank",
    "Mendota",
    "Jerome",
    "Trophy Club",
    "Abbeville",
    "Fuller Heights",
    "Scotts Valley",
    "Blackfoot",
    "James Island",
    "Rossmoor",
    "Princeton",
    "Holiday City-Berkeley",
    "Bucyrus",
    "Hasbrouck Heights",
    "Neosho",
    "Pecos",
    "Westview",
    "Brookhaven",
    "Ringwood",
    "Cheval",
    "Port Lavaca",
    "Hillcrest",
    "Union",
    "Port Salerno",
    "Cherry Hill Mall",
    "Arkansas City",
    "Portales",
    "El Campo",
    "Grafton",
    "Emeryville",
    "Smyrna",
    "Excelsior Springs",
    "Salem",
    "Evanston",
    "Oskaloosa",
    "Cocoa Beach",
    "Largo",
    "Smithfield",
    "Bogalusa",
    "Seven Hills",
    "Oak Ridge",
    "Manor",
    "Mountain Top",
    "Clute",
    "Winton",
    "Jefferson",
    "Wyandanch",
    "Lakeland Highlands",
    "Wyndham",
    "Hillsborough",
    "Clayton",
    "Maryville",
    "Beachwood",
    "Destrehan",
    "Forestville",
    "Sandy",
    "Lighthouse Point",
    "Lawrenceburg",
    "Emmaus",
    "Burkburnett",
    "Urbana",
    "Los Alamitos",
    "Minnehaha",
    "Tarrytown",
    "Manvel",
    "Summerfield",
    "Magnolia",
    "Campbellsville",
    "Waupun",
    "Stuarts Draft",
    "River Edge",
    "Wallington",
    "Peru",
    "Endwell",
    "Nanakuli",
    "Chino Valley",
    "Bacliff",
    "Lovington",
    "Cedarburg",
    "Gloucester City",
    "Camp Verde",
    "Hudson",
    "Newport East",
    "Beachwood",
    "Upper Montclair",
    "Woods Cross",
    "Hormigueros",
    "Valley Center",
    "Lowes Island",
    "Wakefield",
    "Signal Hill",
    "Pontiac",
    "Pearsall",
    "Fort Meade",
    "Guymon",
    "Mexico",
    "Ravenna",
    "Gardnerville Ranchos",
    "Elk City",
    "Selma",
    "Terryville",
    "Newman",
    "Moncks Corner",
    "Branson",
    "Muscoy",
    "Glen Rock",
    "Schiller Park",
    "Roma",
    "Show Low",
    "Guthrie",
    "Elizabethtown",
    "Fort Morgan",
    "Grantsville",
    "Fenton",
    "Fredericksburg",
    "Yeadon",
    "Cherry Creek",
    "Greensburg",
    "Milford",
    "Valley Falls",
    "Madison Heights",
    "Bellmawr",
    "Guttenberg",
    "Gladstone",
    "Snyder",
    "Robstown",
    "Ridgefield",
    "Fulton",
    "Goulds",
    "Lower Burrell",
    "Niles",
    "Springdale",
    "Ionia",
    "Summit",
    "Pebble Creek",
    "Westwood Lakes",
    "Big Lake",
    "La Homa",
    "Sonoma",
    "New Albany",
    "Westwood",
    "Lincolnton",
    "Minooka",
    "Plano",
    "Coamo",
    "Celebration",
    "Grosse Pointe Park",
    "Lindon",
    "Forest",
    "Two Rivers",
    "Lake Grove",
    "Franklin Lakes",
    "Hawaiian Paradise Park",
    "Heath",
    "Progress",
    "Picayune",
    "Pompton Lakes",
    "Eatontown",
    "Kings Mountain",
    "Santa Clara",
    "West Point",
    "Lawrenceburg",
    "Tucson Estates",
    "Waynesboro",
    "Raceland",
    "Ontario",
    "Placerville",
    "Munhall",
    "Fulshear",
    "Gonzales",
    "Damascus",
    "River Forest",
    "Camden",
    "Highland Park",
    "Asbury Lake",
    "Tega Cay",
    "Farmersville",
    "Viera East",
    "Vermillion",
    "Malvern",
    "Spencer",
    "Riverton",
    "Manchester",
    "Lanham",
    "Leon Valley",
    "Yazoo City",
    "Shiloh",
    "Castle Pines",
    "Parker",
    "Potomac Park",
    "Bainbridge",
    "Coshocton",
    "Waimea",
    "Sturgis",
    "Kelso",
    "Middle Island",
    "Waggaman",
    "New Baltimore",
    "Rockport",
    "Poulsbo",
    "Dobbs Ferry",
    "Sierra Madre",
    "Suffern",
    "Oneida",
    "Raymondville",
    "North Logan",
    "Lake City",
    "Woodmere",
    "Braselton",
    "Saddlebrooke",
    "Tarboro",
    "DeRidder",
    "Sylacauga",
    "Ocean City",
    "Bolivar",
    "Speedway",
    "Mount Kisco",
    "Morgan City",
    "Sussex",
    "Satellite Beach",
    "Totowa",
    "Burlington",
    "Oak Grove",
    "McCalla",
    "Okmulgee",
    "Brown Deer",
    "Edgewood",
    "Lake Los Angeles",
    "South Miami",
    "Home Gardens",
    "Florida City",
    "Lansing",
    "Winfield",
    "Hamilton Square",
    "North Wantagh",
    "Florham Park",
    "Crestwood",
    "La Riviera",
    "Red Bank",
    "Port Washington",
    "Prairie Ridge",
    "Tucson Mountains",
    "Tomball",
    "Shiloh",
    "Roessleville",
    "Oak Hills",
    "Robinson",
    "Bridgeton",
    "Honeygo",
    "Arlington",
    "On Top of the World Designated Place",
    "Rosaryville",
    "Somerset",
    "Jefferson Hills",
    "Crossville",
    "Spring Lake",
    "Travilah",
    "Berkley",
    "Canyon Lake",
    "Norwalk",
    "Pasadena Hills",
    "Dent",
    "Mango",
    "Elwood",
    "Caño Martin Peña",
    "University of California-Santa Barbara",
    "Grand Haven",
    "Douglas",
    "Mendota Heights",
    "Halfway",
    "Robertsville",
    "Manchester",
    "North Lindenhurst",
    "Scottdale",
    "Accokeek",
    "Montgomery",
    "View Park-Windsor Hills",
    "The Hills",
    "Magalia",
    "Garden City",
    "Maltby",
    "Brock Hall",
    "Collegedale",
    "Four Corners",
    "Lyndon",
    "Haysville",
    "Grandview",
    "Campton Hills",
    "Doctor Phillips",
    "Spearfish",
    "Galena Park",
    "Merriam",
    "Fairview",
    "Hartsville",
    "Cleveland",
    "Overlea",
    "Yorktown",
    "Pine Castle",
    "East Glenville",
    "Wanaque",
    "Mitchellville",
    "Archdale",
    "Byram",
    "Diamond Springs",
    "Union Park",
    "Harrison",
    "Lake Morton-Berrydale",
    "Highland City",
    "Little Chute",
    "Brooklyn",
    "Piedmont",
    "Mack",
    "Town and Country",
    "Burtonsville",
    "Richfield",
    "Martinsville",
    "Webster",
    "Medulla",
    "East Bethel",
    "Pike Creek Valley",
    "Weddington",
    "Grand Rapids",
    "Bellmead",
    "Waihee-Waiehu",
    "Batesville",
    "Ironton",
    "Pleasanton",
    "Muskegon Heights",
    "Little Ferry",
    "Essex Junction",
    "Crestwood",
    "Darby",
    "Burr Ridge",
    "Cold Springs",
    "Waipio",
    "Fair Oaks Ranch",
    "Columbia",
    "Fairfield",
    "Memphis",
    "East Liverpool",
    "Corning",
    "Lansdowne",
    "Monroe",
    "Roscoe",
    "Isabela",
    "Comstock Park",
    "Vidor",
    "Timonium",
    "Bedford Heights",
    "Alpine",
    "Little Canada",
    "Gateway",
    "Wasilla",
    "Marinette",
    "Mount Sinai",
    "Broomall",
    "West Vero Corridor",
    "Burley",
    "Tanaina",
    "Sedona",
    "Monmouth",
    "Atchison",
    "Cottage Grove",
    "Sweetwater",
    "Van Wert",
    "Cordele",
    "West Point",
    "Oregon",
    "Triangle",
    "Jackson",
    "Beverly Hills",
    "Bluffton",
    "Amelia",
    "Melvindale",
    "Anderson",
    "Morro Bay",
    "Fife",
    "Richmond Heights",
    "Cadillac",
    "Vermilion",
    "Big Rapids",
    "Kearney",
    "Union City",
    "Columbia",
    "Shelton",
    "Pompton Plains",
    "Storm Lake",
    "River Road",
    "Avon Park",
    "Cape Canaveral",
    "Fredonia",
    "Silverton",
    "Covington",
    "Greencastle",
    "Portage",
    "Sauk Village",
    "Celina",
    "Barrington",
    "Lake Monticello",
    "Oak Hills",
    "Vernal",
    "Waterloo",
    "Danville",
    "Blackhawk",
    "Moss Bluff",
    "Petal",
    "Vidalia",
    "Prineville",
    "Hillsdale",
    "Cambridge",
    "Palatka",
    "Exeter",
    "Martin",
    "Ogdensburg",
    "Quartz Hill",
    "Vashon",
    "Jacinto City",
    "Fort Madison",
    "Worth",
    "Timberlane",
    "Newcastle",
    "Bonham",
    "Smithville",
    "Bee Ridge",
    "Jefferson",
    "Bound Brook",
    "Reading",
    "Troy",
    "Pella",
    "East Bakersfield",
    "Mount Airy",
    "Newberry",
    "Rincon",
    "Cedar Hills",
    "Belle Chasse",
    "Sumner",
    "Vienna",
    "Lincoln Park",
    "Milton",
    "Elgin",
    "Sabana Grande",
    "Manville",
    "London",
    "Browns Mills",
    "Keokuk",
    "Shasta Lake",
    "Bel Air",
    "Kinnelon",
    "Westgate",
    "Lantana",
    "Holmen",
    "Capitola",
    "Boiling Springs",
    "Waverly",
    "La Cresta",
    "Blacklick Estates",
    "Winterville",
    "Lambertville",
    "East Stroudsburg",
    "Waynesville",
    "Somers Point",
    "Golden Hills",
    "Orange Cove",
    "Pleasant Hill",
    "Scaggsville",
    "South Huntington",
    "Linthicum",
    "Vernon",
    "Garden Acres",
    "Watervliet",
    "Purcellville",
    "Clinton",
    "Tipp City",
    "Madera Acres",
    "Berlin",
    "Linganore",
    "Marina del Rey",
    "Snohomish",
    "Cedartown",
    "River Grove",
    "St. Albans",
    "Lexington",
    "The Pinery",
    "Elkhorn",
    "Flat Rock",
    "Friendly",
    "East Whittier",
    "Red Bank",
    "Highland",
    "Rotonda",
    "Galion",
    "Waldwick",
    "Ventnor City",
    "Plymouth",
    "Alpena",
    "Paris",
    "Struthers",
    "Brandon",
    "Harrisonville",
    "Wabash",
    "Fountain Inn",
    "Panthersville",
    "Makaha",
    "Berwick",
    "Meadowbrook",
    "Charter Oak",
    "Kapaa",
    "Chalco",
    "Española",
    "Le Mars",
    "Sleepy Hollow",
    "Fairmont",
    "Independence",
    "Cypress Gardens",
    "Glenwood Springs",
    "Bernalillo",
    "Kennett",
    "Marlton",
    "Bastrop",
    "Melissa",
    "Lowell",
    "Astoria",
    "Corte Madera",
    "St. Augustine Shores",
    "Warrenton",
    "Woodbury",
    "Conning Towers Nautilus Park",
    "Birch Bay",
    "Baker City",
    "East Rockaway",
    "Wimauma",
    "Northampton",
    "Stonegate",
    "Star",
    "Denham Springs",
    "Loudonville",
    "Benton Harbor",
    "Mayfield",
    "Jennings",
    "Felida",
    "Bluefield",
    "Trumbull Center",
    "Scotchtown",
    "Peru",
    "Eunice",
    "Clarksville",
    "Pleasant Grove",
    "Howell",
    "Winfield",
    "Rifle",
    "Little River",
    "Lincoln Village",
    "West Perrine",
    "Forestville",
    "Croydon",
    "La Plata",
    "East Setauket",
    "Aiea",
    "Cheat Lake",
    "Millington",
    "Silver City",
    "Reedsburg",
    "New Hyde Park",
    "Cody",
    "Rio del Mar",
    "Maywood",
    "Alexandria",
    "Rainbow City",
    "Pájaros",
    "Hope",
    "Sparta",
    "Paris",
    "Oil City",
    "North Gates",
    "North Bend",
    "St. Francis",
    "Kensington",
    "Rockcreek",
    "Villas",
    "Mooresville",
    "Countryside",
    "Francisville",
    "Merrydale",
    "Wapakoneta",
    "Chesapeake Ranch Estates",
    "Carroll",
    "Fort Irwin",
    "Bardmoor",
    "Taylorville",
    "Helotes",
    "Northbrook",
    "Sugar Grove",
    "Havre",
    "Keansburg",
    "Decatur",
    "Sweet Home",
    "Soquel",
    "Port Townsend",
    "Marysville",
    "Vega Alta",
    "Safford",
    "Cabo Rojo",
    "St. Pete Beach",
    "Dunn",
    "San Diego Country Estates",
    "Uniontown",
    "White City",
    "New Port Richey East",
    "Alderwood Manor",
    "Oakbrook",
    "Newport",
    "East Rutherford",
    "Cross Lanes",
    "Key Largo",
    "DuPont",
    "Brookdale",
    "Winslow",
    "South Yarmouth",
    "Nanticoke",
    "Lake Barcroft",
    "Greentree",
    "Farmington",
    "North Branch",
    "Bellefontaine Neighbors",
    "Progress Village",
    "Gloucester Point",
    "Helena-West Helena",
    "Pine Hill",
    "Newcastle",
    "Gunbarrel",
    "Cusseta",
    "George Mason",
    "Doraville",
    "Del Aire",
    "Alachua",
    "Gages Lake",
    "DeForest",
    "North Bellport",
    "Wyomissing",
    "Arizona City",
    "Mapleton",
    "Warr Acres",
    "Bull Mountain",
    "Saks",
    "Arden Hills",
    "Russellville",
    "Liberty Lake",
    "Budd Lake",
    "Forest Acres",
    "Fairmount",
    "Jesup",
    "Mentone",
    "Sugarmill Woods",
    "Chevy Chase",
    "Jessup",
    "Ingleside",
    "Loudoun Valley Estates",
    "Bithlo",
    "Hermantown",
    "Lake Hopatcong",
    "Woodbury",
    "Pike Road",
    "Boaz",
    "Spout Springs",
    "Alcoa",
    "Walker Mill",
    "Richmond Heights",
    "Arkadelphia",
    "Frederick",
    "Orange Lake",
    "Parsons",
    "Myers Corner",
    "Independent Hill",
    "Fairmount",
    "Willoughby Hills",
    "Rye Brook",
    "Kendall Park",
    "Rodeo",
    "Fort Oglethorpe",
    "Woodlyn",
    "Clay",
    "Eureka",
    "Fort Stewart",
    "Citrus",
    "Mission",
    "Lake Arrowhead",
    "Lyons",
    "Marlboro Village",
    "Midland",
    "Picnic Point",
    "Wood River",
    "Fox Lake",
    "Inwood",
    "Washington",
    "Coweta",
    "Pine Ridge",
    "Miami Shores",
    "Fairview Shores",
    "Cedar Hills",
    "Box Elder",
    "Gig Harbor",
    "West Athens",
    "Granbury",
    "Difficult Run",
    "Fairfield",
    "Ellisville",
    "Oakville",
    "Victoria",
    "Blackwells Mills",
    "Pleasant View",
    "White Horse",
    "West Haverstraw",
    "De Witt",
    "Great Neck",
    "Woodburn",
    "Mount Vista",
    "Mound",
    "Alamosa",
    "Amityville",
    "Succasunna",
    "Brownsville",
    "Evergreen",
    "Hackettstown",
    "Mount Airy",
    "The Village",
    "Atoka",
    "Commerce",
    "Fort Salonga",
    "Lowell",
    "Sunbury",
    "Ecorse",
    "Bloomingdale",
    "Monticello",
    "Park Forest Village",
    "Beckett Ridge",
    "Middletown",
    "Bladensburg",
    "Lancaster",
    "Sangaree",
    "Indianola",
    "Lake Hiawatha",
    "Edwards",
    "Sellersburg",
    "Eagle Point",
    "Valley",
    "Flowood",
    "Versailles",
    "Gresham Park",
    "Grosse Pointe Farms",
    "Madeira",
    "Tomah",
    "Fallston",
    "New Richmond",
    "Country Club Estates",
    "Flossmoor",
    "Corona de Tucson",
    "Itasca",
    "Tiburon",
    "Leisure World",
    "Claymont",
    "Detroit Lakes",
    "Brownfield",
    "Saline",
    "Calimesa",
    "Coffeyville",
    "Lynwood",
    "Lake Mohawk",
    "Louisville",
    "Belmont",
    "Steger",
    "Harvard",
    "Washington Terrace",
    "Jeannette",
    "Cairo",
    "Harahan",
    "Warren",
    "Brentwood",
    "Stansbury Park",
    "Highland Park",
    "Lamesa",
    "Country Club",
    "Hartland",
    "White Meadow Lake",
    "Hondo",
    "Fairview",
    "Belgrade",
    "Murrells Inlet",
    "Middlesborough",
    "Bay Minette",
    "Rio Vista",
    "Westwood",
    "Beverly Hills",
    "Molalla",
    "Eidson Road",
    "Fairfield Glade",
    "Kendallville",
    "Roslyn",
    "Bohemia",
    "Greenwood",
    "Rensselaer",
    "Taft",
    "Pryor Creek",
    "Woodfield",
    "Nolensville",
    "Lugoff",
    "Plymouth",
    "Anthony",
    "North Lakes",
    "Canal Winchester",
    "Murillo",
    "Coral Hills",
    "Marlton",
    "Sandy Hook",
    "Gardere",
    "Haiku-Pauwela",
    "Temperance",
    "LaSalle",
    "Charlotte",
    "Presque Isle",
    "Rochelle",
    "Tuba City",
    "Corozal",
    "Woodway",
    "Clinton",
    "Burlington",
    "Columbia City",
    "Bastrop",
    "Fairview",
    "Cameron",
    "Lock Haven",
    "Cambridge",
    "Merrill",
    "San Elizario",
    "Chillicothe",
    "Boulder Hill",
    "Mechanicsburg",
    "Riverdale",
    "Winchester",
    "Ivins",
    "Oxford",
    "Lihue",
    "Brewer",
    "Smithville",
    "Micco",
    "Riverside",
    "Fort Valley",
    "Delta",
    "East York",
    "University of California-Davis",
    "Craig",
    "Orosi",
    "Southeast Arcadia",
    "Edgewater",
    "Waseca",
    "Brandywine",
    "Monmouth",
    "Grinnell",
    "Skidaway Island",
    "Cloverdale",
    "Miramar Beach",
    "South Amboy",
    "Florence",
    "Wagoner",
    "Glencoe",
    "Alma",
    "Franklin",
    "Grants",
    "La Grange",
    "Terrace Heights",
    "Clarendon Hills",
    "Sheffield",
    "Monmouth Junction",
    "Olney",
    "Earlimart",
    "Rock Falls",
    "Aliquippa",
    "Pine Lake Park",
    "Shawano",
    "Monett",
    "Chanute",
    "McFarland",
    "Woodbury",
    "Covington",
    "Farmingdale",
    "Pineville",
    "Hooper",
    "Tremonton",
    "Fort Knox",
    "Gulf Hills",
    "Savoy",
    "Georgetown",
    "Laurens",
    "Lake Elmo",
    "Glenwood",
    "Redlands",
    "Ogden",
    "Canonsburg",
    "Olmsted Falls",
    "Frankfort Square",
    "Quakertown",
    "Newark",
    "Harleysville",
    "Wood-Ridge",
    "Leonia",
    "Toppenish",
    "Roanoke",
    "Waterford",
    "Port Wentworth",
    "Fairview",
    "Sheffield Lake",
    "Berkeley",
    "Sturgeon Bay",
    "Lititz",
    "Bemiss",
    "Pulaski",
    "Edgewood",
    "Marathon",
    "Pitman",
    "Whippany",
    "Fitzgerald",
    "Orange Park",
    "Glenshaw",
    "Riverside",
    "Thief River Falls",
    "Clinton",
    "Thomaston",
    "Flanders",
    "Laurel Hill",
    "Swissvale",
    "Maysville",
    "Collingdale",
    "Cortez",
    "Glens Falls North",
    "Mount Pleasant",
    "New Albany",
    "Brigantine",
    "Fort Riley",
    "North Madison",
    "Sitka",
    "Juncos",
    "Palm Beach",
    "Montvale",
    "New Square",
    "West Glens Falls",
    "Perkasie",
    "Shiprock",
    "Plymouth",
    "Port Jervis",
    "Paris",
    "Rockingham",
    "Kirby",
    "Ladue",
    "Rathdrum",
    "Fort Lupton",
    "Princeton",
    "Frostburg",
    "Hoquiam",
    "Lake Park",
    "Signal Mountain",
    "Barre",
    "Pleasant Hill",
    "Village Green-Green Ridge",
    "Bayport",
    "Litchfield Beach",
    "Closter",
    "Little Falls",
    "Audubon",
    "Hailey",
    "Perryton",
    "Franklin",
    "Rapid Valley",
    "Vineyard",
    "Thompsonville",
    "Richmond Heights",
    "Whitehouse",
    "Booneville",
    "Graham",
    "Fallon",
    "East Grand Forks",
    "Rawlins",
    "Pingree Grove",
    "Wellington",
    "Independence",
    "Ridgefield",
    "Sanatoga",
    "Sandpoint",
    "Stuttgart",
    "Sallisaw",
    "Sanger",
    "Malverne",
    "Matawan",
    "Dayton",
    "Willowbrook",
    "Wharton",
    "Cumberland Hill",
    "Cresskill",
    "Morrisville",
    "Lapeer",
    "Angola",
    "Corrales",
    "Kings Grant",
    "Lake Villa",
    "Lansdowne",
    "Manteno",
    "Wyoming",
    "Guntersville",
    "Lake of the Woods",
    "Midway City",
    "Bridgeport",
    "Harrisburg",
    "Park Ridge",
    "Indian Harbour Beach",
    "Yorkshire",
    "Perryville",
    "Alamo Heights",
    "Glastonbury Center",
    "Jennings Lodge",
    "Conover",
    "Liberty",
    "Spanish Fort",
    "Girard",
    "Smithfield",
    "Picture Rocks",
    "Augusta",
    "Roxborough Park",
    "College Place",
    "Heath",
    "Lincoln City",
    "Northwest Harborcreek",
    "St. Anthony",
    "University of Virginia",
    "Elsmere",
    "Hernando",
    "Atmore",
    "Morehead City",
    "Harrison",
    "Park Hills",
    "Halls",
    "Clinton",
    "Garrison",
    "Fern Park",
    "Andalusia",
    "Carencro",
    "Summit View",
    "Plainedge",
    "Reserve",
    "Garden City",
    "Kulpsville",
    "Derby",
    "Fort Polk South",
    "Des Peres",
    "Edgemere",
    "Scott",
    "Burton",
    "Oak Grove",
    "Fair Oaks",
    "Fishersville",
    "Folsom",
    "Hickam Housing",
    "South Kensington",
    "Harrodsburg",
    "Los Altos Hills",
    "Oakwood",
    "Valley Cottage",
    "Beecher",
    "Forestdale",
    "Airmont",
    "Dunn Loring",
    "West Haven-Sylvan",
    "Hobart",
    "Powdersville",
    "Ashland",
    "Willow Street",
    "Audubon",
    "Whitestown",
    "North College Hill",
    "Bethalto",
    "Richboro",
    "Westphalia",
    "Woodmoor",
    "Mahomet",
    "Clanton",
    "Hornsby Bend",
    "Clayton",
    "North Kensington",
    "Helena Valley Southeast",
    "Aransas Pass",
    "Wesley Chapel",
    "Airway Heights",
    "Fruitland Park",
    "Berthoud",
    "Mahopac",
    "Fultondale",
    "Lenoir City",
    "St. Stephens",
    "Innsbrook",
    "Greenville",
    "Greenville",
    "Poteau",
    "Sans Souci",
    "Hillview",
    "Yelm",
    "Incline Village",
    "Seven Corners",
    "Stony Brook University",
    "Springfield",
    "Hollymead",
    "Citrus Springs",
    "Druid Hills",
    "Summit"
];

export const usStates = [
    "PR",
    "NJ",
    "FL",
    "CA",
    "CA",
    "NY",
    "IL",
    "SC",
    "NC",
    "NC",
    "FL",
    "MD",
    "CA",
    "CT",
    "OR",
    "PA",
    "CA",
    "CA",
    "AR",
    "CA",
    "FL",
    "WA",
    "FL",
    "PR",
    "NJ",
    "FL",
    "CA",
    "CA",
    "NY",
    "IL",
    "SC",
    "NC",
    "NC",
    "FL",
    "MD",
    "CA",
    "CT",
    "OR",
    "PA",
    "CA",
    "CA",
    "AR",
    "CA",
    "FL",
    "WA",
    "FL",
    "MS",
    "FL",
    "CA",
    "MD",
    "CA",
    "TX",
    "CT",
    "CA",
    "WA",
    "NC",
    "OH",
    "ID",
    "CA",
    "UT",
    "CA",
    "UT",
    "CA",
    "FL",
    "FL",
    "PA",
    "AZ",
    "TX",
    "NH",
    "WI",
    "TX",
    "WA",
    "SC",
    "CA",
    "CA",
    "ND",
    "CA",
    "AZ",
    "CA",
    "PA",
    "CA",
    "CA",
    "CA",
    "FL",
    "FL",
    "TX",
    "FL",
    "CA",
    "PA",
    "SC",
    "FL",
    "MI",
    "CO",
    "OR",
    "NC",
    "TX",
    "LA",
    "NC",
    "TX",
    "CA",
    "TX",
    "MI",
    "WI",
    "CA",
    "IL",
    "TX",
    "CA",
    "FL",
    "CT",
    "CT",
    "TN",
    "CT",
    "PA",
    "TN",
    "CA",
    "CA",
    "MI",
    "TX",
    "MI",
    "CA",
    "TX",
    "IA",
    "NJ",
    "CA",
    "CA",
    "OR",
    "AZ",
    "VA",
    "TX",
    "FL",
    "IN",
    "TX",
    "ME",
    "IA",
    "WV",
    "CT",
    "AZ",
    "MI",
    "PA",
    "CA",
    "TX",
    "NJ",
    "AZ",
    "NC",
    "FL",
    "NV",
    "FL",
    "IL",
    "NV",
    "CA",
    "NY",
    "NC",
    "RI",
    "MA",
    "VA",
    "NV",
    "VA",
    "IL",
    "NV",
    "IN",
    "NJ",
    "FL",
    "FL",
    "NV",
    "WA",
    "TX",
    "SD",
    "GA",
    "MO",
    "OH",
    "CA",
    "NC",
    "CA",
    "AZ",
    "OH",
    "SC",
    "GA",
    "CA",
    "PA",
    "SC",
    "NY",
    "CA",
    "ID",
    "NC",
    "AZ",
    "GA",
    "LA",
    "VA",
    "MA",
    "TX",
    "VA",
    "FL",
    "IA",
    "NY",
    "NV",
    "WA",
    "NY",
    "FL",
    "CA",
    "CO",
    "TX",
    "AR",
    "AZ",
    "HI",
    "NC",
    "CA",
    "OH",
    "WI",
    "AL",
    "MN",
    "VA",
    "FL",
    "VA",
    "WA",
    "NM",
    "TN",
    "MS",
    "TX",
    "IN",
    "NV",
    "KS",
    "KY",
    "UT",
    "TN",
    "FL",
    "OH",
    "CA",
    "LA",
    "NY",
    "AL",
    "PR",
    "CA",
    "FL",
    "NY",
    "TX",
    "MO",
    "FL",
    "LA",
    "NE",
    "AL",
    "FL",
    "MN",
    "NV",
    "TX",
    "OH",
    "AK",
    "CA",
    "KS",
    "CO",
    "KY",
    "AZ",
    "AL",
    "NY",
    "WI",
    "PA",
    "CA",
    "OR",
    "MD",
    "OH",
    "GA",
    "OK",
    "NE",
    "TN",
    "MI",
    "CA",
    "WA",
    "MA",
    "NC",
    "TN",
    "NY",
    "FL",
    "CO",
    "IN",
    "OH",
    "NY",
    "NC",
    "PA",
    "CA",
    "OH",
    "MO",
    "OK",
    "DC",
    "TX",
    "TX",
    "AZ",
    "TX",
    "IL",
    "NY",
    "CA",
    "NY",
    "PR",
    "CA",
    "MI",
    "VA",
    "MA",
    "PA",
    "HI",
    "CA",
    "PR",
    "CA",
    "MI",
    "CA",
    "CO",
    "NH",
    "CA",
    "MI",
    "NH",
    "CA",
    "IL",
    "CA",
    "IL",
    "PR",
    "OH",
    "WA",
    "TX",
    "KS",
    "KY",
    "TX",
    "CA",
    "LA",
    "AZ",
    "CO",
    "NC",
    "TX",
    "CA",
    "ID",
    "MD",
    "CA",
    "CA",
    "ID",
    "UT",
    "CA",
    "CA",
    "WI",
    "TX",
    "NY",
    "WI",
    "LA",
    "CA",
    "CA",
    "TX",
    "TX",
    "MA",
    "CA",
    "GA",
    "LA",
    "VA",
    "PR",
    "CA",
    "SC",
    "GA",
    "CA",
    "MD",
    "CA",
    "CA",
    "FL",
    "CA",
    "CA",
    "CA",
    "TX",
    "TX",
    "CA",
    "IL",
    "VA",
    "TX",
    "CA",
    "CO",
    "MO",
    "MI",
    "CA",
    "CA",
    "PA",
    "CA",
    "CA",
    "AR",
    "FL",
    "TX",
    "CA",
    "CA",
    "TX",
    "CA",
    "CA",
    "CA",
    "UT",
    "CA",
    "WI",
    "TX",
    "SC",
    "MD",
    "CA",
    "IL",
    "FL",
    "CA",
    "IN",
    "FL",
    "GA",
    "CA",
    "CA",
    "GA",
    "TX",
    "CA",
    "WA",
    "CA",
    "IL",
    "CA",
    "CA",
    "FL",
    "DE",
    "NC",
    "TX",
    "CA",
    "TX",
    "MN",
    "MI",
    "VT",
    "TX",
    "OR",
    "CO",
    "CA",
    "UT",
    "OR",
    "OK",
    "CA",
    "NV",
    "CA",
    "TX",
    "CA",
    "AZ",
    "CA",
    "WA",
    "CA",
    "IL",
    "CA",
    "CA",
    "ID",
    "CO",
    "NM",
    "CA",
    "KY",
    "CA",
    "CA",
    "CA",
    "AZ",
    "FL",
    "CA",
    "NJ",
    "OH",
    "TX",
    "MI",
    "MA",
    "FL",
    "NM",
    "WA",
    "CA",
    "FL",
    "SC",
    "SD",
    "PA",
    "IL",
    "GA",
    "MO",
    "MI",
    "MA",
    "MS",
    "FL",
    "SC",
    "CA",
    "MA",
    "WA",
    "FL",
    "TN",
    "CA",
    "NY",
    "SC",
    "FL",
    "OH",
    "FL",
    "FL",
    "UT",
    "AL",
    "WY",
    "CA",
    "IN",
    "MI",
    "CA",
    "CA",
    "CA",
    "IL",
    "CA",
    "FL",
    "MA",
    "TX",
    "TX",
    "TX",
    "NY",
    "FL",
    "CA",
    "UT",
    "CA",
    "FL",
    "WA",
    "TX",
    "WA",
    "MI",
    "CA",
    "TN",
    "OR",
    "MT",
    "GA",
    "MA",
    "FL",
    "TX",
    "TN",
    "CA",
    "MD",
    "VA",
    "PR",
    "IA",
    "OK",
    "MA",
    "UT",
    "FL",
    "IN",
    "ND",
    "UT",
    "IA",
    "NJ",
    "CA",
    "WI",
    "CA",
    "OK",
    "MI",
    "GA",
    "IL",
    "IN",
    "TX",
    "MI",
    "MN",
    "AZ",
    "RI",
    "MD",
    "AL",
    "AZ",
    "CA",
    "MI",
    "NC",
    "NJ",
    "AL",
    "NH",
    "GA",
    "WA",
    "SC",
    "CA",
    "CA",
    "TX",
    "TX",
    "CO",
    "CA",
    "LA",
    "MO",
    "WI",
    "PR",
    "MI",
    "VA",
    "TX",
    "NM",
    "MA",
    "TX",
    "CA",
    "FL",
    "LA",
    "FL",
    "MD",
    "WA",
    "CA",
    "TX",
    "AL",
    "WA",
    "KS",
    "MO",
    "IN",
    "IN",
    "WV",
    "CA",
    "MT",
    "CA",
    "IN",
    "OH",
    "TX",
    "CA",
    "MN",
    "IN",
    "FL",
    "CO",
    "AZ",
    "LA",
    "CT",
    "VA",
    "AR",
    "PR",
    "FL",
    "CO",
    "MN",
    "CA",
    "IN",
    "CO",
    "FL",
    "VA",
    "MO",
    "FL",
    "CA",
    "FL",
    "OR",
    "CO",
    "FL",
    "NC",
    "AL",
    "CO",
    "RI",
    "GA",
    "CO",
    "SC",
    "IL",
    "FL",
    "CO",
    "TX",
    "CA",
    "TX",
    "MN",
    "VA",
    "FL",
    "MA",
    "WV",
    "FL",
    "TX",
    "TX",
    "CA",
    "IL",
    "FL",
    "MO",
    "NJ",
    "FL",
    "TX",
    "OK",
    "IA",
    "MN",
    "GA",
    "GA",
    "KS",
    "MA",
    "KS",
    "VA",
    "CA",
    "CA",
    "WV",
    "VA",
    "VA",
    "WA",
    "WA",
    "CA",
    "NJ",
    "PR",
    "TX",
    "NJ",
    "PR",
    "CA",
    "CA",
    "IL",
    "TN",
    "PA",
    "WA",
    "CA",
    "WA",
    "UT",
    "CT",
    "CA",
    "NY",
    "IN",
    "WA",
    "WV",
    "NJ",
    "PR",
    "CA",
    "CA",
    "TX",
    "NY",
    "NJ",
    "CA",
    "CA",
    "CA",
    "MI",
    "CA",
    "MA",
    "NC",
    "OK",
    "CA",
    "CA",
    "TX",
    "CT",
    "MA",
    "CA",
    "TN",
    "IL",
    "NJ",
    "IL",
    "CA",
    "CA",
    "IL",
    "MA",
    "CA",
    "NJ",
    "CA",
    "MN",
    "CA",
    "CA",
    "TX",
    "CT",
    "CA",
    "MA",
    "NJ",
    "TN",
    "OH",
    "CA",
    "TX",
    "IL",
    "NJ",
    "FL",
    "OH",
    "MA",
    "ID",
    "CA",
    "CA",
    "CA",
    "UT",
    "TX",
    "CA",
    "CA",
    "CA",
    "CA",
    "CA",
    "FL",
    "MI",
    "IN",
    "TX",
    "IL",
    "MI",
    "PR",
    "SC",
    "IL",
    "UT",
    "CA",
    "CA",
    "TX",
    "PA",
    "PR",
    "MD",
    "KY",
    "MA",
    "TN",
    "MN",
    "MN",
    "TX",
    "RI",
    "TN",
    "TX",
    "WI",
    "MD",
    "CA",
    "MO",
    "WI",
    "AL",
    "CA",
    "MI",
    "WV",
    "IL",
    "AR",
    "NY",
    "MN",
    "TX",
    "GA",
    "FL",
    "LA",
    "CA",
    "IA",
    "CA",
    "CA",
    "TX",
    "CA",
    "OR",
    "NJ",
    "FL",
    "IA",
    "CA",
    "IN",
    "MN",
    "FL",
    "CA",
    "MO",
    "MN",
    "WA",
    "IL",
    "FL",
    "UT",
    "CA",
    "IL",
    "ID",
    "CA",
    "CT",
    "FL",
    "CA",
    "WA",
    "CA",
    "CA",
    "CA",
    "FL",
    "IN",
    "CA",
    "IL",
    "MI",
    "CO",
    "IA",
    "MD",
    "CA",
    "MI",
    "CA",
    "FL",
    "TX",
    "CO",
    "OR",
    "MO",
    "GA",
    "CA",
    "MD",
    "VA",
    "AZ",
    "IL",
    "CA",
    "CA",
    "CT",
    "NE",
    "MO",
    "SC",
    "AR",
    "MD",
    "WA",
    "AZ",
    "TN",
    "CA",
    "CA",
    "AL",
    "IN",
    "TX",
    "IN",
    "CA",
    "MI",
    "IL",
    "NC",
    "MN",
    "NY",
    "TX",
    "IN",
    "MT",
    "LA",
    "VA",
    "CA",
    "VA",
    "CA",
    "CA",
    "NM",
    "LA",
    "CA",
    "PA",
    "IL",
    "AZ",
    "OH",
    "WA",
    "TX",
    "CA",
    "CA",
    "CA",
    "CA",
    "ID",
    "MI",
    "IL",
    "VA",
    "AR",
    "WI",
    "CT",
    "WI",
    "LA",
    "AZ",
    "MN",
    "MN",
    "CA",
    "NY",
    "MD",
    "CO",
    "MD",
    "FL",
    "TX",
    "IL",
    "AK",
    "WA",
    "FL",
    "FL",
    "CA",
    "FL",
    "NY",
    "FL",
    "MA",
    "MN",
    "IA",
    "OR",
    "OR",
    "ND",
    "OH",
    "IL",
    "WY",
    "CA",
    "WA",
    "NC",
    "MS",
    "WI",
    "VA",
    "MI",
    "MA",
    "CA",
    "FL",
    "AZ",
    "FL",
    "KS",
    "WA",
    "FL",
    "OH",
    "MI",
    "CA",
    "GA",
    "MA",
    "IN",
    "AZ",
    "NC",
    "OK",
    "OR",
    "FL",
    "NV",
    "GA",
    "MA",
    "TX",
    "MT",
    "FL",
    "MD",
    "IL",
    "FL",
    "NY",
    "AZ",
    "TX",
    "CA",
    "ND",
    "MI",
    "NC",
    "NJ",
    "OK",
    "IL",
    "MO",
    "WI",
    "AR",
    "NJ",
    "RI",
    "MI",
    "GA",
    "IL",
    "AL",
    "IA",
    "FL",
    "NE",
    "CA",
    "CO",
    "MD",
    "CA",
    "NC",
    "CA",
    "MI",
    "FL",
    "FL",
    "FL",
    "UT",
    "FL",
    "NY",
    "TX",
    "FL",
    "TX",
    "FL",
    "PA",
    "FL",
    "FL",
    "DE",
    "FL",
    "TN",
    "FL",
    "MN",
    "CA",
    "NY",
    "MN",
    "MI",
    "AR",
    "OH",
    "MI",
    "UT",
    "OK",
    "VA",
    "MD",
    "WI",
    "IN",
    "WA",
    "FL",
    "OH",
    "GA",
    "NY",
    "FL",
    "OH",
    "KS",
    "MD",
    "CA",
    "PR",
    "OH",
    "AZ",
    "MD",
    "KS",
    "MD",
    "IN",
    "OH",
    "KS",
    "IL",
    "FL",
    "MA",
    "FL",
    "VA",
    "CA",
    "NJ",
    "CA",
    "UT",
    "CA",
    "NV",
    "HI",
    "NJ",
    "MA",
    "NC",
    "IL",
    "MA",
    "NY",
    "UT",
    "TX",
    "SC",
    "CA",
    "TN",
    "MN",
    "CA",
    "CA",
    "VA",
    "MA",
    "IL",
    "CA",
    "OH",
    "MA",
    "OH",
    "MN",
    "CA",
    "NJ",
    "IA",
    "IL",
    "OH",
    "GA",
    "MA",
    "OH",
    "CA",
    "RI",
    "CA",
    "NY",
    "NY",
    "VA",
    "MA",
    "IL",
    "MA",
    "UT",
    "OR",
    "TX",
    "MA",
    "NM",
    "CA",
    "CA",
    "CA",
    "IA",
    "FL",
    "OH",
    "UT",
    "NJ",
    "TX",
    "IL",
    "MA",
    "CA",
    "FL",
    "MO",
    "OH",
    "NM",
    "TN",
    "CA",
    "MD",
    "FL",
    "IL",
    "IL",
    "CA",
    "TN",
    "TX",
    "OH",
    "IL",
    "MD",
    "IL",
    "IL",
    "TX",
    "IL",
    "CA",
    "NJ",
    "HI",
    "WI",
    "FL",
    "MN",
    "UT",
    "OH",
    "OR",
    "FL",
    "OK",
    "GA",
    "MS",
    "FL",
    "ND",
    "NY",
    "UT",
    "IL",
    "CA",
    "MI",
    "FL",
    "CA",
    "CA",
    "WI",
    "IN",
    "WI",
    "MN",
    "NY",
    "IL",
    "ME",
    "MO",
    "IA",
    "MN",
    "AZ",
    "TN",
    "IL",
    "FL",
    "MA",
    "CT",
    "CA",
    "TX",
    "OH",
    "CA",
    "CA",
    "UT",
    "ID",
    "TX",
    "WI",
    "KY",
    "GA",
    "TN",
    "CA",
    "CA",
    "CA",
    "OH",
    "PA",
    "PA",
    "NY",
    "CA",
    "FL",
    "HI",
    "WI",
    "MD",
    "CA",
    "OH",
    "CT",
    "OH",
    "CA",
    "WA",
    "IL",
    "UT",
    "MD",
    "GA",
    "NY",
    "IL",
    "KY",
    "IL",
    "OR",
    "UT",
    "LA",
    "WA",
    "OH",
    "OH",
    "TX",
    "CA",
    "NY",
    "CA",
    "IN",
    "FL",
    "IL",
    "MN",
    "ID",
    "NY",
    "WA",
    "TX",
    "CT",
    "CA",
    "NC",
    "WI",
    "CO",
    "HI",
    "KY",
    "HI",
    "TX",
    "MD",
    "WA",
    "FL",
    "NM",
    "NJ",
    "IL",
    "FL",
    "VA",
    "TX",
    "CA",
    "NH",
    "OH",
    "CA",
    "TX",
    "FL",
    "CA",
    "IA",
    "UT",
    "TX",
    "FL",
    "WI",
    "WA",
    "IL",
    "TX",
    "MD",
    "AZ",
    "MI",
    "MA",
    "PR",
    "TN",
    "VA",
    "FL",
    "FL",
    "OH",
    "MD",
    "FL",
    "TX",
    "CO",
    "WA",
    "IL",
    "FL",
    "AZ",
    "WA",
    "MO",
    "CA",
    "KS",
    "WI",
    "OR",
    "MO",
    "NM",
    "GA",
    "CA",
    "WI",
    "TX",
    "IN",
    "CA",
    "CA",
    "AR",
    "TX",
    "MD",
    "VA",
    "CO",
    "GA",
    "IL",
    "AZ",
    "CA",
    "NC",
    "TX",
    "GA",
    "CA",
    "FL",
    "IN",
    "VA",
    "NY",
    "NC",
    "TX",
    "FL",
    "CA",
    "KS",
    "FL",
    "UT",
    "OK",
    "NY",
    "MN",
    "OK",
    "GA",
    "OR",
    "TX",
    "FL",
    "IN",
    "CA",
    "GA",
    "NC",
    "FL",
    "AL",
    "AR",
    "UT",
    "IN",
    "TN",
    "FL",
    "AL",
    "GA",
    "MO",
    "GA",
    "UT",
    "OH",
    "IN",
    "MD",
    "FL",
    "NJ",
    "TN",
    "NC",
    "NY",
    "GA",
    "FL",
    "WA",
    "CA",
    "FL",
    "OH",
    "MN",
    "PA",
    "MD",
    "FL",
    "CA",
    "CO",
    "AZ",
    "VA",
    "FL",
    "IL",
    "VA",
    "NY",
    "FL",
    "TX",
    "IN",
    "IL",
    "AR",
    "TX",
    "VA",
    "MN",
    "TX",
    "WA",
    "AL",
    "CA",
    "MS",
    "WA",
    "MS",
    "VA",
    "NV",
    "CO",
    "MD",
    "WI",
    "GA",
    "CA",
    "FL",
    "OH",
    "FL",
    "MS",
    "CA",
    "GA",
    "CO",
    "WA",
    "FL",
    "IL",
    "AL",
    "AZ",
    "NC",
    "NE",
    "OH",
    "CO",
    "VA",
    "CO",
    "AZ",
    "KS",
    "FL",
    "OH",
    "FL",
    "TX",
    "AZ",
    "TX",
    "AL",
    "MD",
    "FL",
    "NJ",
    "NY",
    "OH",
    "MO",
    "KY",
    "MI",
    "UT",
    "TN",
    "NY",
    "VA",
    "TX",
    "CA",
    "WA",
    "CA",
    "MD",
    "UT",
    "MD",
    "FL",
    "TX",
    "IL",
    "FL",
    "MT",
    "MT",
    "MN",
    "OH",
    "CA",
    "LA",
    "OR",
    "NM",
    "NC",
    "TX",
    "CA",
    "CO",
    "NY",
    "CA",
    "ME",
    "UT",
    "MO",
    "IL",
    "CA",
    "NY",
    "NJ",
    "IL",
    "IL",
    "VA",
    "FL",
    "CA",
    "FL",
    "UT",
    "VA",
    "CA",
    "MA",
    "CA",
    "MI",
    "KY",
    "MD",
    "NJ",
    "NY",
    "UT",
    "CA",
    "CA",
    "CT",
    "CA",
    "MD",
    "NC",
    "GA",
    "KY",
    "CA",
    "CO",
    "CA",
    "AR",
    "CA",
    "CA",
    "NJ",
    "OH",
    "HI",
    "NY",
    "MD",
    "MD",
    "IN",
    "IL",
    "IL",
    "CA",
    "TX",
    "IL",
    "CA",
    "AZ",
    "MI",
    "TX",
    "NY",
    "NM",
    "LA",
    "IL",
    "NY",
    "IL",
    "IL",
    "OR",
    "OR",
    "CA",
    "IL",
    "IN",
    "SD",
    "PA",
    "CA",
    "NC",
    "FL",
    "AL",
    "NY",
    "CA",
    "TN",
    "OK",
    "CA",
    "DE",
    "IL",
    "MD",
    "IL",
    "MI",
    "NY",
    "PA",
    "FL",
    "CA",
    "KY",
    "UT",
    "NJ",
    "MA",
    "IL",
    "HI",
    "KY",
    "NJ",
    "KY",
    "ID",
    "AR",
    "NV",
    "TX",
    "NV",
    "MO",
    "NC",
    "CA",
    "CT",
    "MN",
    "NY",
    "CA",
    "OK",
    "MI",
    "UT",
    "IA",
    "CA",
    "IL",
    "NY",
    "TX",
    "NJ",
    "MS",
    "AZ",
    "TX",
    "NC",
    "MN",
    "NJ",
    "KS",
    "WA",
    "IL",
    "MS",
    "OH",
    "CA",
    "OR",
    "IL",
    "FL",
    "KS",
    "CA",
    "CA",
    "MI",
    "IL",
    "NC",
    "CO",
    "AR",
    "MN",
    "IL",
    "NY",
    "IA",
    "OH",
    "HI",
    "WA",
    "NE",
    "NY",
    "CA",
    "OH",
    "OH",
    "NY",
    "AZ",
    "OH",
    "LA",
    "IA",
    "IL",
    "OR",
    "CA",
    "WI",
    "FL",
    "CA",
    "TX",
    "MN",
    "NJ",
    "CA",
    "CA",
    "VA",
    "CA",
    "CA",
    "CA",
    "FL",
    "WA",
    "FL",
    "CA",
    "AZ",
    "IL",
    "MS",
    "VA",
    "TX",
    "MS",
    "NJ",
    "FL",
    "TX",
    "TX",
    "WI",
    "MN",
    "ND",
    "IL",
    "NY",
    "ME",
    "SC",
    "OH",
    "MD",
    "NY",
    "SC",
    "MN",
    "CA",
    "NY",
    "TX",
    "WI",
    "AK",
    "WA",
    "SC",
    "CA",
    "SC",
    "MO",
    "TX",
    "TX",
    "MI",
    "OK",
    "CA",
    "FL",
    "FL",
    "FL",
    "NY",
    "MD",
    "OH",
    "IL",
    "OH",
    "WY",
    "MN",
    "PA",
    "FL",
    "GA",
    "WY",
    "TX",
    "AZ",
    "TX",
    "GA",
    "VA",
    "MN",
    "AZ",
    "NY",
    "IL",
    "CA",
    "CA",
    "NC",
    "AZ",
    "MO",
    "IL",
    "CA",
    "FL",
    "AL",
    "OH",
    "NC",
    "IL",
    "TN",
    "CA",
    "GA",
    "NC",
    "MO",
    "MN",
    "CA",
    "TX",
    "FL",
    "GA",
    "OH",
    "OH",
    "LA",
    "MO",
    "GA",
    "OH",
    "AR",
    "FL",
    "PA",
    "CA",
    "VA",
    "IN",
    "OH",
    "MN",
    "IN",
    "MN",
    "CA",
    "FL",
    "TX",
    "MD",
    "NC",
    "ID",
    "AR",
    "MS",
    "MI",
    "MD",
    "AR",
    "TX",
    "GA",
    "MS",
    "MN",
    "IL",
    "AL",
    "MO",
    "MO",
    "PA",
    "FL",
    "IN",
    "FL",
    "WI",
    "IN",
    "AL",
    "IL",
    "FL",
    "FL",
    "GA",
    "MI",
    "TX",
    "CO",
    "FL",
    "FL",
    "WI",
    "IN",
    "MD",
    "UT",
    "MD",
    "VA",
    "KY",
    "NH",
    "MD",
    "MD",
    "MI",
    "AL",
    "NY",
    "AR",
    "NC",
    "ID",
    "NY",
    "CA",
    "TX",
    "FL",
    "FL",
    "GA",
    "FL",
    "UT",
    "MI",
    "TN",
    "FL",
    "IL",
    "TX",
    "CA",
    "NJ",
    "FL",
    "AL",
    "MD",
    "MI",
    "CA",
    "CA",
    "LA",
    "MN",
    "OH",
    "FL",
    "MD",
    "OH",
    "WI",
    "KS",
    "GA",
    "GA",
    "MA",
    "KY",
    "FL",
    "MD",
    "NE",
    "TX",
    "NC",
    "OR",
    "MD",
    "FL",
    "OK",
    "IN",
    "IL",
    "MN",
    "WI",
    "PA",
    "FL",
    "OH",
    "MN",
    "WI",
    "FL",
    "FL",
    "OH",
    "IA",
    "IL",
    "GA",
    "MD",
    "TX",
    "PA",
    "WA",
    "MO",
    "WA",
    "VA",
    "IN",
    "NY",
    "WA",
    "AL",
    "MD",
    "NY",
    "FL",
    "IA",
    "IL",
    "IL",
    "IL",
    "MD",
    "UT",
    "CA",
    "IL",
    "AL",
    "OR",
    "VA",
    "IL",
    "CA",
    "NE",
    "OH",
    "MI",
    "KS",
    "TX",
    "WA",
    "MI",
    "NJ",
    "CA",
    "NE",
    "CA",
    "VA",
    "IA",
    "MI",
    "MT",
    "NY",
    "GA",
    "NY",
    "OH",
    "MI",
    "MN",
    "GA",
    "MS",
    "FL",
    "FL",
    "MD",
    "MS",
    "NJ",
    "TX",
    "NJ",
    "TX",
    "MI",
    "FL",
    "IA",
    "IL",
    "IL",
    "OR",
    "ME",
    "FL",
    "WY",
    "OH",
    "MD",
    "MO",
    "SC",
    "MN",
    "VA",
    "IL",
    "NE",
    "WA",
    "WA",
    "MO",
    "IL",
    "FL",
    "WA",
    "TX",
    "NJ",
    "CA",
    "AZ",
    "MN",
    "OH",
    "TX",
    "AR",
    "CO",
    "ND",
    "SC",
    "OH",
    "WA",
    "TX",
    "NH",
    "SC",
    "NY",
    "FL",
    "NY",
    "IL",
    "CA",
    "TN",
    "AR",
    "CA",
    "IL",
    "FL",
    "IL",
    "OH",
    "HI",
    "IL",
    "IL",
    "PA",
    "OR",
    "PA",
    "DE",
    "SC",
    "CA",
    "IL",
    "VA",
    "VA",
    "IN",
    "MN",
    "OK",
    "ND",
    "IN",
    "CA",
    "CA",
    "OH",
    "CA",
    "VA",
    "PR",
    "SD",
    "IL",
    "KS",
    "TN",
    "KS",
    "NY",
    "IN",
    "FL",
    "FL",
    "CA",
    "IL",
    "IL",
    "VA",
    "CA",
    "TX",
    "FL",
    "NY",
    "VA",
    "UT",
    "IA",
    "OH",
    "VA",
    "MO",
    "WI",
    "NJ",
    "CA",
    "WA",
    "NM",
    "IL",
    "WA",
    "FL",
    "NY",
    "VA",
    "OH",
    "LA",
    "CA",
    "WA",
    "IL",
    "NY",
    "OH",
    "WA",
    "OH",
    "WA",
    "MO",
    "HI",
    "VA",
    "IL",
    "LA",
    "IN",
    "FL",
    "OH",
    "OH",
    "CA",
    "OR",
    "CA",
    "NY",
    "MI",
    "IA",
    "MO",
    "KS",
    "NJ",
    "PA",
    "OH",
    "WA",
    "OR",
    "MO",
    "TN",
    "CA",
    "CA",
    "TX",
    "FL",
    "CA",
    "CA",
    "CA",
    "CA",
    "IL",
    "UT",
    "IL",
    "TX",
    "OH",
    "NJ",
    "WA",
    "TX",
    "MI",
    "NJ",
    "OH",
    "GA",
    "IL",
    "FL",
    "TX",
    "FL",
    "FL",
    "MI",
    "FL",
    "MO",
    "CA",
    "MN",
    "NY",
    "SC",
    "FL",
    "WI",
    "CA",
    "SD",
    "RI",
    "TX",
    "NV",
    "MI",
    "MS",
    "IL",
    "CA",
    "MA",
    "FL",
    "NJ",
    "VA",
    "MN",
    "AR",
    "OK",
    "FL",
    "CA",
    "CA",
    "WA",
    "WI",
    "MD",
    "MI",
    "CO",
    "IN",
    "NC",
    "GA",
    "CA",
    "CA",
    "LA",
    "WA",
    "OK",
    "OK",
    "SC",
    "AL",
    "FL",
    "MD",
    "MN",
    "VA",
    "TX",
    "KY",
    "GA",
    "OR",
    "MD",
    "MS",
    "TX",
    "LA",
    "TX",
    "CA",
    "IL",
    "WA",
    "SC",
    "AL",
    "OH",
    "MD",
    "WA",
    "CA",
    "NY",
    "SC",
    "CA",
    "KS",
    "VA",
    "IA",
    "TX",
    "OK",
    "CA",
    "NC",
    "MI",
    "AL",
    "CA",
    "FL",
    "PR",
    "CA",
    "ME",
    "DE",
    "OR",
    "OH",
    "SC",
    "MD",
    "AL",
    "OK",
    "ME",
    "NV",
    "VA",
    "ID",
    "IL",
    "NC",
    "CA",
    "MI",
    "MO",
    "FL",
    "CO",
    "GA",
    "NC",
    "FL",
    "FL",
    "SC",
    "FL",
    "FL",
    "TX",
    "NY",
    "MN",
    "AZ",
    "WI",
    "CA",
    "NJ",
    "AR",
    "OH",
    "VA",
    "FL",
    "KY",
    "WA",
    "FL",
    "CA",
    "NY",
    "FL",
    "FL",
    "CO",
    "CA",
    "AZ",
    "KS",
    "CA",
    "CA",
    "OR",
    "NJ",
    "MD",
    "LA",
    "FL",
    "UT",
    "FL",
    "MN",
    "CA",
    "MN",
    "NJ",
    "MN",
    "MS",
    "OH",
    "NJ",
    "WA",
    "OH",
    "CA",
    "FL",
    "TX",
    "MO",
    "CA",
    "IL",
    "CA",
    "FL",
    "CA",
    "VA",
    "CA",
    "MN",
    "CA",
    "MO",
    "GA",
    "OH",
    "CA",
    "WA",
    "NC",
    "NE",
    "TX",
    "IL",
    "MI",
    "WA",
    "MS",
    "FL",
    "AL",
    "CO",
    "NV",
    "FL",
    "WA",
    "TN",
    "WA",
    "OH",
    "TX",
    "SC",
    "UT",
    "GA",
    "FL",
    "CA",
    "AK",
    "TX",
    "HI",
    "FL",
    "FL",
    "MD",
    "MN",
    "CO",
    "NY",
    "FL",
    "OH",
    "IN",
    "HI",
    "OR",
    "OK",
    "NY",
    "MO",
    "NY",
    "MN",
    "WA",
    "KY",
    "OH",
    "WA",
    "CA",
    "TX",
    "TX",
    "CA",
    "IL",
    "NC",
    "SC",
    "MN",
    "OH",
    "UT",
    "IL",
    "IL",
    "OH",
    "RI",
    "ME",
    "NY",
    "CA",
    "CA",
    "MO",
    "UT",
    "KY",
    "MO",
    "CA",
    "WA",
    "CO",
    "KS",
    "NJ",
    "MD",
    "ME",
    "MD",
    "NJ",
    "IA",
    "CA",
    "IL",
    "CT",
    "FL",
    "OH",
    "NY",
    "PA",
    "CT",
    "IL",
    "IL",
    "CA",
    "IL",
    "NY",
    "TX",
    "OH",
    "FL",
    "NJ",
    "TX",
    "OR",
    "OH",
    "NY",
    "IL",
    "IN",
    "WI",
    "OH",
    "IL",
    "PA",
    "KS",
    "IA",
    "CA",
    "IL",
    "CA",
    "PA",
    "VA",
    "CA",
    "OK",
    "OH",
    "OH",
    "OR",
    "IL",
    "NY",
    "MD",
    "IL",
    "CA",
    "GA",
    "MO",
    "OR",
    "NY",
    "OH",
    "KY",
    "WV",
    "UT",
    "NJ",
    "OH",
    "WI",
    "FL",
    "IL",
    "MA",
    "OH",
    "KY",
    "TX",
    "NJ",
    "NY",
    "VA",
    "WY",
    "OH",
    "CA",
    "NJ",
    "OK",
    "OH",
    "WI",
    "IL",
    "GA",
    "CA",
    "CA",
    "AR",
    "VA",
    "NY",
    "NY",
    "MO",
    "CA",
    "NY",
    "IL",
    "IL",
    "MI",
    "TX",
    "NY",
    "MI",
    "IL",
    "IL",
    "CA",
    "NJ",
    "TX",
    "OR",
    "NY",
    "NJ",
    "FL",
    "FL",
    "VA",
    "AR",
    "OH",
    "GA",
    "FL",
    "TX",
    "WA",
    "FL",
    "MS",
    "NY",
    "NJ",
    "MD",
    "MN",
    "IL",
    "MO",
    "WI",
    "VA",
    "NJ",
    "VA",
    "CA",
    "MD",
    "NC",
    "MN",
    "IL",
    "LA",
    "IL",
    "NC",
    "MD",
    "IN",
    "VA",
    "PR",
    "CA",
    "CA",
    "CA",
    "OK",
    "FL",
    "WA",
    "MN",
    "HI",
    "GA",
    "OR",
    "OH",
    "TX",
    "MD",
    "NY",
    "NJ",
    "IL",
    "TX",
    "IL",
    "VA",
    "NJ",
    "TX",
    "NC",
    "IN",
    "TX",
    "GA",
    "NJ",
    "OH",
    "MO",
    "AR",
    "OR",
    "IA",
    "NY",
    "IL",
    "LA",
    "IL",
    "GA",
    "TX",
    "FL",
    "IN",
    "AZ",
    "TX",
    "WA",
    "NY",
    "ME",
    "WI",
    "IL",
    "MD",
    "CA",
    "AL",
    "FL",
    "WA",
    "NV",
    "VA",
    "NC",
    "NC",
    "LA",
    "FL",
    "NY",
    "IL",
    "GA",
    "WA",
    "IL",
    "MI",
    "OH",
    "WI",
    "VT",
    "WI",
    "FL",
    "FL",
    "CA",
    "NY",
    "FL",
    "GA",
    "WI",
    "NE",
    "VA",
    "NC",
    "NY",
    "TN",
    "MD",
    "NY",
    "CA",
    "CT",
    "CO",
    "OK",
    "IL",
    "WA",
    "MI",
    "SC",
    "FL",
    "VA",
    "CO",
    "OK",
    "MD",
    "AZ",
    "IN",
    "CO",
    "PA",
    "FL",
    "NY",
    "TX",
    "NY",
    "NY",
    "TX",
    "MO",
    "CA",
    "OH",
    "VA",
    "MS",
    "OH",
    "FL",
    "LA",
    "MO",
    "MD",
    "WI",
    "MN",
    "MD",
    "TX",
    "OH",
    "GA",
    "KY",
    "TX",
    "AL",
    "SC",
    "MD",
    "OK",
    "VA",
    "VA",
    "IN",
    "TX",
    "AZ",
    "MS",
    "VA",
    "SC",
    "MN",
    "NM",
    "UT",
    "WI",
    "MO",
    "FL",
    "OR",
    "FL",
    "NJ",
    "NY",
    "MN",
    "HI",
    "VA",
    "TX",
    "PA",
    "MD",
    "MD",
    "GA",
    "WA",
    "FL",
    "TX",
    "VA",
    "TX",
    "UT",
    "CA",
    "GA",
    "TX",
    "MI",
    "NJ",
    "CA",
    "FL",
    "FL",
    "MI",
    "AL",
    "OH",
    "AL",
    "PA",
    "KY",
    "WI",
    "PA",
    "VA",
    "GA",
    "WV",
    "OK",
    "LA",
    "AL",
    "WA",
    "GA",
    "MD",
    "TN",
    "PA",
    "FL",
    "TX",
    "PA",
    "IN",
    "AK",
    "KY",
    "PA",
    "NC",
    "NY",
    "OH",
    "TX",
    "MO",
    "VA",
    "VA",
    "OR",
    "OR",
    "CA",
    "MO",
    "ME",
    "TX",
    "MD",
    "OR",
    "CA",
    "MI",
    "MO",
    "OH",
    "TX",
    "OH",
    "CA",
    "IL",
    "MD",
    "MN",
    "FL",
    "WA",
    "WI",
    "NC",
    "CA",
    "LA",
    "WA",
    "NJ",
    "TX",
    "TX",
    "MN",
    "IL",
    "NH",
    "CA",
    "WV",
    "MN",
    "NV",
    "MO",
    "OH",
    "NY",
    "KY",
    "NY",
    "NC",
    "CA",
    "NY",
    "CA",
    "KY",
    "MI",
    "CA",
    "IL",
    "OK",
    "NC",
    "IN",
    "NJ",
    "CO",
    "NC",
    "TX",
    "IL",
    "FL",
    "CA",
    "MD",
    "WA",
    "IN",
    "HI",
    "TX",
    "MD",
    "UT",
    "CA",
    "WI",
    "CA",
    "NY",
    "IN",
    "NY",
    "CA",
    "IN",
    "TX",
    "IL",
    "TX",
    "GA",
    "NC",
    "OH",
    "TX",
    "FL",
    "AZ",
    "OH",
    "AL",
    "OK",
    "AZ",
    "WI",
    "TN",
    "CA",
    "NC",
    "AL",
    "MI",
    "NY",
    "NY",
    "CA",
    "NJ",
    "GA",
    "FL",
    "NJ",
    "IL",
    "CA",
    "WI",
    "FL",
    "CA",
    "KY",
    "NY",
    "OH",
    "SD",
    "TX",
    "FL",
    "CA",
    "PA",
    "FL",
    "MD",
    "OR",
    "MD",
    "NC",
    "NC",
    "AZ",
    "SC",
    "MI",
    "AR",
    "IN",
    "IL",
    "IL",
    "HI",
    "GA",
    "GA",
    "CA",
    "MI",
    "MD",
    "AL",
    "NY",
    "NY",
    "WI",
    "ID",
    "CA",
    "PR",
    "WI",
    "NJ",
    "NY",
    "NC",
    "MN",
    "CA",
    "TN",
    "NJ",
    "MN",
    "FL",
    "AL",
    "GA",
    "NC",
    "WI",
    "PA",
    "KS",
    "OH",
    "PA",
    "GA",
    "KY",
    "SC",
    "NY",
    "MD",
    "VA",
    "OH",
    "IA",
    "CO",
    "MS",
    "TN",
    "ID",
    "TN",
    "MO",
    "UT",
    "VA",
    "VT",
    "CA",
    "CA",
    "NM",
    "OH",
    "CA",
    "NY",
    "MS",
    "FL",
    "CA",
    "NC",
    "CA",
    "IL",
    "CA",
    "IN",
    "TX",
    "FL",
    "AZ",
    "NY",
    "FL",
    "TX",
    "NY",
    "UT",
    "IL",
    "GA",
    "NY",
    "MS",
    "TX",
    "WI",
    "IL",
    "TX",
    "MO",
    "KY",
    "WA",
    "FL",
    "MO",
    "NY",
    "NJ",
    "FL",
    "FL",
    "TX",
    "NY",
    "MO",
    "MO",
    "WA",
    "NJ",
    "NV",
    "FL",
    "SD",
    "MI",
    "CA",
    "NE",
    "NC",
    "CA",
    "MS",
    "IL",
    "CA",
    "CO",
    "VA",
    "TX",
    "FL",
    "IL",
    "NY",
    "TX",
    "PA",
    "OR",
    "MN",
    "AZ",
    "NJ",
    "IL",
    "OH",
    "CO",
    "TX",
    "ID",
    "OR",
    "FL",
    "MN",
    "FL",
    "FL",
    "MD",
    "VA",
    "CA",
    "MD",
    "FL",
    "NY",
    "CT",
    "VA",
    "CO",
    "SC",
    "AL",
    "KY",
    "AL",
    "CA",
    "IL",
    "PR",
    "IL",
    "AZ",
    "VA",
    "MI",
    "AL",
    "VA",
    "NJ",
    "TX",
    "AL",
    "SC",
    "ID",
    "AZ",
    "IL",
    "AL",
    "NY",
    "MD",
    "KY",
    "FL",
    "MO",
    "MI",
    "IA",
    "AL",
    "CA",
    "AZ",
    "GA",
    "MD",
    "NC",
    "GA",
    "MI",
    "IN",
    "IN",
    "AR",
    "TX",
    "MD",
    "TX",
    "TX",
    "CA",
    "TX",
    "DE",
    "WV",
    "GA",
    "TX",
    "WA",
    "CO",
    "GA",
    "GA",
    "AZ",
    "IL",
    "FL",
    "CA",
    "FL",
    "MO",
    "IN",
    "NC",
    "NV",
    "PA",
    "NY",
    "WI",
    "NY",
    "WI",
    "TN",
    "SC",
    "FL",
    "FL",
    "AL",
    "CA",
    "MD",
    "FL",
    "MD",
    "AL",
    "LA",
    "GA",
    "CA",
    "TX",
    "OH",
    "NC",
    "TX",
    "NV",
    "ND",
    "CA",
    "VA",
    "NC",
    "NC",
    "FL",
    "NY",
    "PA",
    "WA",
    "MD",
    "MO",
    "VA",
    "WA",
    "PA",
    "FL",
    "WA",
    "WA",
    "VA",
    "GA",
    "VA",
    "NJ",
    "MD",
    "WI",
    "AL",
    "NJ",
    "NJ",
    "OH",
    "SC",
    "LA",
    "PA",
    "SC",
    "TX",
    "VA",
    "GA",
    "FL",
    "CA",
    "FL",
    "KY",
    "FL",
    "NJ",
    "NC",
    "VA",
    "LA",
    "NJ",
    "FL",
    "IL",
    "CA",
    "WA",
    "CA",
    "AR",
    "VA",
    "MO",
    "CA",
    "NJ",
    "OH",
    "TX",
    "PA",
    "TX",
    "MD",
    "MS",
    "NY",
    "NM",
    "IL",
    "NY",
    "OH",
    "CA",
    "CA",
    "TX",
    "IN",
    "AZ",
    "IL",
    "IL",
    "MN",
    "TN",
    "CA",
    "SD",
    "TX",
    "MN",
    "IL",
    "FL",
    "KS",
    "NY",
    "OH",
    "NJ",
    "CA",
    "IL",
    "TX",
    "KY",
    "NC",
    "OH",
    "IA",
    "NY",
    "GA",
    "IL",
    "MN",
    "WI",
    "FL",
    "AR",
    "LA",
    "MN",
    "OR",
    "NJ",
    "IL",
    "NJ",
    "TX",
    "NJ",
    "NJ",
    "DE",
    "FL",
    "HI",
    "PA",
    "PA",
    "TN",
    "HI",
    "WA",
    "MI",
    "WA",
    "FL",
    "WA",
    "MN",
    "MS",
    "OH",
    "NY",
    "FL",
    "MS",
    "MO",
    "FL",
    "CO",
    "TX",
    "NM",
    "HI",
    "NJ",
    "OH",
    "MN",
    "WI",
    "VA",
    "IL",
    "MI",
    "NY",
    "VA",
    "MS",
    "MI",
    "OH",
    "FL",
    "WA",
    "CA",
    "CA",
    "VA",
    "SD",
    "OH",
    "MS",
    "WI",
    "OH",
    "MO",
    "CA",
    "PA",
    "NJ",
    "OR",
    "MD",
    "IN",
    "GA",
    "FL",
    "IN",
    "MN",
    "OH",
    "NH",
    "MA",
    "PA",
    "WA",
    "OH",
    "LA",
    "MD",
    "IL",
    "WI",
    "KS",
    "NM",
    "IL",
    "AL",
    "TX",
    "PA",
    "HI",
    "TN",
    "MO",
    "KS",
    "MN",
    "FL",
    "NJ",
    "TX",
    "OH",
    "PA",
    "CA",
    "FL",
    "CA",
    "WI",
    "FL",
    "IL",
    "WA",
    "WI",
    "AZ",
    "CA",
    "NC",
    "TX",
    "NJ",
    "TX",
    "FL",
    "MD",
    "IN",
    "MN",
    "MD",
    "OH",
    "PA",
    "MD",
    "MN",
    "IL",
    "OK",
    "MI",
    "PR",
    "AR",
    "NM",
    "CO",
    "CO",
    "TN",
    "FL",
    "KY",
    "IL",
    "HI",
    "MN",
    "NC",
    "NJ",
    "MN",
    "IN",
    "CA",
    "AL",
    "MD",
    "CA",
    "PA",
    "OR",
    "OH",
    "FL",
    "GA",
    "NY",
    "MS",
    "NY",
    "GA",
    "LA",
    "OH",
    "NC",
    "OH",
    "NY",
    "AZ",
    "VA",
    "OH",
    "NY",
    "PA",
    "MO",
    "FL",
    "NJ",
    "MO",
    "TX",
    "VA",
    "NY",
    "CA",
    "FL",
    "SC",
    "MN",
    "IL",
    "MO",
    "NY",
    "MI",
    "AL",
    "LA",
    "NM",
    "HI",
    "IL",
    "AL",
    "MI",
    "WI",
    "DE",
    "HI",
    "FL",
    "WI",
    "IA",
    "AR",
    "OH",
    "IL",
    "IL",
    "CA",
    "LA",
    "NY",
    "FL",
    "VA",
    "GA",
    "TX",
    "AL",
    "PA",
    "GA",
    "PA",
    "IL",
    "NJ",
    "FL",
    "OK",
    "IL",
    "CA",
    "WA",
    "CA",
    "FL",
    "GA",
    "IL",
    "TX",
    "GA",
    "TN",
    "WI",
    "IL",
    "FL",
    "IL",
    "VA",
    "CA",
    "CA",
    "AR",
    "OH",
    "NC",
    "CT",
    "IL",
    "OH",
    "IN",
    "MS",
    "OH",
    "GA",
    "MD",
    "CO",
    "GA",
    "MN",
    "FL",
    "TN",
    "TX",
    "OR",
    "OH",
    "IL",
    "IL",
    "IL",
    "TX",
    "PA",
    "NH",
    "CO",
    "TN",
    "AL",
    "TX",
    "CO",
    "OK",
    "WV",
    "WA",
    "FL",
    "PA",
    "GA",
    "OH",
    "GA",
    "OH",
    "CA",
    "OH",
    "NY",
    "IL",
    "VA",
    "MD",
    "WA",
    "FL",
    "FL",
    "PA",
    "FL",
    "AL",
    "FL",
    "SC",
    "OH",
    "NJ",
    "CO",
    "MD",
    "CA",
    "CA",
    "MD",
    "AZ",
    "SC",
    "TX",
    "NM",
    "NC",
    "VA",
    "OH",
    "SC",
    "NY",
    "AK",
    "TX",
    "SC",
    "VA",
    "PA",
    "SC",
    "TX",
    "OH",
    "CA",
    "NC",
    "CA",
    "LA",
    "AL",
    "CA",
    "AL",
    "WA",
    "CA",
    "MD",
    "TX",
    "TX",
    "OH",
    "MD",
    "GA",
    "NJ",
    "WI",
    "NJ",
    "NY",
    "IL",
    "NY",
    "CA",
    "AL",
    "TX",
    "WI",
    "NY",
    "WV",
    "OH",
    "VA",
    "SC",
    "NE",
    "KS",
    "IL",
    "PR",
    "FL",
    "MN",
    "NE",
    "PR",
    "MO",
    "NC",
    "MD",
    "UT",
    "CA",
    "PA",
    "FL",
    "TN",
    "OK",
    "IL",
    "FL",
    "OH",
    "AZ",
    "VA",
    "AZ",
    "LA",
    "MD",
    "WI",
    "CA",
    "TX",
    "PR",
    "WA",
    "FL",
    "MI",
    "MI",
    "CA",
    "MI",
    "FL",
    "ID",
    "MN",
    "AZ",
    "IN",
    "OH",
    "WY",
    "NC",
    "WA",
    "VA",
    "MI",
    "MO",
    "MI",
    "WA",
    "NC",
    "NY",
    "OK",
    "MO",
    "MS",
    "LA",
    "CA",
    "NH",
    "FL",
    "LA",
    "OH",
    "NJ",
    "FL",
    "NY",
    "CA",
    "AL",
    "NY",
    "TN",
    "IN",
    "OH",
    "IN",
    "TN",
    "MN",
    "CA",
    "VA",
    "WI",
    "NJ",
    "CA",
    "ID",
    "TX",
    "LA",
    "FL",
    "CA",
    "ID",
    "SC",
    "CA",
    "TX",
    "NJ",
    "OH",
    "NJ",
    "MO",
    "TX",
    "FL",
    "MS",
    "NJ",
    "FL",
    "TX",
    "CA",
    "MO",
    "FL",
    "NJ",
    "KS",
    "NM",
    "TX",
    "WI",
    "CA",
    "DE",
    "MO",
    "OH",
    "WY",
    "IA",
    "FL",
    "MD",
    "UT",
    "LA",
    "OH",
    "NJ",
    "TX",
    "PA",
    "TX",
    "CA",
    "GA",
    "NY",
    "FL",
    "VA",
    "CA",
    "CA",
    "MO",
    "OH",
    "LA",
    "MD",
    "OR",
    "FL",
    "KY",
    "PA",
    "TX",
    "OH",
    "CA",
    "WA",
    "NY",
    "TX",
    "NC",
    "AR",
    "KY",
    "WI",
    "VA",
    "NJ",
    "NJ",
    "IN",
    "NY",
    "HI",
    "AZ",
    "TX",
    "NM",
    "WI",
    "NJ",
    "AZ",
    "FL",
    "RI",
    "NJ",
    "NJ",
    "UT",
    "PR",
    "CA",
    "VA",
    "VA",
    "CA",
    "IL",
    "TX",
    "MD",
    "OK",
    "MO",
    "OH",
    "NV",
    "OK",
    "TX",
    "NY",
    "CA",
    "SC",
    "MO",
    "CA",
    "NJ",
    "IL",
    "TX",
    "AZ",
    "OK",
    "PA",
    "CO",
    "UT",
    "MI",
    "TX",
    "PA",
    "CO",
    "IN",
    "DE",
    "RI",
    "VA",
    "NJ",
    "NJ",
    "OR",
    "TX",
    "TX",
    "NJ",
    "NY",
    "FL",
    "PA",
    "MI",
    "OH",
    "MI",
    "IL",
    "FL",
    "FL",
    "MN",
    "TX",
    "CA",
    "OH",
    "NJ",
    "NC",
    "IL",
    "IL",
    "PR",
    "FL",
    "MI",
    "UT",
    "VA",
    "WI",
    "NY",
    "NJ",
    "HI",
    "OH",
    "PA",
    "MS",
    "NJ",
    "NJ",
    "NC",
    "OR",
    "UT",
    "TN",
    "AZ",
    "PA",
    "LA",
    "OR",
    "CA",
    "PA",
    "TX",
    "LA",
    "OR",
    "IL",
    "AR",
    "MI",
    "FL",
    "SC",
    "CA",
    "FL",
    "SD",
    "AR",
    "IA",
    "WY",
    "TN",
    "MD",
    "TX",
    "MS",
    "PA",
    "CO",
    "SC",
    "CA",
    "GA",
    "OH",
    "HI",
    "MI",
    "WA",
    "NY",
    "LA",
    "VA",
    "TX",
    "WA",
    "NY",
    "CA",
    "NY",
    "NY",
    "TX",
    "UT",
    "FL",
    "LA",
    "GA",
    "AZ",
    "NC",
    "LA",
    "AL",
    "NJ",
    "MO",
    "IN",
    "NY",
    "LA",
    "WI",
    "FL",
    "NJ",
    "WI",
    "SC",
    "AL",
    "OK",
    "WI",
    "WA",
    "CA",
    "FL",
    "CA",
    "FL",
    "KS",
    "KS",
    "NJ",
    "NY",
    "NJ",
    "MO",
    "CA",
    "TN",
    "WI",
    "WA",
    "AZ",
    "TX",
    "OH",
    "NY",
    "OR",
    "TX",
    "MO",
    "MD",
    "TN",
    "FL",
    "MD",
    "KY",
    "PA",
    "TN",
    "NC",
    "MD",
    "CO",
    "CA",
    "IA",
    "FL",
    "OH",
    "FL",
    "NY",
    "PR",
    "CA",
    "MI",
    "GA",
    "MN",
    "MD",
    "NJ",
    "VA",
    "NY",
    "GA",
    "MD",
    "OH",
    "CA",
    "NJ",
    "CA",
    "SC",
    "WA",
    "MD",
    "TN",
    "TX",
    "KY",
    "KS",
    "WA",
    "IL",
    "FL",
    "SD",
    "TX",
    "KS",
    "CA",
    "TN",
    "MS",
    "MD",
    "IN",
    "FL",
    "NY",
    "NJ",
    "MD",
    "NC",
    "MS",
    "CA",
    "FL",
    "WI",
    "WA",
    "FL",
    "WI",
    "OH",
    "CA",
    "OH",
    "MO",
    "MD",
    "WI",
    "NJ",
    "TX",
    "FL",
    "MN",
    "DE",
    "NC",
    "MN",
    "TX",
    "HI",
    "AR",
    "OH",
    "TX",
    "MI",
    "NJ",
    "VT",
    "IL",
    "PA",
    "IL",
    "NV",
    "HI",
    "TX",
    "IL",
    "AL",
    "FL",
    "OH",
    "NY",
    "PA",
    "WI",
    "IL",
    "PR",
    "MI",
    "TX",
    "MD",
    "OH",
    "UT",
    "MN",
    "FL",
    "AK",
    "WI",
    "NY",
    "PA",
    "FL",
    "ID",
    "AK",
    "AZ",
    "OR",
    "KS",
    "OR",
    "TX",
    "OH",
    "GA",
    "MS",
    "WI",
    "VA",
    "WY",
    "MI",
    "IN",
    "OH",
    "MI",
    "CA",
    "CA",
    "WA",
    "OH",
    "MI",
    "OH",
    "MI",
    "MO",
    "TN",
    "PA",
    "WA",
    "NJ",
    "IA",
    "OR",
    "FL",
    "FL",
    "NY",
    "OR",
    "LA",
    "IN",
    "WI",
    "IL",
    "OH",
    "IL",
    "VA",
    "CA",
    "UT",
    "IL",
    "IN",
    "CA",
    "LA",
    "MS",
    "GA",
    "OR",
    "NJ",
    "OH",
    "FL",
    "CA",
    "TN",
    "NY",
    "CA",
    "WA",
    "TX",
    "IA",
    "IL",
    "LA",
    "WA",
    "TX",
    "MO",
    "FL",
    "LA",
    "NJ",
    "OH",
    "IL",
    "IA",
    "CA",
    "NC",
    "SC",
    "GA",
    "UT",
    "LA",
    "WA",
    "WV",
    "NJ",
    "FL",
    "TX",
    "PR",
    "NJ",
    "OH",
    "NJ",
    "IA",
    "CA",
    "MD",
    "NJ",
    "FL",
    "TX",
    "WI",
    "CA",
    "SC",
    "IA",
    "CA",
    "OH",
    "NC",
    "MI",
    "PA",
    "NC",
    "NJ",
    "CA",
    "CA",
    "IA",
    "MD",
    "NY",
    "MD",
    "TX",
    "CA",
    "NY",
    "VA",
    "TN",
    "OH",
    "CA",
    "NH",
    "MD",
    "CA",
    "WA",
    "GA",
    "IL",
    "WV",
    "NE",
    "CO",
    "WI",
    "MI",
    "MD",
    "CA",
    "SC",
    "IL",
    "FL",
    "OH",
    "NJ",
    "NJ",
    "IN",
    "MI",
    "TN",
    "OH",
    "SD",
    "MO",
    "IN",
    "SC",
    "GA",
    "HI",
    "PA",
    "AL",
    "CA",
    "HI",
    "NE",
    "NM",
    "IA",
    "NY",
    "MN",
    "OR",
    "FL",
    "CO",
    "NM",
    "MO",
    "NJ",
    "LA",
    "TX",
    "IN",
    "OR",
    "CA",
    "FL",
    "VA",
    "NJ",
    "CT",
    "WA",
    "OR",
    "NY",
    "FL",
    "PA",
    "CO",
    "ID",
    "LA",
    "NY",
    "MI",
    "KY",
    "LA",
    "WA",
    "WV",
    "CT",
    "NY",
    "IL",
    "LA",
    "AR",
    "AL",
    "MI",
    "IL",
    "CO",
    "SC",
    "OH",
    "FL",
    "OH",
    "PA",
    "MD",
    "NY",
    "HI",
    "WV",
    "TN",
    "NM",
    "WI",
    "NY",
    "WY",
    "CA",
    "NJ",
    "KY",
    "AL",
    "PR",
    "AR",
    "WI",
    "KY",
    "PA",
    "NY",
    "OR",
    "WI",
    "CT",
    "OR",
    "NJ",
    "IN",
    "VA",
    "KY",
    "LA",
    "OH",
    "MD",
    "IA",
    "CA",
    "FL",
    "IL",
    "TX",
    "OH",
    "IL",
    "MT",
    "NJ",
    "IN",
    "OR",
    "CA",
    "WA",
    "MI",
    "PR",
    "AZ",
    "PR",
    "FL",
    "NC",
    "CA",
    "PA",
    "OR",
    "FL",
    "WA",
    "KY",
    "OR",
    "NJ",
    "WV",
    "FL",
    "WA",
    "NJ",
    "AZ",
    "MA",
    "PA",
    "VA",
    "NJ",
    "MI",
    "MN",
    "MO",
    "FL",
    "VA",
    "AR",
    "NJ",
    "OK",
    "CO",
    "GA",
    "VA",
    "GA",
    "CA",
    "FL",
    "IL",
    "WI",
    "NY",
    "PA",
    "AZ",
    "UT",
    "OK",
    "OR",
    "AL",
    "MN",
    "AL",
    "WA",
    "NJ",
    "SC",
    "CO",
    "GA",
    "CA",
    "FL",
    "MD",
    "MD",
    "TX",
    "VA",
    "FL",
    "MN",
    "NJ",
    "NY",
    "AL",
    "AL",
    "NC",
    "TN",
    "MD",
    "FL",
    "AR",
    "CO",
    "NY",
    "KS",
    "NY",
    "VA",
    "NY",
    "OH",
    "NY",
    "NJ",
    "CA",
    "GA",
    "PA",
    "AL",
    "MO",
    "GA",
    "CA",
    "KS",
    "CA",
    "IL",
    "MD",
    "WA",
    "WA",
    "IL",
    "IL",
    "NY",
    "NC",
    "OK",
    "FL",
    "FL",
    "FL",
    "OR",
    "SD",
    "WA",
    "CA",
    "TX",
    "VA",
    "IA",
    "MO",
    "CT",
    "MN",
    "NJ",
    "UT",
    "NJ",
    "NY",
    "NY",
    "NY",
    "VA",
    "WA",
    "MN",
    "CO",
    "NY",
    "NJ",
    "TN",
    "CO",
    "NJ",
    "MD",
    "OK",
    "TN",
    "TX",
    "NY",
    "AR",
    "PA",
    "MI",
    "TN",
    "AR",
    "PA",
    "OH",
    "PA",
    "MD",
    "SC",
    "SC",
    "MS",
    "NJ",
    "CO",
    "IN",
    "OR",
    "AL",
    "MS",
    "KY",
    "GA",
    "MI",
    "OH",
    "WI",
    "MD",
    "WI",
    "GA",
    "IL",
    "AZ",
    "IL",
    "CA",
    "MD",
    "DE",
    "MN",
    "TX",
    "MI",
    "CA",
    "KS",
    "IL",
    "NJ",
    "OH",
    "VA",
    "IL",
    "IL",
    "UT",
    "PA",
    "GA",
    "LA",
    "PA",
    "PA",
    "UT",
    "TX",
    "TX",
    "CA",
    "WI",
    "NJ",
    "TX",
    "OR",
    "MT",
    "SC",
    "KY",
    "AL",
    "CA",
    "MI",
    "FL",
    "OR",
    "TX",
    "TN",
    "IN",
    "PA",
    "NY",
    "AR",
    "NY",
    "CA",
    "OK",
    "SC",
    "TN",
    "SC",
    "MI",
    "NM",
    "AK",
    "OH",
    "TX",
    "MD",
    "MD",
    "CT",
    "LA",
    "HI",
    "MI",
    "IL",
    "MI",
    "ME",
    "IL",
    "AZ",
    "PR",
    "TX",
    "OK",
    "WA",
    "IN",
    "TX",
    "TN",
    "MO",
    "PA",
    "MN",
    "WI",
    "TX",
    "MO",
    "IL",
    "PA",
    "UT",
    "TN",
    "UT",
    "NC",
    "HI",
    "ME",
    "NJ",
    "FL",
    "CT",
    "GA",
    "CO",
    "PA",
    "CA",
    "CO",
    "CA",
    "FL",
    "MD",
    "MN",
    "MD",
    "IL",
    "IA",
    "GA",
    "CA",
    "FL",
    "NJ",
    "OR",
    "OK",
    "IL",
    "MI",
    "KY",
    "NM",
    "KY",
    "WA",
    "IL",
    "AL",
    "NJ",
    "IL",
    "CA",
    "IL",
    "PA",
    "NJ",
    "WI",
    "MO",
    "KS",
    "WI",
    "NY",
    "TN",
    "NY",
    "NC",
    "UT",
    "UT",
    "KY",
    "MS",
    "IL",
    "SC",
    "SC",
    "MN",
    "IL",
    "CO",
    "NC",
    "PA",
    "OH",
    "IL",
    "PA",
    "NY",
    "PA",
    "NJ",
    "NJ",
    "WA",
    "TX",
    "CA",
    "GA",
    "TX",
    "OH",
    "MO",
    "WI",
    "PA",
    "GA",
    "VA",
    "KY",
    "FL",
    "NJ",
    "NJ",
    "GA",
    "FL",
    "PA",
    "IL",
    "MN",
    "MO",
    "GA",
    "NJ",
    "VA",
    "PA",
    "KY",
    "PA",
    "CO",
    "NY",
    "IA",
    "MS",
    "NJ",
    "KS",
    "OH",
    "AK",
    "PR",
    "FL",
    "NJ",
    "NY",
    "NY",
    "PA",
    "NM",
    "WI",
    "NY",
    "IL",
    "NC",
    "TX",
    "MO",
    "ID",
    "CO",
    "IN",
    "MD",
    "WA",
    "FL",
    "TN",
    "VT",
    "MO",
    "PA",
    "NY",
    "SC",
    "NJ",
    "MN",
    "NJ",
    "ID",
    "TX",
    "NH",
    "SD",
    "UT",
    "CT",
    "MO",
    "TX",
    "MS",
    "TX",
    "NV",
    "MN",
    "WY",
    "IL",
    "CO",
    "KS",
    "WA",
    "PA",
    "ID",
    "AR",
    "OK",
    "TX",
    "NY",
    "NJ",
    "TX",
    "IL",
    "TX",
    "RI",
    "NJ",
    "PA",
    "MI",
    "IN",
    "NM",
    "NC",
    "IL",
    "MD",
    "IL",
    "OH",
    "AL",
    "VA",
    "CA",
    "WV",
    "IL",
    "NJ",
    "FL",
    "VA",
    "MO",
    "TX",
    "CT",
    "OR",
    "NC",
    "TX",
    "AL",
    "OH",
    "VA",
    "AZ",
    "KS",
    "CO",
    "WA",
    "TX",
    "OR",
    "PA",
    "MN",
    "VA",
    "KY",
    "FL",
    "AL",
    "NC",
    "TN",
    "MO",
    "TN",
    "NC",
    "MD",
    "FL",
    "AL",
    "LA",
    "WA",
    "NY",
    "LA",
    "GA",
    "PA",
    "CO",
    "LA",
    "MO",
    "MD",
    "LA",
    "SC",
    "MN",
    "GA",
    "VA",
    "PA",
    "HI",
    "MD",
    "KY",
    "CA",
    "OH",
    "NY",
    "MI",
    "AL",
    "NY",
    "VA",
    "OR",
    "WI",
    "SC",
    "NJ",
    "PA",
    "PA",
    "IN",
    "OH",
    "IL",
    "PA",
    "MD",
    "CO",
    "IL",
    "AL",
    "TX",
    "NJ",
    "MD",
    "MT",
    "TX",
    "NC",
    "WA",
    "FL",
    "CO",
    "NY",
    "AL",
    "TN",
    "NC",
    "VA",
    "RI",
    "NY",
    "OK",
    "SC",
    "KY",
    "WA",
    "NV",
    "VA",
    "NY",
    "FL",
    "VA",
    "FL",
    "GA",
    "WA"
];

export const usNeighborhoods = [
    "Aguadilla",
    "Atlantic",
    "Santa Rosa",
    "Orange",
    "Riverside",
    "Dutchess",
    "Lake",
    "Horry",
    "Cabarrus",
    "Catawba",
    "Volusia",
    "Washington",
    "Riverside",
    "Fairfield",
    "Jackson",
    "Lancaster",
    "Riverside",
    "Los Angeles",
    "Washington",
    "San Bernardino",
    "Lee",
    "Benton",
    "Polk",
    "Aguadilla",
    "Atlantic",
    "Santa Rosa",
    "Orange",
    "Riverside",
    "Dutchess",
    "Lake",
    "Horry",
    "Cabarrus",
    "Catawba",
    "Volusia",
    "Washington",
    "Riverside",
    "Fairfield",
    "Jackson",
    "Lancaster",
    "Riverside",
    "Los Angeles",
    "Washington",
    "San Bernardino",
    "Lee",
    "Benton",
    "Polk",
    "Harrison",
    "Flagler",
    "Contra Costa",
    "Harford",
    "San Bernardino",
    "Brazos",
    "New London",
    "Monterey",
    "Thurston",
    "Gaston",
    "Lorain",
    "Canyon",
    "San Bernardino",
    "Weber",
    "Sacramento",
    "Utah",
    "Ventura",
    "Escambia",
    "Osceola",
    "Berks",
    "Maricopa",
    "Collin",
    "Hillsborough",
    "Outagamie",
    "Bell",
    "Kitsap",
    "Spartanburg",
    "Ventura",
    "Riverside",
    "Cass",
    "Santa Barbara",
    "Maricopa",
    "San Bernardino",
    "York",
    "Tulare",
    "Solano",
    "San Diego",
    "Indian River",
    "Marion",
    "Hidalgo",
    "Sarasota",
    "Contra Costa",
    "Lehigh",
    "Greenville",
    "Brevard",
    "Washtenaw",
    "Larimer",
    "Lane",
    "Buncombe",
    "Montgomery",
    "Lafayette",
    "New Hanover",
    "Webb",
    "Alameda",
    "Dallas",
    "Kalamazoo",
    "Brown",
    "Orange",
    "Kane",
    "Dallas",
    "Orange",
    "Lee",
    "Hartford",
    "Fairfield",
    "Rutherford",
    "New Haven",
    "Dauphin",
    "Montgomery",
    "Stanislaus",
    "Orange",
    "Genesee",
    "Collin",
    "Ingham",
    "Sonoma",
    "Collin",
    "Scott",
    "Mercer",
    "San Diego",
    "Los Angeles",
    "Marion",
    "Maricopa",
    "Chesapeake",
    "Dallas",
    "Miami-Dade",
    "Vanderburgh",
    "Cameron",
    "Cumberland",
    "Linn",
    "Cabell",
    "New Haven",
    "Maricopa",
    "Kent",
    "Lackawanna",
    "Orange",
    "Denton",
    "Hudson",
    "Maricopa",
    "Guilford",
    "Sarasota",
    "Clark",
    "Broward",
    "Winnebago",
    "Clark",
    "Riverside",
    "Westchester",
    "Durham",
    "Providence",
    "Worcester",
    "Roanoke",
    "Clark",
    "Newport News",
    "Peoria",
    "Clark",
    "St. Joseph",
    "Essex",
    "St. Lucie",
    "Polk",
    "Clark",
    "Clark",
    "McLennan",
    "Minnehaha",
    "Richmond",
    "Greene",
    "Mahoning",
    "Kern",
    "Forsyth",
    "Orange",
    "Maricopa",
    "Stark",
    "Charleston",
    "Muscogee",
    "San Bernardino",
    "Erie",
    "Richland",
    "Albany",
    "San Joaquin",
    "Ada",
    "Cumberland",
    "Maricopa",
    "Chatham",
    "Caddo",
    "Virginia Beach",
    "Hampden",
    "Potter",
    "Arlington",
    "Broward",
    "Polk",
    "Richmond",
    "Washoe",
    "Spokane",
    "Onondaga",
    "Leon",
    "Los Angeles",
    "Arapahoe",
    "Tarrant",
    "Pulaski",
    "Maricopa",
    "Honolulu",
    "Guilford",
    "Los Angeles",
    "Lucas",
    "Dane",
    "Madison",
    "Ramsey",
    "Richmond",
    "Pinellas",
    "Norfolk",
    "Pierce",
    "Bernalillo",
    "Knox",
    "Hinds",
    "Lubbock",
    "Allen",
    "Clark",
    "Johnson",
    "Fayette",
    "Salt Lake",
    "Hamilton",
    "Alachua",
    "Montgomery",
    "Alameda",
    "East Baton Rouge",
    "Erie",
    "Montgomery",
    "San Juan",
    "Fresno",
    "Orange",
    "Monroe",
    "El Paso",
    "St. Louis",
    "Miami-Dade",
    "Orleans",
    "Lancaster",
    "Mobile",
    "Hillsborough",
    "Hennepin",
    "Clark",
    "Nueces",
    "Cuyahoga",
    "Anchorage",
    "Sacramento",
    "Sedgwick",
    "El Paso",
    "Jefferson",
    "Pima",
    "Jefferson",
    "Bronx",
    "Milwaukee",
    "Allegheny",
    "San Francisco",
    "Multnomah",
    "Baltimore",
    "Hamilton",
    "Fulton",
    "Tulsa",
    "Douglas",
    "Shelby",
    "Wayne",
    "Santa Clara",
    "King",
    "Suffolk",
    "Mecklenburg",
    "Davidson",
    "Kings",
    "Duval",
    "Denver",
    "Marion",
    "Summit",
    "New York",
    "Wake",
    "Philadelphia",
    "San Diego",
    "Franklin",
    "Jackson",
    "Oklahoma",
    "District of Columbia",
    "Dallas",
    "Harris",
    "Maricopa",
    "Bexar",
    "Cook",
    "Queens",
    "Los Angeles",
    "Queens",
    "Arecibo",
    "Monterey",
    "Oakland",
    "Fredericksburg",
    "Worcester",
    "Montgomery",
    "Honolulu",
    "Los Angeles",
    "San Germán",
    "Santa Clara",
    "Ottawa",
    "Imperial",
    "Boulder",
    "Rockingham",
    "Kings",
    "St. Clair",
    "Strafford",
    "San Bernardino",
    "Kankakee",
    "Los Angeles",
    "Cook",
    "Yauco",
    "Licking",
    "Snohomish",
    "Williamson",
    "Johnson",
    "Hardin",
    "Hidalgo",
    "Los Angeles",
    "Terrebonne",
    "Yuma",
    "Weld",
    "Alamance",
    "Cameron",
    "Ventura",
    "Ada",
    "Wicomico",
    "San Mateo",
    "Sutter",
    "Kootenai",
    "Washington",
    "Orange",
    "Solano",
    "Eau Claire",
    "Collin",
    "Oneida",
    "La Crosse",
    "St. Tammany",
    "Stanislaus",
    "Riverside",
    "Tarrant",
    "Travis",
    "Plymouth",
    "San Bernardino",
    "Fulton",
    "St. Tammany",
    "Montgomery",
    "Mayagüez",
    "Alameda",
    "Charleston",
    "Whitfield",
    "Orange",
    "Montgomery",
    "Sacramento",
    "Los Angeles",
    "Citrus",
    "San Bernardino",
    "Napa",
    "Orange",
    "Comal",
    "Hidalgo",
    "Los Angeles",
    "Madison",
    "Williamsburg",
    "Harris",
    "Orange",
    "Larimer",
    "Jasper",
    "Wayne",
    "Madera",
    "Alameda",
    "Lebanon",
    "Orange",
    "Contra Costa",
    "Washington",
    "Orange",
    "Bowie",
    "Sacramento",
    "Alameda",
    "Denton",
    "Yolo",
    "Riverside",
    "San Bernardino",
    "Davis",
    "Santa Cruz",
    "Marathon",
    "Jefferson",
    "Greenville",
    "Frederick",
    "Los Angeles",
    "Champaign",
    "Lake",
    "Ventura",
    "Elkhart",
    "Bay",
    "Houston",
    "Merced",
    "Solano",
    "Hall",
    "Dallas",
    "Placer",
    "Whatcom",
    "Santa Barbara",
    "McLean",
    "Shasta",
    "Los Angeles",
    "Sumter",
    "Kent",
    "Pitt",
    "Williamson",
    "San Joaquin",
    "Fort Bend",
    "Stearns",
    "Saginaw",
    "Chittenden",
    "Dallas",
    "Washington",
    "Douglas",
    "Ventura",
    "Salt Lake",
    "Deschutes",
    "Tulsa",
    "Los Angeles",
    "Washoe",
    "San Diego",
    "Bell",
    "Los Angeles",
    "Pinal",
    "Los Angeles",
    "King",
    "San Bernardino",
    "Kane",
    "Riverside",
    "Fresno",
    "Bonneville",
    "Boulder",
    "Sandoval",
    "San Diego",
    "Warren",
    "San Diego",
    "San Joaquin",
    "Los Angeles",
    "Yavapai",
    "Hillsborough",
    "Sacramento",
    "Cumberland",
    "Butler",
    "Hidalgo",
    "Wayne",
    "Norfolk",
    "Orange",
    "Santa Fe",
    "King",
    "Alameda",
    "Hillsborough",
    "Florence",
    "Pennington",
    "Centre",
    "Lake",
    "Fulton",
    "St. Charles",
    "Jackson",
    "Essex",
    "Forrest",
    "Broward",
    "Anderson",
    "Santa Clara",
    "Middlesex",
    "King",
    "Pasco",
    "Williamson",
    "Los Angeles",
    "Westchester",
    "York",
    "St. Johns",
    "Cuyahoga",
    "Palm Beach",
    "Miami-Dade",
    "Cache",
    "Lee",
    "Laramie",
    "Riverside",
    "Tippecanoe",
    "Muskegon",
    "Santa Clara",
    "Santa Cruz",
    "Los Angeles",
    "DuPage",
    "San Diego",
    "Hernando",
    "Bristol",
    "Harris",
    "Dallas",
    "Ector",
    "Broome",
    "Broward",
    "Orange",
    "Salt Lake",
    "Santa Clara",
    "Broward",
    "Yakima",
    "Brazoria",
    "King",
    "Macomb",
    "Butte",
    "Washington",
    "Multnomah",
    "Yellowstone",
    "Fulton",
    "Middlesex",
    "Broward",
    "Gregg",
    "Sullivan",
    "San Mateo",
    "Howard",
    "Charlottesville",
    "Ponce",
    "Johnson",
    "Comanche",
    "Essex",
    "Salt Lake",
    "Miami-Dade",
    "Hamilton",
    "Burleigh",
    "Utah",
    "Black Hawk",
    "Union",
    "Riverside",
    "Kenosha",
    "San Diego",
    "Oklahoma",
    "Wayne",
    "Dougherty",
    "Macon",
    "Madison",
    "Montgomery",
    "Oakland",
    "Hennepin",
    "Coconino",
    "Kent",
    "Montgomery",
    "Jefferson",
    "Maricopa",
    "San Mateo",
    "Oakland",
    "Wake",
    "Passaic",
    "Calhoun",
    "Hillsborough",
    "Lowndes",
    "King",
    "Sumter",
    "Alameda",
    "Los Angeles",
    "Smith",
    "Midland",
    "Pueblo",
    "Orange",
    "Jefferson",
    "Boone",
    "Racine",
    "Carolina",
    "Macomb",
    "Lynchburg",
    "Galveston",
    "Doña Ana",
    "Middlesex",
    "Denton",
    "Los Angeles",
    "Hillsborough",
    "Ouachita",
    "Miami-Dade",
    "Charles",
    "Snohomish",
    "Los Angeles",
    "Galveston",
    "Lauderdale",
    "King",
    "Douglas",
    "Jackson",
    "Hamilton",
    "Vigo",
    "Monongalia",
    "Los Angeles",
    "Missoula",
    "Los Angeles",
    "Delaware",
    "Clark",
    "Brazos",
    "Los Angeles",
    "Hennepin",
    "Lake",
    "Brevard",
    "Mesa",
    "Maricopa",
    "Calcasieu",
    "Fairfield",
    "Alexandria",
    "Sebastian",
    "Bayamón",
    "Lee",
    "Boulder",
    "Olmsted",
    "Contra Costa",
    "Monroe",
    "Jefferson",
    "Broward",
    "Portsmouth",
    "Buchanan",
    "Lee",
    "Orange",
    "Palm Beach",
    "Washington",
    "Adams",
    "Palm Beach",
    "Onslow",
    "Tuscaloosa",
    "Arapahoe",
    "Providence",
    "Fulton",
    "Adams",
    "Charleston",
    "Will",
    "Broward",
    "Jefferson",
    "Taylor",
    "Los Angeles",
    "Tom Green",
    "Hennepin",
    "Suffolk",
    "Broward",
    "Bristol",
    "Kanawha",
    "Pinellas",
    "Harris",
    "Wichita",
    "Alameda",
    "Sangamon",
    "Pinellas",
    "Jackson",
    "Passaic",
    "Broward",
    "Jefferson",
    "Cleveland",
    "Woodbury",
    "St. Louis",
    "Bibb",
    "Clarke",
    "Wyandotte",
    "Middlesex",
    "Shawnee",
    "Hampton",
    "Los Angeles",
    "Santa Clara",
    "Ohio",
    "Prince William",
    "Winchester",
    "Franklin",
    "Chelan",
    "Contra Costa",
    "Passaic",
    "Juana Díaz",
    "Tarrant",
    "Hudson",
    "Florida",
    "San Mateo",
    "Tulare",
    "DeKalb",
    "Sullivan",
    "York",
    "Cowlitz",
    "Los Angeles",
    "King",
    "Utah",
    "Fairfield",
    "San Luis Obispo",
    "Warren",
    "LaPorte",
    "Spokane",
    "Hancock",
    "Hudson",
    "Guayama",
    "Orange",
    "Tulare",
    "Travis",
    "Suffolk",
    "Mercer",
    "Alameda",
    "Contra Costa",
    "Los Angeles",
    "Wayne",
    "Los Angeles",
    "Middlesex",
    "Mecklenburg",
    "Cleveland",
    "Los Angeles",
    "Santa Clara",
    "Williamson",
    "Hartford",
    "Middlesex",
    "Orange",
    "Sumner",
    "McLean",
    "Middlesex",
    "Cook",
    "San Bernardino",
    "Los Angeles",
    "Cook",
    "Suffolk",
    "San Bernardino",
    "Middlesex",
    "Los Angeles",
    "Dakota",
    "Kern",
    "Los Angeles",
    "Harris",
    "New Haven",
    "Orange",
    "Essex",
    "Hudson",
    "Rutherford",
    "Lorain",
    "Orange",
    "Dallas",
    "Cook",
    "Hudson",
    "Miami-Dade",
    "Cuyahoga",
    "Essex",
    "Twin Falls",
    "Orange",
    "San Diego",
    "Los Angeles",
    "Salt Lake",
    "Dallas",
    "Orange",
    "Sacramento",
    "Placer",
    "Riverside",
    "Alameda",
    "Orange",
    "Macomb",
    "Clark",
    "Johnson",
    "Cook",
    "Calhoun",
    "Fajardo",
    "Beaufort",
    "Will",
    "Salt Lake",
    "Alameda",
    "San Bernardino",
    "Brazoria",
    "Blair",
    "Caguas",
    "Howard",
    "Daviess",
    "Middlesex",
    "Bradley",
    "Washington",
    "Hennepin",
    "Hays",
    "Providence",
    "Madison",
    "Tarrant",
    "Sheboygan",
    "Carroll",
    "San Joaquin",
    "St. Charles",
    "Washington",
    "Morgan",
    "Orange",
    "Bay",
    "Wood",
    "Cook",
    "Benton",
    "Saratoga",
    "Dakota",
    "Grayson",
    "Floyd",
    "Broward",
    "Jefferson",
    "Los Angeles",
    "Polk",
    "Sonoma",
    "Los Angeles",
    "Dallas",
    "Riverside",
    "Linn",
    "Essex",
    "Palm Beach",
    "Polk",
    "Orange",
    "Hamilton",
    "Anoka",
    "Miami-Dade",
    "Los Angeles",
    "St. Charles",
    "Dakota",
    "Pierce",
    "Cook",
    "Highlands",
    "Salt Lake",
    "San Diego",
    "Cook",
    "Canyon",
    "Yolo",
    "New Haven",
    "Seminole",
    "San Diego",
    "Benton",
    "San Diego",
    "Los Angeles",
    "Marin",
    "Broward",
    "Johnson",
    "Los Angeles",
    "Cook",
    "Oakland",
    "Adams",
    "Pottawattamie",
    "Baltimore",
    "Los Angeles",
    "Wayne",
    "Los Angeles",
    "Miami-Dade",
    "Tarrant",
    "Douglas",
    "Washington",
    "Jackson",
    "DeKalb",
    "Riverside",
    "Montgomery",
    "Loudoun",
    "Maricopa",
    "DuPage",
    "Yolo",
    "Riverside",
    "New Haven",
    "Hall",
    "St. Louis",
    "Dorchester",
    "Benton",
    "Montgomery",
    "Thurston",
    "Pinal",
    "Shelby",
    "Los Angeles",
    "Los Angeles",
    "Madison",
    "St. Joseph",
    "Denton",
    "Tippecanoe",
    "Los Angeles",
    "Kalamazoo",
    "DuPage",
    "Wilson",
    "Hennepin",
    "Rensselaer",
    "Tarrant",
    "Bartholomew",
    "Gallatin",
    "Rapides",
    "Harrisonburg",
    "Placer",
    "Henrico",
    "Sacramento",
    "Orange",
    "Chaves",
    "Tangipahoa",
    "Riverside",
    "Lehigh",
    "Cook",
    "Maricopa",
    "Franklin",
    "Skagit",
    "Williamson",
    "Los Angeles",
    "San Luis Obispo",
    "Sacramento",
    "Sacramento",
    "Bannock",
    "Oakland",
    "Cook",
    "Fairfax",
    "Faulkner",
    "Rock",
    "Hartford",
    "Waukesha",
    "Bossier",
    "Pima",
    "Dakota",
    "Hennepin",
    "San Diego",
    "Chemung",
    "Anne Arundel",
    "Douglas",
    "Montgomery",
    "Volusia",
    "Victoria",
    "Cook",
    "Fairbanks North Star",
    "King",
    "Miami-Dade",
    "Polk",
    "Riverside",
    "Palm Beach",
    "Westchester",
    "Palm Beach",
    "Essex",
    "Anoka",
    "Dubuque",
    "Benton",
    "Lane",
    "Grand Forks",
    "Allen",
    "Jackson",
    "Natrona",
    "Alameda",
    "Pierce",
    "Nash",
    "DeSoto",
    "Milwaukee",
    "Fairfax",
    "Macomb",
    "Middlesex",
    "Marin",
    "Pinellas",
    "Pinal",
    "Manatee",
    "Riley",
    "King",
    "Miami-Dade",
    "Butler",
    "Oakland",
    "San Bernardino",
    "Cobb",
    "Bristol",
    "Howard",
    "Mohave",
    "Wake",
    "Oklahoma",
    "Washington",
    "Broward",
    "Carson City",
    "DeKalb",
    "Hampden",
    "Tarrant",
    "Cascade",
    "Osceola",
    "Anne Arundel",
    "Cook",
    "Orange",
    "Nassau",
    "Pima",
    "Fort Bend",
    "Los Angeles",
    "Ward",
    "Ingham",
    "Cabarrus",
    "Camden",
    "Garfield",
    "Cook",
    "St. Louis",
    "Winnebago",
    "Craighead",
    "Union",
    "Providence",
    "Oakland",
    "DeKalb",
    "Cook",
    "Houston",
    "Story",
    "Charlotte",
    "Sarpy",
    "Contra Costa",
    "Broomfield",
    "Montgomery",
    "Sacramento",
    "Orange",
    "San Bernardino",
    "Kent",
    "Broward",
    "Broward",
    "Pasco",
    "Salt Lake",
    "Volusia",
    "Schenectady",
    "Collin",
    "Miami-Dade",
    "Galveston",
    "Miami-Dade",
    "Bucks",
    "Pinellas",
    "Miami-Dade",
    "New Castle",
    "Miami-Dade",
    "Shelby",
    "Palm Beach",
    "Hennepin",
    "Riverside",
    "Westchester",
    "Hennepin",
    "Oakland",
    "Pulaski",
    "Summit",
    "Kent",
    "Salt Lake",
    "Payne",
    "Fairfax",
    "Prince George's",
    "Milwaukee",
    "Marion",
    "King",
    "Hillsborough",
    "Montgomery",
    "Cobb",
    "Niagara",
    "Miami-Dade",
    "Richland",
    "Johnson",
    "Montgomery",
    "Santa Clara",
    "Guaynabo",
    "Greene",
    "Pima",
    "Baltimore",
    "Johnson",
    "Montgomery",
    "Lake",
    "Lake",
    "Saline",
    "DuPage",
    "Broward",
    "Middlesex",
    "Orange",
    "Prince William",
    "San Mateo",
    "Camden",
    "Santa Clara",
    "Salt Lake",
    "Riverside",
    "Clark",
    "Hawaii",
    "Bergen",
    "Bristol",
    "Wake",
    "DuPage",
    "Essex",
    "Nassau",
    "Davis",
    "Harris",
    "Berkeley",
    "Santa Clara",
    "Williamson",
    "Blue Earth",
    "Santa Barbara",
    "Stanislaus",
    "Prince William",
    "Berkshire",
    "Lake",
    "Riverside",
    "Fairfield",
    "Middlesex",
    "Montgomery",
    "Scott",
    "Los Angeles",
    "Union",
    "Black Hawk",
    "Rock Island",
    "Delaware",
    "Fulton",
    "Worcester",
    "Hancock",
    "Sonoma",
    "Providence",
    "Los Angeles",
    "Nassau",
    "Suffolk",
    "Manassas",
    "Middlesex",
    "Cook",
    "Hampden",
    "Weber",
    "Marion",
    "Fort Bend",
    "Hampden",
    "Bernalillo",
    "Merced",
    "San Benito",
    "San Mateo",
    "Linn",
    "Broward",
    "Butler",
    "Utah",
    "Hudson",
    "Galveston",
    "Will",
    "Suffolk",
    "Imperial",
    "Palm Beach",
    "St. Charles",
    "Franklin",
    "Curry",
    "Sumner",
    "San Bernardino",
    "Baltimore",
    "Orange",
    "Cook",
    "DuPage",
    "Contra Costa",
    "Maury",
    "Dallas",
    "Franklin",
    "DuPage",
    "Prince George's",
    "Rock Island",
    "Cook",
    "Hidalgo",
    "Kane",
    "San Diego",
    "Bergen",
    "Honolulu",
    "Rock",
    "Seminole",
    "Washington",
    "Utah",
    "Franklin",
    "Clackamas",
    "Lake",
    "Tulsa",
    "Columbia",
    "DeSoto",
    "Pinellas",
    "Cass",
    "Nassau",
    "Salt Lake",
    "DuPage",
    "Contra Costa",
    "Wayne",
    "Hillsborough",
    "Ventura",
    "Los Angeles",
    "Waukesha",
    "Floyd",
    "Milwaukee",
    "Hennepin",
    "Nassau",
    "Cook",
    "Androscoggin",
    "St. Louis",
    "Scott",
    "Ramsey",
    "Maricopa",
    "Rutherford",
    "Kendall",
    "Osceola",
    "Middlesex",
    "Fairfield",
    "San Mateo",
    "Val Verde",
    "Franklin",
    "Riverside",
    "Orange",
    "Tooele",
    "Kootenai",
    "Harris",
    "Milwaukee",
    "Madison",
    "Fayette",
    "Wilson",
    "Los Angeles",
    "Los Angeles",
    "Los Angeles",
    "Marion",
    "Montgomery",
    "Delaware",
    "Suffolk",
    "Los Angeles",
    "St. Johns",
    "Honolulu",
    "Dane",
    "Montgomery",
    "San Mateo",
    "Summit",
    "Litchfield",
    "Lorain",
    "Contra Costa",
    "Whitman",
    "DuPage",
    "Utah",
    "Baltimore",
    "Liberty",
    "Nassau",
    "Cook",
    "Scott",
    "DuPage",
    "Yamhill",
    "Salt Lake",
    "Ascension",
    "Snohomish",
    "Warren",
    "Medina",
    "El Paso",
    "San Bernardino",
    "Rockland",
    "Kern",
    "Wayne",
    "Miami-Dade",
    "DuPage",
    "Anoka",
    "Nez Perce",
    "Nassau",
    "King",
    "Coryell",
    "Middlesex",
    "El Dorado",
    "Mecklenburg",
    "Manitowoc",
    "Pueblo",
    "Honolulu",
    "Boone",
    "Honolulu",
    "Tarrant",
    "Montgomery",
    "Walla Walla",
    "Brevard",
    "San Juan",
    "Bergen",
    "Tazewell",
    "Seminole",
    "Loudoun",
    "Rockwall",
    "Contra Costa",
    "Merrimack",
    "Cuyahoga",
    "Los Angeles",
    "Denton",
    "Volusia",
    "Orange",
    "Polk",
    "Salt Lake",
    "Hays",
    "Miami-Dade",
    "Fond du Lac",
    "Snohomish",
    "Champaign",
    "Dallas",
    "Anne Arundel",
    "Pinal",
    "Midland",
    "Essex",
    "Trujillo Alto",
    "Maury",
    "Fairfax",
    "Palm Beach",
    "Lee",
    "Franklin",
    "Anne Arundel",
    "Hillsborough",
    "Dallas",
    "El Paso",
    "Snohomish",
    "Adams",
    "Seminole",
    "Mohave",
    "King",
    "Cole",
    "Los Angeles",
    "Reno",
    "Waukesha",
    "Clackamas",
    "Cape Girardeau",
    "Lea",
    "Cobb",
    "Sacramento",
    "Waukesha",
    "Dallas",
    "Hamilton",
    "Los Angeles",
    "Los Angeles",
    "Garland",
    "Tarrant",
    "Baltimore",
    "Danville",
    "Adams",
    "Coweta",
    "McHenry",
    "Maricopa",
    "Orange",
    "Iredell",
    "Hidalgo",
    "Fulton",
    "Los Angeles",
    "Miami-Dade",
    "Porter",
    "Hanover",
    "Suffolk",
    "Wake",
    "Ellis",
    "Miami-Dade",
    "Sacramento",
    "Leavenworth",
    "Hillsborough",
    "Utah",
    "Washington",
    "Nassau",
    "Dakota",
    "Muskogee",
    "Fulton",
    "Josephine",
    "Fort Bend",
    "Miami-Dade",
    "Lake",
    "Los Angeles",
    "DeKalb",
    "Union",
    "Palm Beach",
    "Autauga",
    "Saline",
    "Salt Lake",
    "Elkhart",
    "Wilson",
    "Miami-Dade",
    "Russell",
    "Cobb",
    "St. Louis",
    "Columbia",
    "Iron",
    "Greene",
    "Hendricks",
    "Prince George's",
    "Broward",
    "Middlesex",
    "Shelby",
    "Union",
    "Suffolk",
    "Gwinnett",
    "Broward",
    "Pierce",
    "Orange",
    "Palm Beach",
    "Trumbull",
    "Ramsey",
    "Luzerne",
    "Anne Arundel",
    "Miami-Dade",
    "Sacramento",
    "Arapahoe",
    "Cochise",
    "Fairfax",
    "Orange",
    "Kane",
    "Prince William",
    "Suffolk",
    "Hillsborough",
    "Harris",
    "Porter",
    "Will",
    "Jefferson",
    "Tarrant",
    "Fairfax",
    "Clay",
    "Bexar",
    "Pierce",
    "Shelby",
    "Riverside",
    "Lee",
    "Pierce",
    "Lauderdale",
    "Fairfax",
    "Clark",
    "Jefferson",
    "Baltimore",
    "Milwaukee",
    "DeKalb",
    "Los Angeles",
    "Volusia",
    "Franklin",
    "Brevard",
    "Harrison",
    "Los Angeles",
    "Douglas",
    "Adams",
    "Pierce",
    "Lee",
    "St. Clair",
    "Jefferson",
    "Yuma",
    "Rowan",
    "Buffalo",
    "Cuyahoga",
    "Jefferson",
    "Fairfax",
    "Arapahoe",
    "Pima",
    "Johnson",
    "Pasco",
    "Cuyahoga",
    "Broward",
    "Angelina",
    "Yavapai",
    "Walker",
    "Etowah",
    "Baltimore",
    "Broward",
    "Bergen",
    "Nassau",
    "Cuyahoga",
    "Clay",
    "Kenton",
    "Macomb",
    "Utah",
    "Putnam",
    "Nassau",
    "Loudoun",
    "Tarrant",
    "Orange",
    "Pierce",
    "Los Angeles",
    "Baltimore",
    "Davis",
    "Montgomery",
    "St. Lucie",
    "Nacogdoches",
    "Cook",
    "Miami-Dade",
    "Lewis and Clark",
    "Silver Bow",
    "Scott",
    "Cuyahoga",
    "Los Angeles",
    "Jefferson",
    "Deschutes",
    "Otero",
    "Wayne",
    "Ellis",
    "Santa Barbara",
    "Jefferson",
    "Suffolk",
    "San Diego",
    "Penobscot",
    "Davis",
    "St. Louis",
    "Lake",
    "Santa Barbara",
    "Suffolk",
    "Monmouth",
    "McHenry",
    "Lake",
    "Loudoun",
    "Collier",
    "San Luis Obispo",
    "Clay",
    "Utah",
    "Fairfax",
    "Ventura",
    "Essex",
    "Merced",
    "Oakland",
    "Jessamine",
    "Baltimore",
    "Union",
    "Nassau",
    "Davis",
    "San Mateo",
    "Los Angeles",
    "New Haven",
    "Contra Costa",
    "Baltimore",
    "Mecklenburg",
    "Gwinnett",
    "Christian",
    "Riverside",
    "El Paso",
    "San Mateo",
    "Miller",
    "Sacramento",
    "Santa Clara",
    "Union",
    "Cuyahoga",
    "Maui",
    "Niagara",
    "Baltimore",
    "Baltimore",
    "Lake",
    "Lake",
    "Cook",
    "San Mateo",
    "Guadalupe",
    "St. Clair",
    "Solano",
    "Yuma",
    "Oakland",
    "Maverick",
    "Chautauqua",
    "Eddy",
    "St. John the Baptist",
    "Cook",
    "Westchester",
    "McHenry",
    "McHenry",
    "Washington",
    "Washington",
    "Kern",
    "Cook",
    "Lake",
    "Brown",
    "Delaware",
    "Kern",
    "Wake",
    "Collier",
    "Coffee",
    "Orange",
    "Solano",
    "Anderson",
    "Canadian",
    "Sonoma",
    "New Castle",
    "Cook",
    "Prince George's",
    "Cook",
    "Wayne",
    "Suffolk",
    "Lycoming",
    "Seminole",
    "Riverside",
    "Franklin",
    "Washington",
    "Bergen",
    "Middlesex",
    "DuPage",
    "Honolulu",
    "Henderson",
    "Cumberland",
    "Kenton",
    "Ada",
    "Greene",
    "Clark",
    "Bexar",
    "Nye",
    "St. Louis",
    "Wake",
    "Los Angeles",
    "New London",
    "Anoka",
    "Nassau",
    "Riverside",
    "Tulsa",
    "Wayne",
    "Salt Lake",
    "Cerro Gordo",
    "San Mateo",
    "McHenry",
    "Suffolk",
    "Tarrant",
    "Bergen",
    "DeSoto",
    "Pinal",
    "Williamson",
    "Mecklenburg",
    "Carver",
    "Bergen",
    "Finney",
    "King",
    "Will",
    "Rankin",
    "Wayne",
    "Fresno",
    "Clackamas",
    "Lake",
    "Miami-Dade",
    "Ford",
    "San Diego",
    "San Diego",
    "Wayne",
    "Cook",
    "Davidson",
    "Weld",
    "Lonoke",
    "Ramsey",
    "DuPage",
    "Suffolk",
    "Marshall",
    "Greene",
    "Honolulu",
    "Clark",
    "Dodge",
    "Nassau",
    "Sacramento",
    "Summit",
    "Medina",
    "Suffolk",
    "Maricopa",
    "Miami",
    "Jefferson",
    "Clinton",
    "McHenry",
    "Marion",
    "Contra Costa",
    "Waukesha",
    "Polk",
    "Kings",
    "Collin",
    "Steele",
    "Bergen",
    "Imperial",
    "Los Angeles",
    "Roanoke",
    "Los Angeles",
    "Fresno",
    "Contra Costa",
    "Martin",
    "King",
    "Hillsborough",
    "Monterey",
    "Maricopa",
    "Will",
    "Oktibbeha",
    "Salem",
    "Dallas",
    "Madison",
    "Bergen",
    "Pinellas",
    "Kleberg",
    "Harris",
    "Winnebago",
    "Washington",
    "Williams",
    "Cook",
    "Orange",
    "Cumberland",
    "Berkeley",
    "Muskingum",
    "Prince George's",
    "Jefferson",
    "Horry",
    "Mower",
    "Contra Costa",
    "Suffolk",
    "Bexar",
    "Brown",
    "Juneau",
    "King",
    "Greenville",
    "Orange",
    "Aiken",
    "Jackson",
    "Parker",
    "Bell",
    "Wayne",
    "Pottawatomie",
    "Santa Clara",
    "Miami-Dade",
    "Marion",
    "Broward",
    "Rockland",
    "Prince George's",
    "Athens",
    "Boone",
    "Stark",
    "Albany",
    "Hennepin",
    "Allegheny",
    "Escambia",
    "Cherokee",
    "Campbell",
    "Johnson",
    "Pima",
    "Guadalupe",
    "Troup",
    "Petersburg",
    "Hennepin",
    "Mohave",
    "Tompkins",
    "Vermilion",
    "Santa Clara",
    "San Diego",
    "Wake",
    "Pima",
    "St. Louis",
    "Knox",
    "Alameda",
    "Orange",
    "Lee",
    "Wood",
    "Craven",
    "Lake",
    "Hamblen",
    "Kern",
    "DeKalb",
    "Lee",
    "St. Louis",
    "Winona",
    "San Bernardino",
    "Howard",
    "Hillsborough",
    "Henry",
    "Mahoning",
    "Portage",
    "Iberia",
    "Clay",
    "Cherokee",
    "Cuyahoga",
    "Pope",
    "Volusia",
    "Northampton",
    "Humboldt",
    "Henrico",
    "Johnson",
    "Cuyahoga",
    "Scott",
    "Lake",
    "Ramsey",
    "Santa Barbara",
    "Hillsborough",
    "Hunt",
    "Anne Arundel",
    "Iredell",
    "Madison",
    "Benton",
    "Lafayette",
    "Kent",
    "Howard",
    "Pulaski",
    "Brazoria",
    "Gwinnett",
    "Washington",
    "Anoka",
    "Madison",
    "Limestone",
    "St. Louis",
    "Jackson",
    "Allegheny",
    "Brevard",
    "Grant",
    "Pasco",
    "Douglas",
    "Hendricks",
    "Baldwin",
    "Kane",
    "Hillsborough",
    "Miami-Dade",
    "Henry",
    "Kent",
    "Dallas",
    "Jefferson",
    "Miami-Dade",
    "Indian River",
    "Portage",
    "St. Joseph",
    "Prince George's",
    "Salt Lake",
    "Harford",
    "Fairfax",
    "McCracken",
    "Strafford",
    "Baltimore",
    "Harford",
    "Ingham",
    "Jefferson",
    "Oneida",
    "Pulaski",
    "Randolph",
    "Latah",
    "Cayuga",
    "Contra Costa",
    "Dallas",
    "Hillsborough",
    "Clay",
    "Bulloch",
    "Palm Beach",
    "Salt Lake",
    "Isabella",
    "Blount",
    "Hillsborough",
    "Madison",
    "Ector",
    "Orange",
    "Mercer",
    "Pinellas",
    "Jefferson",
    "Anne Arundel",
    "Genesee",
    "Riverside",
    "Monterey",
    "East Baton Rouge",
    "Carver",
    "Summit",
    "Hillsborough",
    "Baltimore",
    "Union",
    "Racine",
    "Lyon",
    "DeKalb",
    "Chatham",
    "Hampshire",
    "Jefferson",
    "Miami-Dade",
    "Montgomery",
    "Adams",
    "Grayson",
    "Forsyth",
    "Washington",
    "Baltimore",
    "Manatee",
    "Carter",
    "Boone",
    "DuPage",
    "Dakota",
    "Dane",
    "Allegheny",
    "Hillsborough",
    "Montgomery",
    "Sherburne",
    "Racine",
    "Hillsborough",
    "Clay",
    "Erie",
    "Des Moines",
    "St. Clair",
    "Carroll",
    "Montgomery",
    "Comal",
    "Luzerne",
    "Snohomish",
    "St. Louis",
    "Kitsap",
    "Staunton",
    "Lake",
    "Westchester",
    "King",
    "Tuscaloosa",
    "Howard",
    "Nassau",
    "Monroe",
    "Wapello",
    "Will",
    "Madison",
    "Cook",
    "Anne Arundel",
    "Davis",
    "Tulare",
    "Cook",
    "Shelby",
    "Clackamas",
    "Fairfax",
    "Stephenson",
    "Los Angeles",
    "Madison",
    "Lorain",
    "Ingham",
    "Sedgwick",
    "Tarrant",
    "Clark",
    "Wayne",
    "Somerset",
    "Los Angeles",
    "Lincoln",
    "Fresno",
    "Fairfax",
    "Webster",
    "Ottawa",
    "Flathead",
    "Westchester",
    "DeKalb",
    "Suffolk",
    "Medina",
    "Oakland",
    "Rice",
    "Gwinnett",
    "Madison",
    "Brevard",
    "Seminole",
    "Prince George's",
    "Rankin",
    "Middlesex",
    "Cameron",
    "Bergen",
    "Kaufman",
    "Eaton",
    "Hillsborough",
    "Muscatine",
    "Lake",
    "Cook",
    "Yamhill",
    "Androscoggin",
    "Duval",
    "Sweetwater",
    "Lake",
    "Prince George's",
    "Cass",
    "Greenville",
    "Dakota",
    "Fairfax",
    "Cook",
    "Platte",
    "Grant",
    "Snohomish",
    "St. Louis",
    "Cook",
    "Miami-Dade",
    "Island",
    "Fort Bend",
    "Middlesex",
    "San Bernardino",
    "Maricopa",
    "Dakota",
    "Butler",
    "Kerr",
    "Crawford",
    "Weld",
    "Stark",
    "Beaufort",
    "Cuyahoga",
    "King",
    "Coryell",
    "Cheshire",
    "Horry",
    "Suffolk",
    "Brevard",
    "Ulster",
    "DuPage",
    "San Mateo",
    "Knox",
    "White",
    "Orange",
    "Cook",
    "Hillsborough",
    "Kane",
    "Lorain",
    "Maui",
    "DuPage",
    "Winnebago",
    "Allegheny",
    "Marion",
    "Montgomery",
    "New Castle",
    "Lexington",
    "Los Angeles",
    "DuPage",
    "Hopewell",
    "Montgomery",
    "Hancock",
    "Ramsey",
    "Canadian",
    "Morton",
    "Lake",
    "Stanislaus",
    "Monterey",
    "Summit",
    "El Dorado",
    "Waynesboro",
    "Vega Baja",
    "Codington",
    "Tazewell",
    "Geary",
    "Bedford",
    "Johnson",
    "Nassau",
    "Lake",
    "Pasco",
    "Santa Rosa",
    "Los Angeles",
    "DuPage",
    "Cook",
    "Fairfax",
    "Kings",
    "Bell",
    "Miami-Dade",
    "Suffolk",
    "Fairfax",
    "Davis",
    "Polk",
    "Cuyahoga",
    "Chesterfield",
    "Christian",
    "Milwaukee",
    "Union",
    "Kern",
    "Pierce",
    "McKinley",
    "DuPage",
    "Snohomish",
    "Indian River",
    "Nassau",
    "Loudoun",
    "Wood",
    "East Baton Rouge",
    "Los Angeles",
    "King",
    "Cook",
    "Nassau",
    "Fairfield",
    "Clark",
    "Stark",
    "Clark",
    "Jefferson",
    "Honolulu",
    "Fairfax",
    "Kane",
    "Jefferson",
    "LaPorte",
    "Escambia",
    "Ross",
    "Miami",
    "San Diego",
    "Jackson",
    "Los Angeles",
    "Suffolk",
    "Oakland",
    "Johnson",
    "Pettis",
    "Ellis",
    "Union",
    "Franklin",
    "Warren",
    "Snohomish",
    "Clackamas",
    "Cass",
    "Hamilton",
    "San Bernardino",
    "Riverside",
    "Galveston",
    "Volusia",
    "San Joaquin",
    "San Bernardino",
    "Los Angeles",
    "Stanislaus",
    "Will",
    "Davis",
    "Cook",
    "Collin",
    "Shelby",
    "Bergen",
    "Kittitas",
    "Bexar",
    "Lenawee",
    "Hudson",
    "Ashland",
    "Gwinnett",
    "Lake",
    "Okaloosa",
    "Lamar",
    "Miami-Dade",
    "Orange",
    "Marquette",
    "Okaloosa",
    "Johnson",
    "Los Angeles",
    "Washington",
    "Niagara",
    "Horry",
    "Manatee",
    "Ozaukee",
    "Stanislaus",
    "Brookings",
    "Newport",
    "Tarrant",
    "Elko",
    "Muskegon",
    "Hinds",
    "Lake",
    "Los Angeles",
    "Worcester",
    "St. Johns",
    "Somerset",
    "Fairfax",
    "Rice",
    "Crittenden",
    "Kay",
    "Miami-Dade",
    "San Joaquin",
    "Sacramento",
    "Snohomish",
    "Jefferson",
    "Baltimore",
    "Wayne",
    "Arapahoe",
    "Clark",
    "Johnston",
    "Cobb",
    "Ventura",
    "Los Angeles",
    "Lincoln",
    "King",
    "Stephens",
    "Tulsa",
    "Aiken",
    "Jefferson",
    "Okaloosa",
    "Montgomery",
    "Anoka",
    "Fairfax",
    "Harrison",
    "Hardin",
    "Spalding",
    "Douglas",
    "Howard",
    "Warren",
    "Tarrant",
    "St. Bernard",
    "Navarro",
    "Los Angeles",
    "Winnebago",
    "King",
    "Greenville",
    "Marshall",
    "Montgomery",
    "Prince George's",
    "Thurston",
    "Yuba",
    "Rockland",
    "Greenwood",
    "Placer",
    "Johnson",
    "Fairfax",
    "Dallas",
    "Denton",
    "Oklahoma",
    "Los Angeles",
    "Brunswick",
    "Wayne",
    "Baldwin",
    "Orange",
    "Escambia",
    "Cataño",
    "San Diego",
    "York",
    "New Castle",
    "Klamath",
    "Cuyahoga",
    "Richland",
    "Frederick",
    "Calhoun",
    "Creek",
    "York",
    "Washoe",
    "Prince William",
    "Ada",
    "Rock Island",
    "Forsyth",
    "San Diego",
    "Washtenaw",
    "St. Louis",
    "Miami-Dade",
    "Mesa",
    "Bartow",
    "Orange",
    "Lake",
    "Pasco",
    "Pickens",
    "Escambia",
    "Marion",
    "Erath",
    "Nassau",
    "Hennepin",
    "Pima",
    "Kenosha",
    "San Diego",
    "Morris",
    "Saline",
    "Montgomery",
    "Prince William",
    "Hillsborough",
    "Boyd",
    "Snohomish",
    "Manatee",
    "San Diego",
    "Suffolk",
    "Volusia",
    "Hillsborough",
    "Weld",
    "Los Angeles",
    "Santa Cruz",
    "Crawford",
    "Solano",
    "Alameda",
    "Clackamas",
    "Somerset",
    "Prince George's",
    "Terrebonne",
    "Escambia",
    "Utah",
    "Hillsborough",
    "Anoka",
    "Monterey",
    "Hennepin",
    "Gloucester",
    "Dakota",
    "Jackson",
    "Cuyahoga",
    "Atlantic",
    "Pierce",
    "Scioto",
    "Los Angeles",
    "Collier",
    "Hale",
    "Phelps",
    "Napa",
    "Will",
    "Riverside",
    "Sarasota",
    "San Bernardino",
    "Fairfax",
    "Los Angeles",
    "Hennepin",
    "Kern",
    "Christian",
    "Fulton",
    "Montgomery",
    "Alameda",
    "Snohomish",
    "Robeson",
    "Sarpy",
    "Harris",
    "Coles",
    "Oakland",
    "Kitsap",
    "Lowndes",
    "Bay",
    "Mobile",
    "Jefferson",
    "Lyon",
    "Pinellas",
    "Snohomish",
    "Coffee",
    "Snohomish",
    "Lucas",
    "Ellis",
    "York",
    "Weber",
    "Gwinnett",
    "Polk",
    "Kern",
    "Fairbanks North Star",
    "El Paso",
    "Honolulu",
    "Santa Rosa",
    "Palm Beach",
    "Allegany",
    "Kandiyohi",
    "Boulder",
    "Nassau",
    "Orange",
    "Cuyahoga",
    "Jackson",
    "Honolulu",
    "Washington",
    "Oklahoma",
    "Nassau",
    "St. Louis",
    "Nassau",
    "Washington",
    "King",
    "Calloway",
    "Hamilton",
    "Clark",
    "Contra Costa",
    "Hidalgo",
    "Brazoria",
    "Riverside",
    "Lake",
    "Watauga",
    "Greenville",
    "Dakota",
    "Lake",
    "Box Elder",
    "Will",
    "Morgan",
    "Lucas",
    "Providence",
    "York",
    "Suffolk",
    "Kern",
    "Los Angeles",
    "St. Francois",
    "Utah",
    "Hopkins",
    "St. Louis",
    "San Bernardino",
    "Snohomish",
    "Adams",
    "Seward",
    "Morris",
    "Baltimore",
    "Cumberland",
    "Prince George's",
    "Passaic",
    "Polk",
    "Los Angeles",
    "Lake",
    "New Haven",
    "Marion",
    "Cuyahoga",
    "Suffolk",
    "Cumberland",
    "New Haven",
    "LaSalle",
    "Kankakee",
    "Riverside",
    "Cook",
    "Nassau",
    "Harris",
    "Summit",
    "Miami-Dade",
    "Ocean",
    "Jim Wells",
    "Klamath",
    "Cuyahoga",
    "Rockland",
    "Cook",
    "Shelby",
    "La Crosse",
    "Franklin",
    "Cook",
    "Allegheny",
    "Harvey",
    "Johnson",
    "Contra Costa",
    "Lake",
    "Los Angeles",
    "Lawrence",
    "Culpeper",
    "Riverside",
    "Bryan",
    "Cuyahoga",
    "Hamilton",
    "Washington",
    "Cook",
    "Suffolk",
    "Anne Arundel",
    "Cook",
    "Imperial",
    "Thomas",
    "St. Louis",
    "Jackson",
    "Cortland",
    "Cuyahoga",
    "Clark",
    "Marion",
    "Washington",
    "Hudson",
    "Warren",
    "Milwaukee",
    "Hillsborough",
    "Lake",
    "Essex",
    "Ashtabula",
    "Boone",
    "Fort Bend",
    "Bergen",
    "Nassau",
    "Fairfax",
    "Sheridan",
    "Trumbull",
    "Humboldt",
    "Passaic",
    "Pittsburg",
    "Lake",
    "Winnebago",
    "DuPage",
    "Camden",
    "Los Angeles",
    "San Luis Obispo",
    "Union",
    "Chesterfield",
    "Suffolk",
    "Nassau",
    "St. Louis",
    "Monterey",
    "Suffolk",
    "Williamson",
    "Madison",
    "Wayne",
    "Tarrant",
    "Montgomery",
    "Ottawa",
    "DeKalb",
    "McDonough",
    "San Luis Obispo",
    "Bergen",
    "Hidalgo",
    "Clackamas",
    "Erie",
    "Bergen",
    "Pinellas",
    "Orange",
    "Fairfax",
    "Pulaski",
    "Summit",
    "Douglas",
    "Orange",
    "Matagorda",
    "King",
    "Lee",
    "Jackson",
    "Nassau",
    "Middlesex",
    "Montgomery",
    "Freeborn",
    "Cook",
    "Adair",
    "Wood",
    "Prince William",
    "Morris",
    "Fairfax",
    "Los Angeles",
    "Anne Arundel",
    "Caldwell",
    "Stearns",
    "McHenry",
    "East Baton Rouge",
    "Kane",
    "Pasquotank",
    "Anne Arundel",
    "Cass",
    "Manassas Park",
    "Humacao",
    "Madera",
    "Butte",
    "San Diego",
    "Pontotoc",
    "Miami-Dade",
    "Lewis",
    "Anoka",
    "Maui",
    "Camden",
    "Umatilla",
    "Tuscarawas",
    "Harris",
    "Anne Arundel",
    "Oswego",
    "Middlesex",
    "DuPage",
    "Jefferson",
    "Coles",
    "Colonial Heights",
    "Camden",
    "Titus",
    "Lenoir",
    "Huntington",
    "Williamson",
    "Barrow",
    "Middlesex",
    "Seneca",
    "Marion",
    "Benton",
    "Linn",
    "Polk",
    "Nassau",
    "Cook",
    "Jefferson",
    "Cook",
    "Houston",
    "Washington",
    "Brevard",
    "Knox",
    "Pima",
    "Gray",
    "Clallam",
    "Suffolk",
    "Kennebec",
    "Dane",
    "Kane",
    "Carroll",
    "Butte",
    "Baldwin",
    "Sarasota",
    "Clark",
    "Clark",
    "Fairfax",
    "Davidson",
    "Cleveland",
    "Calcasieu",
    "Miami-Dade",
    "Nassau",
    "Kendall",
    "Gordon",
    "Island",
    "Cook",
    "Ingham",
    "Cuyahoga",
    "Washington",
    "Chittenden",
    "Winnebago",
    "Seminole",
    "Leon",
    "Fresno",
    "Suffolk",
    "Lake",
    "Clayton",
    "Brown",
    "Sarpy",
    "Chesterfield",
    "Craven",
    "Clinton",
    "Robertson",
    "Prince George's",
    "Suffolk",
    "Los Angeles",
    "Windham",
    "El Paso",
    "Tulsa",
    "Will",
    "Skagit",
    "Monroe",
    "Greenville",
    "St. Johns",
    "Fairfax",
    "Montrose",
    "Rogers",
    "Baltimore",
    "Santa Cruz",
    "Henry",
    "La Plata",
    "Allegheny",
    "Charlotte",
    "Westchester",
    "Williamson",
    "Suffolk",
    "Nassau",
    "Orange",
    "St. Louis",
    "El Dorado",
    "Jefferson",
    "Fairfax",
    "Jackson",
    "Hamilton",
    "Collier",
    "Jefferson",
    "St. Louis",
    "Prince George's",
    "Wood",
    "Hennepin",
    "Prince George's",
    "Anderson",
    "Stark",
    "Fayette",
    "Jefferson",
    "Brown",
    "Dallas",
    "Lexington",
    "Prince George's",
    "Jackson",
    "Chesterfield",
    "Henrico",
    "Hendricks",
    "San Patricio",
    "Pinal",
    "Jones",
    "Radford",
    "Pickens",
    "Wright",
    "Doña Ana",
    "Weber",
    "Brown",
    "Butler",
    "Indian River",
    "Clackamas",
    "Miami-Dade",
    "Ocean",
    "Nassau",
    "Wright",
    "Honolulu",
    "Prince William",
    "Kaufman",
    "Westmoreland",
    "Montgomery",
    "Montgomery",
    "DeKalb",
    "Snohomish",
    "Pinellas",
    "Fort Bend",
    "Fairfax",
    "Hidalgo",
    "Davis",
    "Riverside",
    "Gwinnett",
    "Fort Bend",
    "Kent",
    "Monmouth",
    "San Diego",
    "Escambia",
    "Miami-Dade",
    "Wayne",
    "Jefferson",
    "Huron",
    "Pike",
    "Chester",
    "Kenton",
    "Waukesha",
    "Montgomery",
    "Bristol",
    "Baldwin",
    "Berkeley",
    "Canadian",
    "Natchitoches",
    "Mobile",
    "King",
    "Tift",
    "Montgomery",
    "Sevier",
    "Chester",
    "Bay",
    "Kendall",
    "Cambria",
    "Lake",
    "Matanuska-Susitna",
    "Boyle",
    "Allegheny",
    "Wake",
    "Suffolk",
    "Defiance",
    "Dallas",
    "St. Louis",
    "Prince William",
    "Fairfax",
    "Umatilla",
    "Polk",
    "Humboldt",
    "St. Louis",
    "Kennebec",
    "Denton",
    "Talbot",
    "Multnomah",
    "Los Angeles",
    "Oakland",
    "Scott",
    "Portage",
    "Travis",
    "Knox",
    "Los Angeles",
    "Tazewell",
    "Prince George's",
    "Anoka",
    "Miami-Dade",
    "Yakima",
    "Dunn",
    "Burke",
    "San Diego",
    "St. Landry",
    "Grays Harbor",
    "Morris",
    "Hays",
    "Hidalgo",
    "Wright",
    "Cook",
    "Belknap",
    "Nevada",
    "Raleigh",
    "St. Louis",
    "Clark",
    "St. Charles",
    "Portage",
    "Nassau",
    "Shelby",
    "Nassau",
    "Moore",
    "San Joaquin",
    "Nassau",
    "Sacramento",
    "Campbell",
    "Macomb",
    "San Luis Obispo",
    "St. Clair",
    "Grady",
    "Cabarrus",
    "Lake",
    "Bergen",
    "Fremont",
    "Union",
    "Bexar",
    "Cook",
    "Miami-Dade",
    "Alameda",
    "Prince George's",
    "Clark",
    "Boone",
    "Honolulu",
    "Hidalgo",
    "Prince George's",
    "Wasatch",
    "Orange",
    "Outagamie",
    "Los Angeles",
    "Suffolk",
    "Lake",
    "Albany",
    "Sacramento",
    "Montgomery",
    "Tarrant",
    "Cook",
    "Hopkins",
    "Glynn",
    "New Hanover",
    "Cuyahoga",
    "Uvalde",
    "Sarasota",
    "Yuma",
    "Sandusky",
    "Jefferson",
    "Cherokee",
    "Mohave",
    "Dodge",
    "Dyer",
    "Mendocino",
    "Stanly",
    "Shelby",
    "Kent",
    "Suffolk",
    "Nassau",
    "Contra Costa",
    "Middlesex",
    "Carroll",
    "Escambia",
    "Bergen",
    "Tazewell",
    "Santa Barbara",
    "Pierce",
    "Lake",
    "Orange",
    "Jefferson",
    "Suffolk",
    "Licking",
    "Davison",
    "Harris",
    "Seminole",
    "Ventura",
    "Mercer",
    "Okaloosa",
    "Cecil",
    "Wasco",
    "Harford",
    "Alamance",
    "Union",
    "Gila",
    "Richland",
    "Wayne",
    "Garland",
    "Dubois",
    "Cook",
    "Cook",
    "Honolulu",
    "Laurens",
    "Chatham",
    "Orange",
    "Oakland",
    "Montgomery",
    "Jefferson",
    "Erie",
    "Erie",
    "Washington",
    "Bannock",
    "Lake",
    "Toa Baja",
    "Marathon",
    "Monmouth",
    "Nassau",
    "Rockingham",
    "Beltrami",
    "Yuba",
    "Sumner",
    "Bergen",
    "Washington",
    "Clay",
    "Talladega",
    "Glynn",
    "Scotland",
    "Brown",
    "Allegheny",
    "Barton",
    "Cuyahoga",
    "Lehigh",
    "Cobb",
    "Campbell",
    "Berkeley",
    "Nassau",
    "Anne Arundel",
    "Warren",
    "Cuyahoga",
    "Jasper",
    "Adams",
    "Coahoma",
    "Sevier",
    "Kootenai",
    "Dickson",
    "Cape Girardeau",
    "Weber",
    "Loudoun",
    "Rutland",
    "Monterey",
    "San Diego",
    "Valencia",
    "Franklin",
    "Los Angeles",
    "Nassau",
    "Harrison",
    "Broward",
    "Fresno",
    "Vance",
    "Lassen",
    "Lee",
    "Sacramento",
    "Clinton",
    "Jefferson",
    "Miami-Dade",
    "Maricopa",
    "Erie",
    "Miami-Dade",
    "Cherokee",
    "Nassau",
    "Salt Lake",
    "Whiteside",
    "Columbia",
    "Fulton",
    "Adams",
    "Gregg",
    "Walworth",
    "Jefferson",
    "McLennan",
    "Jasper",
    "Bullitt",
    "Whatcom",
    "Pinellas",
    "Laclede",
    "Erie",
    "Somerset",
    "Martin",
    "Bay",
    "Deaf Smith",
    "Suffolk",
    "Pulaski",
    "St. Louis",
    "Whatcom",
    "Bergen",
    "Elko",
    "Okaloosa",
    "Yankton",
    "Macomb",
    "Merced",
    "Scotts Bluff",
    "Halifax",
    "Contra Costa",
    "Alcorn",
    "Grundy",
    "Santa Cruz",
    "Logan",
    "Fairfax",
    "Bee",
    "Pasco",
    "Lake",
    "Broome",
    "Starr",
    "Westmoreland",
    "Coos",
    "Hennepin",
    "Maricopa",
    "Middlesex",
    "Cook",
    "Hamilton",
    "Weld",
    "Galveston",
    "Bonneville",
    "Marion",
    "Santa Rosa",
    "Goodhue",
    "Orange",
    "Pinellas",
    "Prince George's",
    "Falls Church",
    "Los Angeles",
    "Montgomery",
    "St. Johns",
    "Rockland",
    "Tolland",
    "Henrico",
    "El Paso",
    "Lexington",
    "Tallapoosa",
    "Barren",
    "Morgan",
    "Marin",
    "Lake",
    "Cayey",
    "Cook",
    "Maricopa",
    "Prince William",
    "Shiawassee",
    "Dale",
    "Fairfax",
    "Warren",
    "Cooke",
    "Shelby",
    "Horry",
    "Elmore",
    "Cochise",
    "Cook",
    "Mobile",
    "Genesee",
    "Prince George's",
    "Christian",
    "Miami-Dade",
    "Jackson",
    "Kent",
    "Warren",
    "Elmore",
    "Santa Clara",
    "Cochise",
    "Gwinnett",
    "Baltimore",
    "Cumberland",
    "Fulton",
    "Grand Traverse",
    "Kosciusko",
    "Allen",
    "Benton",
    "Travis",
    "Montgomery",
    "Dallas",
    "Harris",
    "Fresno",
    "Randall",
    "New Castle",
    "Harrison",
    "Clayton",
    "Palo Pinto",
    "Pierce",
    "Arapahoe",
    "DeKalb",
    "Sumter",
    "Pima",
    "Kankakee",
    "Lake",
    "Stanislaus",
    "Orange",
    "St. Louis",
    "Marion",
    "Alamance",
    "Washoe",
    "Dauphin",
    "Nassau",
    "Kenosha",
    "Suffolk",
    "Milwaukee",
    "Greene",
    "Greenville",
    "Martin",
    "Miami-Dade",
    "Cullman",
    "Los Angeles",
    "St. Mary's",
    "Hillsborough",
    "Montgomery",
    "Jackson",
    "Lafourche",
    "DeKalb",
    "Placer",
    "Rockwall",
    "Montgomery",
    "Onslow",
    "Collin",
    "Lyon",
    "Stutsman",
    "Kern",
    "Roanoke",
    "Harnett",
    "Moore",
    "Escambia",
    "Suffolk",
    "York",
    "King",
    "Montgomery",
    "Greene",
    "Henrico",
    "Snohomish",
    "Dauphin",
    "Lake",
    "Kitsap",
    "Benton",
    "Fairfax",
    "Rockdale",
    "Henrico",
    "Middlesex",
    "Montgomery",
    "Chippewa",
    "Colbert",
    "Sussex",
    "Gloucester",
    "Fayette",
    "Horry",
    "St. Charles",
    "Allegheny",
    "Greenville",
    "Harris",
    "Fairfax",
    "Fulton",
    "Lee",
    "San Mateo",
    "Polk",
    "Madison",
    "Orange",
    "Bergen",
    "Gaston",
    "Loudoun",
    "Lafayette",
    "Monmouth",
    "Miami-Dade",
    "St. Clair",
    "Placer",
    "Douglas",
    "Los Angeles",
    "St. Francis",
    "Fairfax",
    "Franklin",
    "Tehama",
    "Camden",
    "Lake",
    "Moore",
    "Columbia",
    "Hidalgo",
    "Harford",
    "Leflore",
    "Otsego",
    "Luna",
    "Cook",
    "Nassau",
    "Pickaway",
    "Ventura",
    "Contra Costa",
    "Andrews",
    "Porter",
    "Pima",
    "Cook",
    "Cook",
    "Benton",
    "McMinn",
    "Monterey",
    "Hughes",
    "Rockwall",
    "Lyon",
    "Lake",
    "Polk",
    "Butler",
    "Suffolk",
    "Hamilton",
    "Union",
    "Kern",
    "DuPage",
    "Caldwell",
    "Bullitt",
    "Rockingham",
    "Lucas",
    "Polk",
    "Cattaraugus",
    "Newton",
    "St. Clair",
    "Nicollet",
    "St. Croix",
    "Manatee",
    "Mississippi",
    "Jefferson",
    "Wright",
    "Columbia",
    "Essex",
    "Logan",
    "Middlesex",
    "Harris",
    "Atlantic",
    "Middlesex",
    "New Castle",
    "Duval",
    "Honolulu",
    "Schuylkill",
    "Lancaster",
    "Warren",
    "Honolulu",
    "King",
    "Wayne",
    "King",
    "Martin",
    "Pierce",
    "Douglas",
    "Hancock",
    "Franklin",
    "Dutchess",
    "Lee",
    "Harrison",
    "Randolph",
    "Sarasota",
    "Mesa",
    "Hockley",
    "Doña Ana",
    "Honolulu",
    "Burlington",
    "Washington",
    "McLeod",
    "Dane",
    "Chesterfield",
    "Fulton",
    "Oakland",
    "Suffolk",
    "Fairfax",
    "DeSoto",
    "Chippewa",
    "Cuyahoga",
    "Miami-Dade",
    "King",
    "San Luis Obispo",
    "Santa Barbara",
    "Fairfax",
    "Beadle",
    "Logan",
    "Jackson",
    "Milwaukee",
    "Delaware",
    "St. Charles",
    "Los Angeles",
    "Washington",
    "Union",
    "Union",
    "Prince George's",
    "Lawrence",
    "Bryan",
    "Nassau",
    "DeKalb",
    "Crow Wing",
    "Cuyahoga",
    "Sullivan",
    "Berkshire",
    "Mercer",
    "King",
    "Butler",
    "East Baton Rouge",
    "Anne Arundel",
    "Cook",
    "Dane",
    "McPherson",
    "Los Alamos",
    "Cook",
    "Jefferson",
    "Dallas",
    "Montgomery",
    "Maui",
    "Sumner",
    "Saline",
    "Butler",
    "Ramsey",
    "Palm Beach",
    "Bergen",
    "Hardin",
    "Cuyahoga",
    "Butler",
    "Riverside",
    "Miami-Dade",
    "Los Angeles",
    "Portage",
    "Volusia",
    "Champaign",
    "Pierce",
    "Dane",
    "Mohave",
    "Kern",
    "Catawba",
    "Tarrant",
    "Bergen",
    "Ellis",
    "Palm Beach",
    "St. Mary's",
    "Fayette",
    "Nobles",
    "Worcester",
    "Seneca",
    "Chester",
    "Prince George's",
    "Hennepin",
    "DuPage",
    "Ottawa",
    "Oakland",
    "Dorado",
    "Boone",
    "San Miguel",
    "Routt",
    "Boulder",
    "Knox",
    "Sarasota",
    "Nelson",
    "Sangamon",
    "Honolulu",
    "Brown",
    "Mecklenburg",
    "Bergen",
    "Otter Tail",
    "Lake",
    "Nevada",
    "Calhoun",
    "Harford",
    "Tulare",
    "Luzerne",
    "Washington",
    "Tuscarawas",
    "Lee",
    "Gwinnett",
    "Seneca",
    "Pike",
    "Suffolk",
    "DeKalb",
    "Acadia",
    "Darke",
    "Johnston",
    "Lake",
    "Broome",
    "Yavapai",
    "Henrico",
    "Hamilton",
    "Suffolk",
    "Crawford",
    "St. Louis",
    "Pasco",
    "Camden",
    "Callaway",
    "Jefferson",
    "Martinsville",
    "Nassau",
    "Riverside",
    "Nassau",
    "York",
    "Ramsey",
    "Cook",
    "Lincoln",
    "Suffolk",
    "Macomb",
    "Jefferson",
    "Lafourche",
    "Eddy",
    "Honolulu",
    "Marion",
    "DeKalb",
    "Wayne",
    "Brown",
    "New Castle",
    "Honolulu",
    "Brevard",
    "Milwaukee",
    "Boone",
    "Baxter",
    "Ashtabula",
    "Cook",
    "LaSalle",
    "Marin",
    "Rapides",
    "Suffolk",
    "Sarasota",
    "Loudoun",
    "Chatham",
    "Travis",
    "St. Clair",
    "Westmoreland",
    "Colquitt",
    "Elk",
    "Cook",
    "Middlesex",
    "Seminole",
    "Oklahoma",
    "Cook",
    "San Mateo",
    "Spokane",
    "Marin",
    "St. Lucie",
    "Walton",
    "Cook",
    "Hutchinson",
    "Cobb",
    "Shelby",
    "Jefferson",
    "Cook",
    "Clay",
    "Madison",
    "Fairfax",
    "Yuba",
    "San Bernardino",
    "Crittenden",
    "Clinton",
    "Forsyth",
    "New Haven",
    "Henry",
    "Cuyahoga",
    "Daviess",
    "Grenada",
    "Hamilton",
    "Paulding",
    "Prince George's",
    "Adams",
    "Cherokee",
    "Ramsey",
    "Seminole",
    "Hamilton",
    "Collin",
    "Clackamas",
    "Cuyahoga",
    "Cook",
    "Will",
    "St. Clair",
    "Rusk",
    "Indiana",
    "Grafton",
    "Douglas",
    "Carter",
    "Shelby",
    "Galveston",
    "Weld",
    "Tulsa",
    "Putnam",
    "Snohomish",
    "Orange",
    "Montgomery",
    "Gwinnett",
    "Montgomery",
    "Walton",
    "Montgomery",
    "Kings",
    "Butler",
    "Westchester",
    "Williamson",
    "Campbell",
    "Charles",
    "King",
    "Broward",
    "Pasco",
    "Lackawanna",
    "Bay",
    "Baldwin",
    "Pinellas",
    "Orangeburg",
    "Montgomery",
    "Camden",
    "El Paso",
    "Anne Arundel",
    "San Diego",
    "San Bernardino",
    "Prince George's",
    "Pinal",
    "Beaufort",
    "Tarrant",
    "Bernalillo",
    "Henderson",
    "Loudoun",
    "Hamilton",
    "Beaufort",
    "Suffolk",
    "Fairbanks North Star",
    "Coryell",
    "Cherokee",
    "Fairfax",
    "Montgomery",
    "Lexington",
    "El Paso",
    "Hamilton",
    "Marin",
    "Iredell",
    "Los Angeles",
    "Ouachita",
    "Jefferson",
    "Kern",
    "St. Clair",
    "King",
    "Los Angeles",
    "Frederick",
    "Henderson",
    "Fort Bend",
    "Summit",
    "Frederick",
    "Ware",
    "Somerset",
    "Brown",
    "Mercer",
    "Suffolk",
    "Lake",
    "Albany",
    "San Diego",
    "Walker",
    "Tarrant",
    "Milwaukee",
    "Jefferson",
    "Kanawha",
    "Hamilton",
    "Fairfax",
    "Richland",
    "Dakota",
    "Franklin",
    "Effingham",
    "Canóvanas",
    "Miami-Dade",
    "Carver",
    "Gage",
    "Río Grande",
    "Howell",
    "Gaston",
    "Dorchester",
    "Utah",
    "Los Angeles",
    "Allegheny",
    "Volusia",
    "Robertson",
    "Woodward",
    "Cook",
    "Lake",
    "Lorain",
    "Yavapai",
    "Poquoson",
    "Pima",
    "Lafayette",
    "Baltimore",
    "Sauk",
    "Humboldt",
    "Brazoria",
    "Manatí",
    "Pierce",
    "Volusia",
    "Oakland",
    "Branch",
    "Fresno",
    "Kent",
    "Palm Beach",
    "Ada",
    "Carlton",
    "Pinal",
    "Morgan",
    "Summit",
    "Sweetwater",
    "Alamance",
    "Skagit",
    "Loudoun",
    "Wayne",
    "Jefferson",
    "Delta",
    "King",
    "New Hanover",
    "Suffolk",
    "Custer",
    "Jasper",
    "Madison",
    "Webster",
    "Sonoma",
    "Strafford",
    "Pasco",
    "Ouachita",
    "Warren",
    "Somerset",
    "Sarasota",
    "Nassau",
    "Merced",
    "Barbour",
    "Chautauqua",
    "Marshall",
    "Jefferson",
    "Summit",
    "Lake",
    "Hamilton",
    "Nicollet",
    "Santa Clara",
    "Fairfax",
    "Grant",
    "Monmouth",
    "Fresno",
    "Jerome",
    "Denton",
    "Vermilion",
    "Polk",
    "Santa Cruz",
    "Bingham",
    "Charleston",
    "Orange",
    "Collin",
    "Ocean",
    "Crawford",
    "Bergen",
    "Newton",
    "Reeves",
    "Miami-Dade",
    "Lincoln",
    "Passaic",
    "Hillsborough",
    "Calhoun",
    "Kern",
    "Franklin",
    "Martin",
    "Camden",
    "Cowley",
    "Roosevelt",
    "Wharton",
    "Ozaukee",
    "Alameda",
    "Kent",
    "Clay",
    "Columbiana",
    "Uinta",
    "Mahaska",
    "Brevard",
    "Prince George's",
    "Cache",
    "Washington",
    "Cuyahoga",
    "Morris",
    "Travis",
    "Luzerne",
    "Brazoria",
    "Merced",
    "Jackson",
    "Suffolk",
    "Polk",
    "Henrico",
    "San Mateo",
    "Contra Costa",
    "Nodaway",
    "Cuyahoga",
    "St. Charles",
    "Prince George's",
    "Clackamas",
    "Broward",
    "Anderson",
    "Lehigh",
    "Wichita",
    "Champaign",
    "Orange",
    "Clark",
    "Westchester",
    "Brazoria",
    "Guilford",
    "Columbia",
    "Taylor",
    "Dodge",
    "Augusta",
    "Bergen",
    "Bergen",
    "Miami",
    "Broome",
    "Honolulu",
    "Yavapai",
    "Galveston",
    "Lea",
    "Ozaukee",
    "Camden",
    "Yavapai",
    "Pasco",
    "Newport",
    "Ocean",
    "Essex",
    "Davis",
    "Hormigueros",
    "San Diego",
    "Loudoun",
    "Fairfax",
    "Los Angeles",
    "Livingston",
    "Frio",
    "Anne Arundel",
    "Texas",
    "Audrain",
    "Portage",
    "Douglas",
    "Beckham",
    "Bexar",
    "Suffolk",
    "Stanislaus",
    "Berkeley",
    "Taney",
    "San Bernardino",
    "Bergen",
    "Cook",
    "Starr",
    "Navajo",
    "Logan",
    "Lancaster",
    "Morgan",
    "Tooele",
    "Genesee",
    "Gillespie",
    "Delaware",
    "Arapahoe",
    "Decatur",
    "Sussex",
    "Providence",
    "Amherst",
    "Camden",
    "Hudson",
    "Clackamas",
    "Scurry",
    "Nueces",
    "Bergen",
    "Oswego",
    "Miami-Dade",
    "Westmoreland",
    "Berrien",
    "Hamilton",
    "Ionia",
    "Cook",
    "Hillsborough",
    "Miami-Dade",
    "Sherburne",
    "Hidalgo",
    "Sonoma",
    "Franklin",
    "Bergen",
    "Lincoln",
    "Grundy",
    "Kendall",
    "Coamo",
    "Osceola",
    "Wayne",
    "Utah",
    "Bedford",
    "Manitowoc",
    "Suffolk",
    "Bergen",
    "Hawaii",
    "Licking",
    "Dauphin",
    "Pearl River",
    "Passaic",
    "Monmouth",
    "Cleveland",
    "Lane",
    "Davis",
    "Lawrence",
    "Pima",
    "Franklin",
    "Lafourche",
    "Malheur",
    "El Dorado",
    "Allegheny",
    "Fort Bend",
    "Ascension",
    "Clackamas",
    "Cook",
    "Ouachita",
    "Wayne",
    "Clay",
    "York",
    "Tulare",
    "Brevard",
    "Clay",
    "Hot Spring",
    "Clay",
    "Fremont",
    "Coffee",
    "Prince George's",
    "Bexar",
    "Yazoo",
    "York",
    "Douglas",
    "Greenville",
    "Kern",
    "Decatur",
    "Coshocton",
    "Hawaii",
    "St. Joseph",
    "Cowlitz",
    "Suffolk",
    "Jefferson",
    "Fauquier",
    "Aransas",
    "Kitsap",
    "Westchester",
    "Los Angeles",
    "Rockland",
    "Madison",
    "Willacy",
    "Cache",
    "Columbia",
    "Jefferson",
    "Jackson",
    "Pinal",
    "Edgecombe",
    "Beauregard",
    "Talladega",
    "Cape May",
    "Polk",
    "Marion",
    "Westchester",
    "St. Mary",
    "Waukesha",
    "Brevard",
    "Passaic",
    "Racine",
    "Lexington",
    "Jefferson",
    "Okmulgee",
    "Milwaukee",
    "Pierce",
    "Los Angeles",
    "Miami-Dade",
    "Riverside",
    "Miami-Dade",
    "Leavenworth",
    "Cowley",
    "Mercer",
    "Nassau",
    "Morris",
    "St. Louis",
    "Sacramento",
    "Hamilton",
    "Ozaukee",
    "Pierce",
    "Pima",
    "Harris",
    "Montgomery",
    "Albany",
    "Washington",
    "McLennan",
    "St. Louis",
    "Baltimore",
    "Shelby",
    "Marion",
    "Prince George's",
    "Pulaski",
    "Allegheny",
    "Cumberland",
    "Cumberland",
    "Montgomery",
    "Adams",
    "Riverside",
    "Warren",
    "Pasco",
    "Hamilton",
    "Hillsborough",
    "Suffolk",
    "San Juan",
    "Santa Barbara",
    "Ottawa",
    "Coffee",
    "Dakota",
    "Washington",
    "Monmouth",
    "Chesterfield",
    "Suffolk",
    "DeKalb",
    "Prince George's",
    "Hamilton",
    "Los Angeles",
    "Somerset",
    "Butte",
    "Horry",
    "Snohomish",
    "Prince George's",
    "Hamilton",
    "Fort Bend",
    "Jefferson",
    "Sedgwick",
    "Yakima",
    "Kane",
    "Orange",
    "Lawrence",
    "Harris",
    "Johnson",
    "Alameda",
    "Trousdale",
    "Bolivar",
    "Baltimore",
    "Delaware",
    "Orange",
    "Schenectady",
    "Passaic",
    "Prince George's",
    "Randolph",
    "Hinds",
    "El Dorado",
    "Orange",
    "Calumet",
    "King",
    "Polk",
    "Outagamie",
    "Cuyahoga",
    "Alameda",
    "Hamilton",
    "St. Louis",
    "Montgomery",
    "Washington",
    "Somerset",
    "Harris",
    "Polk",
    "Anoka",
    "New Castle",
    "Union",
    "Itasca",
    "McLennan",
    "Maui",
    "Independence",
    "Lawrence",
    "Atascosa",
    "Muskegon",
    "Bergen",
    "Chittenden",
    "Cook",
    "Delaware",
    "DuPage",
    "Washoe",
    "Honolulu",
    "Bexar",
    "Monroe",
    "Jefferson",
    "Manatee",
    "Columbiana",
    "Steuben",
    "Delaware",
    "Green",
    "Winnebago",
    "Isabela",
    "Kent",
    "Orange",
    "Baltimore",
    "Cuyahoga",
    "Utah",
    "Ramsey",
    "Lee",
    "Matanuska-Susitna",
    "Marinette",
    "Suffolk",
    "Delaware",
    "Indian River",
    "Cassia",
    "Matanuska-Susitna",
    "Yavapai",
    "Polk",
    "Atchison",
    "Lane",
    "Nolan",
    "Van Wert",
    "Crisp",
    "Clay",
    "Dane",
    "Prince William",
    "Teton",
    "Oakland",
    "Wells",
    "Clermont",
    "Wayne",
    "Shasta",
    "San Luis Obispo",
    "Pierce",
    "Cuyahoga",
    "Wexford",
    "Lorain",
    "Mecosta",
    "Clay",
    "Obion",
    "Lancaster",
    "Mason",
    "Morris",
    "Buena Vista",
    "Lane",
    "Highlands",
    "Brevard",
    "Chautauqua",
    "Marion",
    "St. Tammany",
    "Putnam",
    "Columbia",
    "Cook",
    "Mercer",
    "Cook",
    "Fluvanna",
    "San Bernardino",
    "Uintah",
    "Monroe",
    "Hendricks",
    "Contra Costa",
    "Calcasieu",
    "Forrest",
    "Toombs",
    "Crook",
    "Bergen",
    "Guernsey",
    "Putnam",
    "Tulare",
    "Weakley",
    "St. Lawrence",
    "Los Angeles",
    "King",
    "Harris",
    "Lee",
    "Cook",
    "Jefferson",
    "King",
    "Fannin",
    "Clay",
    "Sarasota",
    "Jefferson",
    "Somerset",
    "Hamilton",
    "Madison",
    "Marion",
    "Kern",
    "Surry",
    "Newberry",
    "Effingham",
    "Utah",
    "Plaquemines",
    "Pierce",
    "Wood",
    "Morris",
    "Santa Rosa",
    "Bastrop",
    "Sabana Grande",
    "Somerset",
    "Madison",
    "Burlington",
    "Lee",
    "Shasta",
    "Harford",
    "Morris",
    "Palm Beach",
    "Denton",
    "La Crosse",
    "Santa Cruz",
    "Spartanburg",
    "Bremer",
    "Kern",
    "Franklin",
    "Pitt",
    "Monroe",
    "Monroe",
    "Haywood",
    "Atlantic",
    "Kern",
    "Fresno",
    "Polk",
    "Howard",
    "Suffolk",
    "Anne Arundel",
    "Wilbarger",
    "San Joaquin",
    "Albany",
    "Loudoun",
    "Anderson",
    "Miami",
    "Madera",
    "Coos",
    "Frederick",
    "Los Angeles",
    "Snohomish",
    "Polk",
    "Cook",
    "Kanawha",
    "Dawson",
    "Douglas",
    "Walworth",
    "Wayne",
    "Prince George's",
    "Los Angeles",
    "Lexington",
    "Madison",
    "Charlotte",
    "Crawford",
    "Bergen",
    "Atlantic",
    "Marshall",
    "Alpena",
    "Henry",
    "Mahoning",
    "Minnehaha",
    "Cass",
    "Wabash",
    "Greenville",
    "DeKalb",
    "Honolulu",
    "Columbia",
    "Shelby",
    "Los Angeles",
    "Kauai",
    "Sarpy",
    "Rio Arriba",
    "Plymouth",
    "Westchester",
    "Martin",
    "Polk",
    "Polk",
    "Garfield",
    "Sandoval",
    "Dunklin",
    "Burlington",
    "Morehouse",
    "Collin",
    "Lake",
    "Clatsop",
    "Marin",
    "St. Johns",
    "Fauquier",
    "Gloucester",
    "New London",
    "Whatcom",
    "Baker",
    "Nassau",
    "Hillsborough",
    "Northampton",
    "Douglas",
    "Ada",
    "Livingston",
    "Albany",
    "Berrien",
    "Graves",
    "Jefferson Davis",
    "Clark",
    "Mercer",
    "Fairfield",
    "Orange",
    "LaSalle",
    "St. Landry",
    "Johnson",
    "Jefferson",
    "Livingston",
    "DuPage",
    "Garfield",
    "Horry",
    "Franklin",
    "Miami-Dade",
    "Hamilton",
    "Bucks",
    "Charles",
    "Suffolk",
    "Honolulu",
    "Monongalia",
    "Shelby",
    "Grant",
    "Sauk",
    "Nassau",
    "Park",
    "Santa Cruz",
    "Bergen",
    "Campbell",
    "Etowah",
    "Toa Alta",
    "Hempstead",
    "Monroe",
    "Bourbon",
    "Venango",
    "Monroe",
    "Coos",
    "Milwaukee",
    "Hartford",
    "Washington",
    "Cape May",
    "Morgan",
    "Loudoun",
    "Boone",
    "East Baton Rouge",
    "Auglaize",
    "Calvert",
    "Carroll",
    "San Bernardino",
    "Pinellas",
    "Christian",
    "Bexar",
    "Hamilton",
    "Kane",
    "Hill",
    "Monmouth",
    "Adams",
    "Linn",
    "Santa Cruz",
    "Jefferson",
    "St. Clair",
    "Vega Alta",
    "Graham",
    "Cabo Rojo",
    "Pinellas",
    "Harnett",
    "San Diego",
    "Fayette",
    "Jackson",
    "Pasco",
    "Snohomish",
    "Boone",
    "Lincoln",
    "Bergen",
    "Kanawha",
    "Monroe",
    "Pierce",
    "Essex",
    "Navajo",
    "Barnstable",
    "Luzerne",
    "Fairfax",
    "Camden",
    "Oakland",
    "Chisago",
    "St. Louis",
    "Hillsborough",
    "Gloucester",
    "Phillips",
    "Camden",
    "McClain",
    "Boulder",
    "Chattahoochee",
    "Fairfax",
    "DeKalb",
    "Los Angeles",
    "Alachua",
    "Lake",
    "Dane",
    "Suffolk",
    "Berks",
    "Pinal",
    "Utah",
    "Oklahoma",
    "Washington",
    "Calhoun",
    "Ramsey",
    "Franklin",
    "Spokane",
    "Morris",
    "Richland",
    "Jefferson",
    "Wayne",
    "San Bernardino",
    "Citrus",
    "Montgomery",
    "Anne Arundel",
    "San Patricio",
    "Loudoun",
    "Orange",
    "St. Louis",
    "Morris",
    "Orange",
    "Montgomery",
    "Marshall",
    "Harnett",
    "Blount",
    "Prince George's",
    "Miami-Dade",
    "Clark",
    "Weld",
    "Orange",
    "Labette",
    "Dutchess",
    "Prince William",
    "Onondaga",
    "Lake",
    "Westchester",
    "Middlesex",
    "Contra Costa",
    "Catoosa",
    "Delaware",
    "Jefferson",
    "St. Louis",
    "Liberty",
    "Los Angeles",
    "Johnson",
    "San Bernardino",
    "Cook",
    "Prince George's",
    "Pierce",
    "Snohomish",
    "Madison",
    "Lake",
    "Nassau",
    "Beaufort",
    "Wagoner",
    "Citrus",
    "Miami-Dade",
    "Orange",
    "Washington",
    "Pennington",
    "Pierce",
    "Los Angeles",
    "Hood",
    "Fairfax",
    "Jefferson",
    "St. Louis",
    "Litchfield",
    "Carver",
    "Somerset",
    "Weber",
    "Mercer",
    "Rockland",
    "Onondaga",
    "Nassau",
    "Fairfax",
    "Clark",
    "Hennepin",
    "Alamosa",
    "Suffolk",
    "Morris",
    "Haywood",
    "Jefferson",
    "Warren",
    "Carroll",
    "Oklahoma",
    "Tipton",
    "Hunt",
    "Suffolk",
    "Benton",
    "Northumberland",
    "Wayne",
    "Sullivan",
    "Drew",
    "Centre",
    "Butler",
    "Dauphin",
    "Prince George's",
    "Lancaster",
    "Berkeley",
    "Sunflower",
    "Morris",
    "Eagle",
    "Clark",
    "Jackson",
    "Chambers",
    "Rankin",
    "Woodford",
    "DeKalb",
    "Wayne",
    "Hamilton",
    "Monroe",
    "Harford",
    "St. Croix",
    "Glynn",
    "Cook",
    "Pima",
    "DuPage",
    "Marin",
    "Montgomery",
    "New Castle",
    "Becker",
    "Terry",
    "Washtenaw",
    "Riverside",
    "Montgomery",
    "Cook",
    "Sussex",
    "Stark",
    "Loudoun",
    "Cook",
    "McHenry",
    "Weber",
    "Westmoreland",
    "Grady",
    "Jefferson",
    "Warren",
    "Allegheny",
    "Tooele",
    "Dallas",
    "Dawson",
    "San Joaquin",
    "Waukesha",
    "Morris",
    "Medina",
    "Multnomah",
    "Gallatin",
    "Georgetown",
    "Bell",
    "Baldwin",
    "Solano",
    "Kalamazoo",
    "Citrus",
    "Clackamas",
    "Maverick",
    "Cumberland",
    "Noble",
    "Montgomery",
    "Suffolk",
    "Sebastian",
    "Rensselaer",
    "Kern",
    "Mayes",
    "Richland",
    "Williamson",
    "Kershaw",
    "Wayne",
    "Doña Ana",
    "Matanuska-Susitna",
    "Franklin",
    "Hidalgo",
    "Prince George's",
    "Prince George's",
    "Fairfield",
    "East Baton Rouge",
    "Maui",
    "Monroe",
    "LaSalle",
    "Eaton",
    "Aroostook",
    "Ogle",
    "Coconino",
    "Corozal",
    "McLennan",
    "Custer",
    "Skagit",
    "Whitley",
    "Bastrop",
    "Williamson",
    "Clinton",
    "Clinton",
    "Isanti",
    "Lincoln",
    "El Paso",
    "Livingston",
    "Kendall",
    "Cumberland",
    "Weber",
    "Franklin",
    "Washington",
    "Granville",
    "Kauai",
    "Penobscot",
    "Atlantic",
    "Brevard",
    "Fairfield",
    "Peach",
    "Delta",
    "York",
    "Yolo",
    "Moffat",
    "Tulare",
    "DeSoto",
    "Anne Arundel",
    "Waseca",
    "Prince George's",
    "Warren",
    "Poweshiek",
    "Chatham",
    "Sonoma",
    "Walton",
    "Middlesex",
    "Lane",
    "Wagoner",
    "Cook",
    "Gratiot",
    "Simpson",
    "Cibola",
    "Oldham",
    "Yakima",
    "DuPage",
    "Colbert",
    "Middlesex",
    "Richland",
    "Tulare",
    "Whiteside",
    "Beaver",
    "Ocean",
    "Shawano",
    "Barry",
    "Neosho",
    "Dane",
    "Nassau",
    "Tipton",
    "Nassau",
    "Mecklenburg",
    "Weber",
    "Box Elder",
    "Hardin",
    "Jackson",
    "Champaign",
    "Georgetown",
    "Laurens",
    "Washington",
    "Cook",
    "Mesa",
    "New Hanover",
    "Washington",
    "Cuyahoga",
    "Will",
    "Bucks",
    "Wayne",
    "Montgomery",
    "Bergen",
    "Bergen",
    "Yakima",
    "Denton",
    "Stanislaus",
    "Chatham",
    "Collin",
    "Lorain",
    "St. Louis",
    "Door",
    "Lancaster",
    "Lowndes",
    "Pulaski",
    "Kenton",
    "Monroe",
    "Gloucester",
    "Morris",
    "Ben Hill",
    "Clay",
    "Allegheny",
    "Cook",
    "Pennington",
    "Henry",
    "Upson",
    "Morris",
    "Fairfax",
    "Allegheny",
    "Mason",
    "Delaware",
    "Montezuma",
    "Warren",
    "Henry",
    "Union",
    "Atlantic",
    "Riley",
    "Lake",
    "Sitka",
    "Juncos",
    "Palm Beach",
    "Bergen",
    "Rockland",
    "Warren",
    "Bucks",
    "San Juan",
    "Sheboygan",
    "Orange",
    "Edgar",
    "Richmond",
    "Bexar",
    "St. Louis",
    "Kootenai",
    "Weld",
    "Gibson",
    "Allegany",
    "Grays Harbor",
    "Palm Beach",
    "Hamilton",
    "Washington",
    "Cass",
    "Delaware",
    "Suffolk",
    "Georgetown",
    "Bergen",
    "Morrison",
    "Camden",
    "Blaine",
    "Ochiltree",
    "Merrimack",
    "Pennington",
    "Utah",
    "Hartford",
    "St. Louis",
    "Smith",
    "Prentiss",
    "Young",
    "Churchill",
    "Polk",
    "Carbon",
    "Kane",
    "Larimer",
    "Montgomery",
    "Clark",
    "Montgomery",
    "Bonner",
    "Arkansas",
    "Sequoyah",
    "Denton",
    "Nassau",
    "Monmouth",
    "Liberty",
    "DuPage",
    "Wharton",
    "Providence",
    "Bergen",
    "Bucks",
    "Lapeer",
    "Steuben",
    "Sandoval",
    "New Hanover",
    "Lake",
    "Baltimore",
    "Kankakee",
    "Hamilton",
    "Marshall",
    "Orange",
    "Orange",
    "Harrison",
    "Saline",
    "Bergen",
    "Brevard",
    "Prince William",
    "Perry",
    "Bexar",
    "Hartford",
    "Clackamas",
    "Catawba",
    "Liberty",
    "Baldwin",
    "Trumbull",
    "Isle of Wight",
    "Pima",
    "Butler",
    "Douglas",
    "Walla Walla",
    "Rockwall",
    "Lincoln",
    "Erie",
    "Hennepin",
    "Albemarle",
    "Kenton",
    "Citrus",
    "Escambia",
    "Carteret",
    "Hamilton",
    "St. Francois",
    "Knox",
    "Sampson",
    "Baltimore",
    "Seminole",
    "Covington",
    "Lafayette",
    "Pierce",
    "Nassau",
    "St. John the Baptist",
    "Chatham",
    "Montgomery",
    "Adams",
    "Vernon",
    "St. Louis",
    "Baltimore",
    "Lafayette",
    "Beaufort",
    "Anoka",
    "Cobb",
    "Augusta",
    "Delaware",
    "Honolulu",
    "Montgomery",
    "Mercer",
    "Santa Clara",
    "Montgomery",
    "Rockland",
    "Genesee",
    "Jefferson",
    "Rockland",
    "Fairfax",
    "Washington",
    "Brown",
    "Anderson",
    "Camden",
    "Lancaster",
    "Montgomery",
    "Boone",
    "Hamilton",
    "Madison",
    "Bucks",
    "Prince George's",
    "El Paso",
    "Champaign",
    "Chilton",
    "Travis",
    "Gloucester",
    "Montgomery",
    "Lewis and Clark",
    "Nueces",
    "Union",
    "Spokane",
    "Lake",
    "Larimer",
    "Putnam",
    "Jefferson",
    "Loudon",
    "Catawba",
    "Henrico",
    "Providence",
    "Westchester",
    "Le Flore",
    "Greenville",
    "Bullitt",
    "Thurston",
    "Washoe",
    "Fairfax",
    "Suffolk",
    "Bay",
    "Albemarle",
    "Citrus",
    "DeKalb",
    "Pierce"
];




